import { docsKy } from "./docs";
import { auditKy } from "./audit/ky";
import type { Dictionary } from "./ru";

export const ky: Dictionary = {
  reportReset: {
    "deleteArchive": "Архивди өчүрүү",
    "deleteArchiveTitle": "Тазалоонун архивин өчүрөсүзбү?",
    "deleteArchiveText": "{{period}} мезгилинин отчёттору архивден биротоло өчүрүлөт — аларды кайра жүктөп алуу мүмкүн болбойт. Тазалоо, анын күнү жана тарыхтагы жазуу калат, заказдар жана төлөмдөр өчүрүлбөйт.",
    "deleteArchiveSave": "Архив дагы керек болсо — өчүрүүдөн мурун жүктөп алыңыз:",
    "deleteArchiveConfirm": "Архивди биротоло өчүрөсүзбү?",
    "deleteArchiveConfirmText": "Архивди өчүрүүнү жокко чыгарууга болбойт.",
    "archiveDeleted": "Архив өчүрүлдү",
    "title": "Отчётторду тазалоо",
    "description": "Эсепти таза барактан баштоо: отчёттордогу түшүм жана акча — тандалган күндөн. Эч нерсе өчүрүлбөйт, мурунку отчёттор архивге сакталат.",
    "currentFrom": "Отчёттор {{date}} күнүнөн эсептелет",
    "currentAll": "Отчёттор иштин башынан эсептелет",
    "currentHint": "Заказдар, төлөмдөр, сменалар жана документтер өчүрүлбөйт. Мурунку отчёттор архивде — аны Excel же PDF түрүндө жүктөп алса болот.",
    "start": "Отчётторду тазалоо",
    "history": "Тазалоолордун тарыхы",
    "historyEmpty": "Азырынча тазалоо болгон эмес",
    "colFrom": "Отчёттор ушул күндөн",
    "colArchive": "Архивдин мезгили",
   
    "colBy": "Ким жана качан",
   
    "statusActive": "Күчүндө",
    "statusCancelled": "Жокко чыгарылды",
    "archiveNone": "Маалымат жок",
    "cancel": "Тазалоону жокко чыгаруу",
    "cancelTitle": "Отчётторду тазалоону жокко чыгарасызбы?",
    "cancelText": "Отчёттор кайра {{since}} эсептелет. Бул тазалоонун архиви тарыхта калат.",
    "sinceDate": "{{date}} күнүнөн",
    "sinceStart": "иштин башынан",
    "cancelled": "Тазалоо жокко чыгарылды — отчёттор кайра мурунку маалыматты көрсөтөт",
    "stepWhat": "Эмне болот",
    "stepArchive": "Архив",
    "stepConfirm": "Ырастоо",
    "stepOf": "{{n}}-кадам, 3 кадамдан · {{name}}",
    "date": "Отчётторду кайсы күндөн кайра эсептөө керек",
    "dateHint": "Адатта — бүгүн же айдын биринчи күнү. Ошол күндүн сатуулары жаңы отчёттордо калат.",
    "resets": "Нөлдөн башталат",
    "resetRevenue": "Отчёттордогу түшүм, төлөмдөр, кайтаруулар, орточо чек",
    "resetFinance": "Финансы: отчёттордогу пайда, чыгымдар, сатып алуулар, эсептен чыгаруулар, эмгек акы фонду",
    "resetOther": "Тамактардын сатылышы, азыктар, официанттар, акциялар, кызматтар жана кеңейтилген отчёттор",
    "keeps": "Өзгөрбөйт",
    "keepMenu": "Меню, техкарталар, баалар, стоп-лист",
    "keepStock": "Кампа жана азыктардын калдыктары",
    "keepDebts": "Кардарлар жана алардын карыздары, жеткирүүчүлөргө карыздар",
    "keepStaff": "Кызматкерлер, сменалар, эмгек акы",
    "keepJournal": "Журналдардагы заказдар, төлөмдөр, касса сменалары жана документтер — мурункудай",
    "archivePeriod": "Архивге {{from}} — {{to}} мезгилинин отчёттору кирет",
    "archiveEmpty": "Бул күнгө чейин отчёттор жок — архив бош болот.",
    "archiveLimit": "Архив — бир жылдан ашпайт жана тариф боюнча отчёттордун тарыхынан тереңирээк эмес. Маалыматтын өзү базада калат.",
    "archiveText": "Мурунку мезгилдин отчётторун жүктөп алып, өзүңүздө сактаңыз. Кийин архивди тазалоолордун тарыхынан кайра жүктөп алса болот.",
    "archiveSaved": "Архивди сактадым же ал мага керек эмес",
    "archiveTitle": "Отчёттордун архиви",
    "branch": "Филиал",
    "revenue": "Түшүм",
    "orders": "Заказдар",
    "confirmText": "Ырастоо үчүн {{word}} деген сөздү киргизиңиз.",
    "confirmWord": "ТАЗАЛОО",
    "password": "Сиздин сырсөзүңүз",
    "comment": "Комментарий",
    "commentPlaceholder": "Мисалы: окутуудан кийин иштин башталышы",
    "next": "Кийинки",
    "back": "Артка",
    "submit": "Отчётторду тазалоо",
    "finalTitle": "Отчётторду тазалайсызбы?",
    "finalText": "Бардык кызматкерлердин бардык отчёттору {{date}} күнүнөн башталат. Маалымат өчүрүлбөйт, тазалоону тарыхта жокко чыгарса болот.",
    "done": "Отчёттор тазаланды — эсеп {{date}} күнүнөн",
    "banner": "Отчёттор {{date}} күнүнөн эсептелет — мурунку маалымат тазалоонун архивинде.",
    "bannerLink": "Отчётторду тазалоо",
  },
  nav: {
    "reportReset": "Отчётторду тазалоо",
    "menuPacks": "Даяр менюлар",
    "help": "Маалымдама",
    "stockRequests": "Кампага арыздар",
    "purchaseRequests": "Сатып алууга арыздар",
    "conversions": "Бөлүү жана чогултуу",
    "warehouses": "Кампалар",
    "transfers": "Которуулар",
    "expiry": "Жарактуулук мөөнөтү",
    "production": "Өндүрүш",
    site: "Сайт жана QR-меню",
    employees: "Кадрлар",
    positions: "Кызмат орундары",
    workShifts: "Жумуш сменалары",
    payroll: "Эмгек акы",
    tips: "Чайпул",
    myWork: "Менин кабинетим",
    audit: "Аудит журналы",
    customers: "Кардарлар",
    debts: "Карыздар",
    insights: "Кафе аналитикасы", expenses: "Чыгымдар", suppliers: "Жеткирүүчүлөр", supplierReturns: "Жеткирүүчүлөргө кайтаруу", purchases: "Сатып алуулар", writeoffs: "Эсептен чыгаруу",
    analytics: "Аналитика", dashboard: "Башкы панель", reports: "Отчеттор",
    sales: "Сатуулар", pos: "Касса (POS)", posShort: "POS", orders: "Заказдар", kitchen: "Ашкана",
    venue: "Мекеме", branches: "Филиалдар", tables: "Залдар жана столдор",
    shifts: "Сменалар жана брондор", cashShifts: "Касса сменалары", reservations: "Брондоо",
    catalog: "Меню жана кампа", menu: "Меню", products: "Азыктар", costing: "Калькуляция", inventory: "Кампа", inventoryCounts: "Инвентаризация", notifications: "Билдирмелер", security: "Коопсуздук",
    staff: "Персонал", users: "Кызматкерлер", roles: "Ролдор жана укуктар",
    settings: "Жөндөөлөр", company: "Компания", devices: "Терминалдар", subscription: "Жазылуу", support: "Колдоо", fraud: "Кыянаттыктан коргоо", sms: "SMS-жөнөтүүлөр", services: "Кызматтар жана ижара", banquets: "Банкеттер", promotions: "Акциялар", deliveries: "Жеткирүү", courier: "Менин жеткирүүлөрүм", goals: "Максаттар жана жетишкендиктер", myGoals: "Менин максаттарым", waiterZones: "Залдар боюнча официанттар",
    kitchenStations: "Ашкана станциялары", more: "Дагы",
  },
  common: {
    close: "Жабуу",
    save: "Сактоо", cancel: "Жокко чыгаруу", create: "Түзүү", edit: "Өзгөртүү", delete: "Өчүрүү", retry: "Кайталоо", add: "Кошуу",
    done: "Даяр", saved: "Өзгөртүүлөр сакталды", search: "Издөө…", logout: "Чыгуу", logoutTitle: "Аккаунттан чыгасызбы?", logoutHint: "Иштөөнү улантуу үчүн кайра кирүү керек болот.", profile: "Профиль", branch: "Филиал", allBranches: "Бардык филиалдар",
    active: "Активдүү", inactive: "Өчүрүлгөн", blocked: "Бөгөттөлгөн", soon: "Жакында",
    locked: "Тарифте жок", upgrade: "Кошуу", theme: "Тема", language: "Тил",
    name: "Аталышы", description: "Сүрөттөмө", phone: "Телефон", status: "Абалы", price: "Баасы", actions: "Аракеттер",
    all: "Баары", no: "Жок", more: "Кененирээк", filter: "Чыпка", moveUp: "Жогору", moveDown: "Төмөн", hasErrors: "Каталар бар",
    nothingFound: "Эч нерсе табылган жок", nothingFoundHint: "Сурамды өзгөртүп көрүңүз", resetSearch: "Издөөнү тазалоо", resetFilters: "Чыпкаларды тазалоо",
    deleteNamed: "«{{name}}» өчүрүлсүнбү?",
  },
  ui: {
    ok: "Түшүнүктүү", confirm: "Ырастоо", actionFailed: "Аракетти аткаруу мүмкүн болгон жок",
    typeToConfirmBefore: "Ырастоо үчүн", typeToConfirmAfter: "деп жазыңыз", dialog: "Диалог", close: "Жабуу", clear: "Тазалоо",
    showPassword: "Сырсөздү көрсөтүү", hidePassword: "Сырсөздү жашыруу", select: "Тандаңыз…", loadError: "Жүктөөдө ката. Кайра аракет кылыңыз.",
    create: "«{{q}}» түзүү", increase: "Көбөйтүү", decrease: "Азайтуу", loading: "Жүктөлүүдө", pages: "Барактар",
    pageRange: "{{total}} ичинен {{from}}–{{to}}", prevPage: "Мурунку барак", nextPage: "Кийинки барак",
    selectAll: "Баарын тандоо", selectRow: "Тандоо", selectedCount: "Тандалды: {{count}}", clearSelection: "Тандоону алып салуу",
    grams: "г", kilograms: "кг", weight: "Салмагы", perKg: "1 кг үчүн",
  },
  currencySymbols: { KGS: "сом", KZT: "₸", UZS: "сум", RUB: "₽", TJS: "сомони" },
  errors: {
    IMPERSONATION_READ_ONLY: "Колдоо сеансы окуу үчүн гана",
    INVOICE_PAID: "Эсеп төлөнгөн — өзгөртүүгө болбойт",
    DOWNGRADE_BLOCKED: "Колдонуу жаңы тарифтин лимиттеринен ашат",
    ADDON_UNAVAILABLE: "Кошумча бул тарифте жеткиликсиз",
    MENU_PACK_NOT_PURCHASED: "Даяр меню али төлөнө элек — эсеп төлөнгөндөн кийин жүктөсөңүз болот",
    TWO_FACTOR_INVALID: "Ырастоо коду туура эмес",
    CLOCK_IN_NOT_ALLOWED: "Сменаны белгилөө жеткиликсиз",
    WORK_SHIFT_OPEN: "Кызматкердин сменасы ачык",
    PAYROLL_APPROVED: "Ведомость бекитилген — өзгөртүүгө болбойт",
    CREDIT_LIMIT_EXCEEDED: "Кардардын кредиттик лимити ашып кетти",
    DEPOSIT_REQUIRED: "Банкет депозит киргизилгенден кийин тастыкталат",
    DELIVERY_ADDRESS_OUT_OF_ZONE: "Дарек жеткирүү зоналарынан тышкары",
    CUSTOMER_DEBT_OVERDUE: "Кардардын мөөнөтү өткөн карызы бар — жаңы кредит берилбейт",
    CUSTOMER_BLOCKED: "Кардар бөгөттөлгөн",
    CUSTOMER_PHONE_TAKEN: "Бул телефон менен кардар бар",
    CASH_SHIFT_NOT_OPEN: "Касса сменасы ачылган эмес",
    CASH_INSUFFICIENT: "Кассада накталай акча жетишсиз",
    INSUFFICIENT_STOCK: "Кампада калдык жетишсиз",
    APPROVAL_REQUIRED: "Менеджердин ырастоосу керек",
    APPROVAL_INVALID: "Ырастоо бул аракетке туура келбейт же мөөнөтү өттү",
    APPROVAL_USED: "Ырастоо мурунтан колдонулган",
    DISCOUNT_INVALID: "Арзандатуу уруксат берилген позициялардын суммасынан ашат",
    BRANCH_INACTIVE: "Филиал өчүрүлгөн — анда өзгөртүүгө болбойт",
    DOCUMENT_POSTED: "Өткөрүлгөн документти өзгөртүүгө же өчүрүүгө болбойт",
    INVENTORY_COUNT_CLOSED: "Инвентаризация мурунтан өткөрүлгөн же жокко чыгарылган",
    PAYMENT_AMOUNT_INVALID: "Накталай эмес төлөм калган суммадан көп",
    CUSTOMER_REQUIRED: "Карызга төлөө үчүн кардарды тандаңыз",
    MODIFIERS_INVALID: "Модификаторлордун тандоосун текшериңиз", TABLE_UNAVAILABLE: "Стол жеткиликсиз", ITEM_ALREADY_SENT: "Позиция ашканага жөнөтүлгөн — өзгөртүүгө болбойт, жокко гана чыгарса болот", ORDER_CLOSED: "Заказ жабылган", ORDER_HAS_PAYMENTS: "Заказ боюнча төлөмдөр бар — жокко чыгаруу кайтаруу аркылуу гана", NOTHING_TO_SEND: "Ашканага жөнөтүү үчүн жаңы позиция жок",
    NETWORK_ERROR: "Сервер менен байланыш жок. Интернетти текшериңиз", requestFailed: "Сурамда ката", unknown: "Бир нерсе туура эмес болду. Кайра аракет кылыңыз",
    code: "код: {{id}}…", actionFailed: "Аракетти аткаруу мүмкүн болгон жок",
    limitTitle: "Тарифтин чегине жеттиңиз", limitHint: "Чек: {{max}}. Тарифти көбөйтүңүз же «Жазылуу» бөлүмүнөн пакет кошуңуз.",
    planHint: "Тарифти узартуу же кеңейтүү үчүн «Жөндөөлөр → Жазылуу» бөлүмүн ачыңыз.",
    conflictTitle: "Маалыматты башка колдонуучу өзгөрттү", conflictHint: "Акыркы версиясын жүктөдүк — текшерип, өзгөртүүнү кайталаңыз.",
    VALIDATION_ERROR: "Талаалардын туура толтурулушун текшериңиз", UNAUTHENTICATED: "Системага кирүү талап кылынат", TOKEN_EXPIRED: "Сессия бүттү",
    REFRESH_TOKEN_REUSED: "Коопсуздук үчүн сессия токтотулду. Кайра кириңиз",
    DEVICE_REQUIRED: "PIN менен кирүү катталган терминалда гана жеткиликтүү", DEVICE_REVOKED: "Терминал администратор тарабынан өчүрүлгөн",
    INVALID_CREDENTIALS: "Логин же сырсөз туура эмес", FEATURE_NOT_IN_PLAN: "Бул функция тарифиңизде жок", PLAN_LIMIT_REACHED: "Тарифтин чегине жеттиңиз",
    SUBSCRIPTION_READ_ONLY: "Жазылуу окуу гана режиминде", SUBSCRIPTION_SUSPENDED: "Жазылуу токтотулган", PERMISSION_DENIED: "Укук жетишсиз",
    BRANCH_ACCESS_DENIED: "Филиалга кирүү укугу жок", NOT_FOUND: "Табылган жок", VERSION_CONFLICT: "Маалымат өзгөрдү. Баракты жаңылаңыз",
    DUPLICATE: "Мындай жазуу мурунтан бар", SLUG_TAKEN: "Бул дарек бош эмес", ENTITY_IN_USE: "Жазуу колдонулууда, аны өчүрүүгө болбойт",
    ACCOUNT_LOCKED: "Аккаунт убактылуу бөгөттөлдү", PIN_LOCKED: "PIN менен кирүү убактылуу бөгөттөлдү",
    RATE_LIMITED: "Аракеттер өтө көп. Кийинчерээк кайталаңыз", INTERNAL_ERROR: "Сервердин ички катасы",
    UNIT_CONVERSION_UNDEFINED: "Бирдик азыктын бирдигине которулбайт — азыктын тыгыздыгын көрсөтүңүз",
    RECIPE_CYCLE: "Жарым фабрикат өзүн өзү камтый албайт (же 5 деңгээлден терең)",
    RECIPE_VERSION_PUBLISHED: "Жарыяланган ТТК версиясын өзгөртүүгө болбойт — жаңысын түзүңүз",
    MENU_ITEM_UNAVAILABLE: "Позиция сатууга жеткиликсиз", TABLE_OCCUPIED: "Стол бош эмес",
    FILE_TOO_LARGE: "Файл өтө чоң (10 МБ чейин)", FILE_TYPE_NOT_ALLOWED: "JPEG, PNG, WebP, AVIF, HEIC сүрөттөрү гана",
    SERVICE_UNAVAILABLE: "Кызмат убактылуу жеткиликсиз",
    SHIFT_ALREADY_OPEN: "Бул кассада смена мурунтан ачык", SHIFT_CLOSED: "Смена мурунтан жабылган",
    CURSOR_EXPIRED: "Кассанын маалыматы эскирди — толук жүктөө керек", BATCH_TOO_LARGE: "Маалымат топтому өтө чоң", OPEN_ORDERS_EXIST: "Ачык заказдар бар — валютаны алмаштыруудан мурун аларды жабыңыз", TOTALS_MISMATCH: "Заказдын суммасы сервердин эсебине дал келбейт", TERMINAL_REVOKED: "Касса администратор тарабынан өчүрүлдү", REFUND_EXCEEDS_PAID: "Кайтаруу суммасы төлөнгөндөн көп", ORDER_NOT_PAID: "Заказ боюнча кайтаруу үчүн төлөм жок",
    INVALID_STATUS_TRANSITION: "Бул аракет учурдагы статуста жеткиликсиз — баракты жаңыртыңыз", BUSINESS_RULE: "Аракетти аткарууга болбойт", QUOTA_EXCEEDED: "Квота түгөндү — «Жазылуу» бөлүмүнөн пакет кошуңуз",
    row: "{{n}}-сап",
    detail: {
      stock: "{{product}}: бар {{available}}, керек {{required}}", stockAt: "{{product}} ({{warehouse}}): бар {{available}}, керек {{required}}",
      creditOff: "Кардарга насыяга төлөөгө уруксат жок", credit: "Лимит {{limit}}, азыркы карыз {{balance}}, жаңы карыз {{amount}}",
      cash: "Кассада {{expected}}, керек {{amount}}", due: "Төлөнө турган калдык {{due}}", depositLeft: "Депозиттен жеткиликтүү {{available}}",
      refund: "{{available}} ашык кайтарууга болбойт", deposit: "{{required}} төлөө керек, төлөндү {{paid}}", discount: "Арзандатууга уруксат берилген позициялардын суммасы — {{base}}",
      unavailable: "Жеткиликсиз: {{items}}", permission: "Укук керек: {{perms}}. Администраторго кайрылыңыз", retry: "{{min}} мүнөттөн кийин кайталаңыз",
      quota: "Керек {{needed}}, калды {{remaining}}", unit: "{{product}}: «{{unit}}» «{{base}}» бирдигине которулбайт", limit: "Тарифтин лимити: {{max}}",
    },
  },
  validation: {
    purchaseLine: "Продуктту тандаңыз же атын жазыңыз", purchaseDocNotFound: "Бул филиалда сатып алуу табылган жок",
    geoLat: "Кеңдикти көрсөтүңүз", geoLng: "Узундукту көрсөтүңүз", geoLatRange: "Кеңдик — −90дон 90го чейин", geoLngRange: "Узундук — −180ден 180ге чейин", geoPair: "Кеңдикти да, узундукту да көрсөтүңүз",
    socialWhatsapp: "WhatsApp номери +996XXXXXXXXX форматында же шилтеме", socialHandle: "Шилтеме же аккаунттун аты (@name)",
    lossRequired: "Жоготууну көрсөтүңүз", lossMin: "Нөлдөн кем эмес", lossOnlyReceipt: "Жоготуу — сатып алуу үчүн гана", lossPercentMax: "Жоготуу 100% дан аз болушу керек", lossQtyMax: "Жоготуу сандан аз болушу керек",
    bulkPick: "Жок дегенде бир жазууну тандаңыз", bulkMax: "Бир жолу 500дөн ашык эмес жазуу", bulkWhat: "Эмнени өзгөртүүнү тандаңыз", intOnly: "Бүтүн сан киргизиңиз", nonZeroChange: "Өзгөртүү нөл болбошу керек", bulkPercent: "Пайыз — −90дон 500гө чейин",
    codeRequired: "Каттагы кодду киргизиңиз",
    code6: "Код — 6 сан", codeWrong: "Код туура эмес", codeExpired: "Коддун мөөнөтү бүттү же суралган эмес — жаңысын жөнөтүңүз",
    codeTooMany: "Туура эмес аракеттер өтө көп — жаңы код жөнөтүңүз", resetLinkExpired: "Шилтеме жараксыз же эскирген — калыбына келтирүүнү кайра сураңыз",
    nothingToPay: "Төлөй турган эч нерсе жок",
    tipsPeriodTaken: "Бул мезгилдин чайпулу бөлүштүрүлгөн",
    tipsEmpty: "Мезгил ичинде чайпул жок",
    noShiftParticipants: "Мезгил ичинде сменасы бар кызматкер жок",
    dismissSelf: "Өзүңүздү бошото албайсыз",
    positionNotFound: "Кызмат орду табылган жок",
    debtNotFound: "Ачык карыз табылган жок",
    customerNotFound: "Кардар табылган жок",
    diffReason2: "Айырманын себебин жазыңыз",
    periodMax3: "Мезгил 3 айдан ашпашы керек",
    periodMax2: "Мезгил 2 айдан ашпашы керек",
    endAfterStart2: "Аягы башталышынан кийин болушу керек",
    nonZero: "Сумма 0 болушу мүмкүн эмес",
    diffReason: "Айырманын себебин жазыңыз",
    selectProduct: "Азыкты тандаңыз", expenseCategory: "Категорияны тандаңыз", amountPositive: "Сумма нөлдөн көп болушу керек", qtyRequired: "Санын көрсөтүңүз", qtyPositive: "Саны нөлдөн көп болушу керек", unknownUnit: "Белгисиз бирдик", reasonSelect: "Себебин тандаңыз", amountRequired: "Сумманы көрсөтүңүз", linesRequired: "Жок дегенде бир сап кошуңуз", productNotFound: "Азык табылган жок",
    refundPositive: "Кайтаруу суммасы 0дөн чоң болушу керек",
    reasonRequired: "Себебин көрсөтүңүз",
    refundTarget: "Төлөмдү же кайтаруу ыкмасын көрсөтүңүз",
    dateFormat: "Күн ЖЖЖЖ-АА-КК форматында",
    periodOrder: "Мезгилдин аягы башталышынан мурун",
    periodMax: "Мезгил бир жылдан ашпашы керек",
    endAfterStart: "Аягы башталышынан кийин болушу керек",
    paymentPositive: "Төлөм суммасы 0дөн чоң болушу керек",
    reasonComment: "Себебин жазыңыз", tableRequired: "Залдагы заказ үчүн столду тандаңыз",
    required: "Милдеттүү талаа", minChars: "Кеминде {{n}} белги", maxChars: "Эң көп {{n}} белги", min2: "Кеминде 2 белги",
    invalidId: "Туура эмес идентификатор", phoneFormat: "Телефон +996XXXXXXXXX форматында", invalidEmail: "Туура эмес email",
    slugChars: "Латын тамгалары, сандар жана дефис гана", pinFormat: "PIN — 4–6 сан", passwordMin: "Сырсөз — кеминде 10 белги",
    siteSlugFormat: "Субдомен: 3–40 белги, латын тамгалары, сандар жана дефис", siteSlugReserved: "Бул кызматтык дарек — башка субдомен тандаңыз",
    passwordMax: "Сырсөз — эң көп 128 белги", passwordChars: "Сырсөздө тамгалар жана сандар болушу керек",
    currencyCode: "ISO 4217 валюта коду", countryCode: "ISO 3166-1 өлкө коду", moneyInteger: "Сумма бүтүн сан болушу керек (minor units)",
    invalidQty: "Туура эмес саны", unknownTz: "Белгисиз саат алкагы", timeFormat: "СС:ММ форматы",
    formatsRequired: "Жок дегенде бир форматты тандаңыз", taxId: "ИНН — 10–14 сан", pct: "0дөн 99.99га чейин", sku: "Латын тамгалары, сандар, . _ - (64кө чейин)",
    barcode: "Штрихкод — 6–14 сан", invalidPrice: "Туура эмес баа", oldPrice: "Эски баа учурдагыдан жогору болушу керек",
    productRequired: "Товар үчүн кампадагы азыкты тандаңыз", oneDefaultVariant: "Демейки вариант бирөө гана болот",
    duplicateVariants: "Варианттардын аттары кайталанат", modifiersRequired: "Жок дегенде бир модификатор кошуңуз",
    maxGteMin: "Максимум минимумдан кем болбошу керек", singleMax: "Бирден тандоодо максимум = 1",
    minTooHigh: "Минимум активдүү модификаторлордун санынан көп", modifierQty: "Азыгы бар модификатор үчүн чыгым санын көрсөтүңүз",
    positive: "0дөн чоң", loginFormat: "Email же +996… форматындагы телефонду киргизиңиз", loginRequired: "Email же телефонду киргизиңиз",
    passwordRequired: "Сырсөздү киргизиңиз", ingredientRequired: "Азыкты же жарым фабрикатты тандаңыз",
    passwordNeedsContact: "Сырсөз менен кирүү үчүн email же телефон керек", passwordOrPin: "Сырсөз же PIN коюңуз",
    activationCode: "Активдештирүү коду — 8 белги", assignRole: "Жок дегенде бир роль дайындаңыз", invalidDate: "Туура эмес күн",
    acceptTerms: "Оферта шарттарын кабыл алуу зарыл", seatsMin: "1 орундан", numberRequired: "Номерин көрсөтүңүз", copyFactor: "Коэффициент 0.01ден 100гө чейин", copyTargets: "Кайда көчүрүүнү тандаңыз",
    goalTargetPositive: "Максат нөлдөн чоң болушу керек", goalTargetInteger: "Максат — бүтүн сан", goalDates: "Максаттын күндөрүн көрсөтүңүз", goalItemOnly: "Позиция же категория — сатылган тамактардын саны боюнча максат үчүн гана", goalItemOrCategory: "Позицияны же категорияны тандаңыз",
  },
  shell: {
    sections: "Бөлүмдөр", home: "Башкы бетке", logo: "Логотип", skipToContent: "Мазмунга өтүү", workScreens: "Иш экрандары", hideLabels: "Жазууларды жашыруу", showLabels: "Жазууларды көрсөтүү",
  },
  guards: {
    noAccess: "Укук жетишсиз",
    noAccessHint: "Бөлүмгө кирүү үчүн ээсине же башкаруучуга кайрылыңыз.",
    featureLocked: "«{{feature}}» функциясы учурдагы тарифке кирбейт. Кошумча кызматты кошуңуз же тарифти алмаштырыңыз.",
    soonTitle: "{{title}} — иштелип жатат",
    soonHint: "Бөлүм киргизүү планына ылайык жакынкы жаңыртуулардын биринде пайда болот.",
  },
  auth: {
    twoFactorTitle: "Ырастоо коду",
    twoFactorHint: "Аутентификатор тиркемесин (Google Authenticator ж.б.) ачып, 6 санды киргизиңиз.",
    twoFactorBackupHint: "Коргоону күйгүзгөндө сакталган запастык коддордун бирин киргизиңиз. Ар бир код бир жолу иштейт.",
    twoFactorCodeLabel: "Тиркемеден код",
    twoFactorBackupLabel: "Запастык код",
    twoFactorCodeFormat: "Код — 6 сан",
    twoFactorBackupFormat: "Запастык код — 8 белги, мисалы abcd-efgh",
    twoFactorConfirm: "Кирүү",
    twoFactorUseBackup: "Тиркемеге кирүү жокпу? Запастык код",
    twoFactorUseApp: "Тиркемеден код киргизүү",
    twoFactorWrong: "Код туура эмес",
    twoFactorExpired: "Код киргизүү убактысы бүттү — кайра кириңиз",
    forgotTitle: "Сырсөздү калыбына келтирүү",
    forgotDescription: "Email жазыңыз — жаңы сырсөз үчүн шилтеме жиберебиз.",
    forgotSentTitle: "Почтаңызды текшериңиз",
    forgotSent: "Эгер {{email}} катталган болсо, ага шилтеме келет. Ал 30 мүнөт жарактуу.",
    forgotAgain: "Шилтемени кайра суроо",
    backToLogin: "Кирүүгө кайтуу",
    forgotSend: "Шилтеме жиберүү",
    resetTitle: "Жаңы сырсөз",
    resetDescription: "Жаңы сырсөз ойлоп табыңыз. Сактагандан кийин бардык түзмөктөрдө кайра кириңиз.",
    resetNoToken: "Шилтеме толук эмес же эскирген. Жаңысын сураңыз.",
    newPassword: "Жаңы сырсөз",
    passwordRules: "Кеминде 10 белги, тамгалар жана сандар",
    resetSave: "Сырсөздү сактоо",
    resetDone: "Сырсөз өзгөрдү — жаңы сырсөз менен кириңиз",
    emailField: "Email",
    loginTitle: "Системага кирүү",
    loginDescription: "Мекемеңиздин заказдары, ашканасы, кампасы жана аналитикасы бир жерде.",
    terms: "Колдонуучу келишими",
    loginField: "Email же телефон",
    loginPlaceholder: "owner@cafe.kg же +996…",
    password: "Сырсөз",
    passwordPlaceholder: "Сырсөздү киргизиңиз",
    forgot: "Сырсөздү унуттуңузбу?",
    forgotHint: "Сырсөздү калыбына келтирүү жакынкы жаңыртууда пайда болот. Мекеменин ээсине кайрылыңыз.",
    signIn: "Кирүү",
    noAccount: "Аккаунтуңуз жокпу?",
    chooseCompany: "Компанияны тандаңыз",
    chooseCompanyHint: "Бул логин бир нече мекемеде бар",
    registerTitle: "Мекемени туташтыруу",
    registerDescription: "14 күн толук мүмкүнчүлүк акысыз. Карта керек эмес.",
    haveAccount: "Аккаунтуңуз барбы?",
    companyName: "Мекеменин аталышы",
    companyNamePlaceholder: "«Таң» кофейнясы",
    yourName: "Атыңыз",
    yourNamePlaceholder: "Айбек Асанов",
    phoneHint: "Билдирүүлөр жана кирүүнү калыбына келтирүү үчүн",
    passwordHint: "Кеминде 10 белги, тамгалар жана сандар",
    newPasswordPlaceholder: "Сырсөз ойлоп табыңыз",
    acceptBefore: "Мен",
    acceptLink: "оферта шарттарын",
    acceptAfter: "жана жеке маалыматтарды иштетүү саясатын кабыл алам",
    startFree: "Акысыз баштоо",
    registerCodeTitle: "Email'ди ырастаңыз",
    registerCodeDescription: "{{email}} дарегине 6 сандан турган код жөнөттүк. Ал 10 мүнөт жарактуу.",
    registerCodeLabel: "Каттагы код",
    registerCodeHint: "Келген жокпу? «Спам» жана «Промоакциялар» папкаларын текшериңиз.",
    registerConfirm: "Ырастоо",
    registerResend: "Кодду кайра жөнөтүү",
    registerResendIn: "{{sec}} сек кийин кайра жөнөтүү",
    registerCodeSent: "Код {{email}} дарегине жөнөтүлдү",
    registerChangeData: "Маалыматты өзгөртүү",
    forgotSelfSent: "Жаңы сырсөз үчүн шилтеме {{email}} дарегине жөнөтүлдү",
    forgotNoEmail: "Сизде email көрсөтүлгөн эмес — администратордон «Кызматкерлер» бөлүмүндө жаңы сырсөз коюуну сураңыз.",
  },
  terminal: {
    mode: "Режим",
    modeLogin: "Кирүү",
    modeClock: "Сменаны белгилөө",
    clockTitle: "Келүү жана кетүү",
    clockHint: "PIN киргизиңиз — келүү же кетүү автоматтык белгиленет",
    clockedIn: "{{name}}: келүү белгиленди",
    clockedOut: "{{name}}: кетүү белгиленди, иштелди {{h}}",
    mark: "Белгилөө",
    activateTitle: "Терминалды активдештирүү",
    activateDescription: "«Жөндөөлөр → Терминалдар» бөлүмүндөгү бир жолку кодду киргизиңиз.",
    code: "Активдештирүү коду",
    activate: "Активдештирүү",
    wrongPin: "PIN туура эмес",
    terminal: "Терминал",
    pinTitle: "PIN менен кирүү",
    pinHint: "Сменаны баштоо үчүн PIN-кодуңузду киргизиңиз",
    digitsEntered: "Киргизилген сандар: {{count}}",
    erase: "Өчүрүү",
    managerTitle: "Менеджердин кирүүсү",
    managerHint: "PIN заказды кайра ишке кайтаруу үчүн гана керек. Ашпозчулар ашкана экранында кирбей эле иштешет.",
    backToScreen: "Экранга кайтуу",
    appDevice: "Бул Kafe Coco кассасы — аны браузерде эмес, Kafe Coco тиркемесинде «Терминалдар» бөлүмүндөгү код менен байлашат.",
    unsupported: "Бул түзмөк түрү азырынча браузерде иштебейт. Касса, ашкана экранын же даярдык экранын түзүңүз.",
    screenFailed: "Экран ачылган жок",
    revoked: "Түзмөк өчүрүлгөн — «Терминалдар» бөлүмүндөгү код менен кайра активдештириңиз.",
  },
  dashboard: {
    hello: "Саламатсызбы, {{name}}!",
    sectionsHint: "Бөлүмдүн барактарын көрүү үчүн аны басыңыз",
    pages: "Барактар: {{count}}",
  },
  currencies: { KGS: "кыргыз сому", KZT: "теңге", UZS: "өзбек суму", RUB: "рубль", TJS: "сомони", USD: "АКШ доллары", EUR: "евро" },
  formats: { dine_in: "Залда", takeaway: "Ала кетүү", delivery: "Жеткирүү", self_service: "Өзүн өзү тейлөө" },
  branches: {
    description: "Компаниянын сатуу түйүндөрү: даректер, иш убактысы, тейлөө форматтары.",
    add: "Филиал кошуу", create: "Филиал түзүү", newTitle: "Жаңы филиал", editTitle: "«{{name}}» филиалы",
    searchPlaceholder: "Аталышы же шаар", empty: "Филиалдар азырынча жок",
    deleteTitle: "«{{name}}» филиалы өчүрүлсүнбү?", deleteHint: "Филиал бардык тизмелерден жашырылат. Сатуулардын тарыхы сакталат.", deleted: "Филиал өчүрүлдү",
    tabMain: "Негизги", tabHours: "Иш убактысы",
    namePlaceholder: "Борбордук", slug: "Шилтемедеги дарек (slug)", slugHint: "Сайттын дарегинде жана QR-менюда колдонулат",
    city: "Шаар", cityPlaceholder: "Бишкек", address: "Дарек", addressPlaceholder: "Киев көч., 77",
    timezone: "Саат алкагы", currency: "Валюта", dayCutoff: "Иш күнүнүн алмашуусу", dayCutoffHint: "Бул убакытка чейинки сатуулар мурунку күнгө кирет",
    formats: "Иш форматтары", formatsShort: "Форматтар", tzCurrency: "Алкак / валюта", working: "Иштейт",
    isActive: "Филиал иштейт", isActiveHint: "Өчүрүлгөн филиал заказ кабыл албайт жана тарифтин чегине эсептелбейт",
    hoursError: "Убакытты текшериңиз: СС:ММ форматы", dayOff: "Дем алыш",
    opens: "{{day}}: ачылышы", closes: "{{day}}: жабылышы",
    overnightHint: "Жабылуу ачылуудан эрте болсо, түн ортосунан кийин иштейт дегенди билдирет (мисалы, 10:00 — 02:00).",
    days: { mon: "Дүйшөмбү", tue: "Шейшемби", wed: "Шаршемби", thu: "Бейшемби", fri: "Жума", sat: "Ишемби", sun: "Жекшемби" },
  },
  users: {
    description: "ERPге сырсөз менен, терминалдарга PIN менен кирүү. Ролдор филиалдар боюнча дайындалат.",
    add: "Кызматкер кошуу", newTitle: "Жаңы кызматкер", added: "Кызматкер кошулду",
    searchPlaceholder: "Аты, телефону же email", allStatuses: "Бардык абалдар", activeMany: "Активдүүлөр", blockedMany: "Бөгөттөлгөндөр",
    employee: "Кызматкер", you: "(сиз)", contacts: "Байланыштар", roles: "Ролдор", role: "Роль", login: "Кирүү", lastLogin: "Акыркы кирүү",
    allBranchesLower: "бардык филиалдар",
    status: { active: "Активдүү", blocked: "Бөгөттөлгөн", invited: "Чакырылган" },
    notFound: "Эч ким табылган жок", empty: "Кызматкерлер азырынча жок",
    resetPin: "PINди жаңылоо", resetPassword: "Сырсөздү жаңылоо",
    sendResetLink: "Сырсөздү калыбына келтирүү шилтемесин жөнөтүү", resetLinkSent: "Жаңы сырсөз үчүн шилтеме {{email}} дарегине жөнөтүлдү",
    emailCodeLabel: "Кызматкердин катындагы код", emailCodeHint: "«Код жөнөтүү» баскычын басыңыз — код ушул email'ге келет. Кызматкерден аны айтып берүүнү сураңыз.", sendCode: "Код жөнөтүү", resendIn: "{{sec}} сек кийин кайра", codeSent: "Код {{email}} дарегине жөнөтүлдү",
    block: "Бөгөттөө", blockTitle: "{{name}} бөгөттөлсүнбү?", blockHint: "Кызматкердин бардык сеанстары дароо токтотулат, кирүү мүмкүн болбой калат.",
    blocked: "Кызматкер бөгөттөлдү", unblock: "Бөгөттөн чыгаруу", unblocked: "Кызматкер бөгөттөн чыгарылды",
    deleteTitle: "{{name}} өчүрүлсүнбү?", deleteHint: "Кызматкер тизмелерден жоголот, анын аракеттеринин тарыхы сакталат.", deleted: "Кызматкер өчүрүлдү",
    fullName: "Аты-жөнү", fullNamePlaceholder: "Асель Токтогулова",
    access: "Кирүү ыкмасы", accessHint: "PIN — филиалдын терминалында тез кирүү. Сырсөз — ERPге кирүү (тарифтин колдонуучулар чегине эсептелет).",
    accessOptions: { pin: "PIN гана", password: "Сырсөз (ERP)", both: "Сырсөз жана PIN" },
    pin: "PIN-код", pinHint: "4–6 сан, компанияда кайталанбайт",
    chooseRole: "Ролду тандаңыз", chooseBranch: "Филиалды тандаңыз", checkRoles: "Ролдорду текшериңиз", assignRole: "Жок дегенде бир роль дайындаңыз",
    addRole: "Роль кошуу", removeRole: "Ролду алып салуу",
    newPin: "Жаңы PIN", newPassword: "Жаңы сырсөз", pinLabel: "PIN-код (4–6 сан)", passwordLabel: "Сырсөз (≥ 10 белги, тамгалар жана сандар)",
    pinChanged: "PIN өзгөртүлдү", passwordChanged: "Сырсөз өзгөртүлдү, кызматкердин бардык сеанстары токтотулду",
  },
  notifications: {
    bell: "Билдирмелер",
    bellUnread: "Билдирмелер: жаңы {{n}}",
    title: "Билдирмелер",
    settings: "Жөндөөлөр",
    readAll: "Баарын окулду деп белгилөө",
    new: "жаңы",
    empty: "Билдирмелер азырынча жок",
    emptyHint: "Бул жерде смена жыйынтыктары, калдыктар, кайтаруулар жана QR-заказдар чыгат.",
    settingsTitle: "Билдирмелер",
    settingsDescription: "Кайсы билдирмелерди кайда жиберүү керек. Маанилүүлөрү баш жактагы коңгуроодо дайыма көрүнөт.",
    telegramHint: "Өз Telegram'ыңызды туташтырыңыз: {{bot}} боту ролуңузга жеткиликтүү билдирмелерди жөнөтөт.",
    telegramLinked: "Туташты {{user}}",
    telegramNotLinked: "Туташкан эмес",
    telegramNotInPlan: "Telegram-билдирмелер Pro тарифинде же «Telegram» кошумчасы менен жеткиликтүү.",
    telegramConnect: "Telegram туташтыруу",
    telegramRelink: "Башка чатты туташтыруу",
    telegramUnlink: "Өчүрүү",
    telegramUnlinkTitle: "Telegram билдирмелерин өчүрөсүзбү?",
    telegramOpened: "Telegram ачып, бот менен чатта «Start» басыңыз",
    refresh: "Абалын жаңыртуу",
    linkedAt: "Туташкан {{at}}",
    channels: "Каналдар",
    channelTelegram: "Боттон билдирүүлөр",
    channelEmail: "{{email}} дарегине каттар",
    noEmail: "Сизде email көрсөтүлгөн эмес",
    dailyReport: "Күндүк отчёт",
    dailyReportHint: "Кечинде филиалдар боюнча жыйынтык: киреше, чектер, топ тамактар, эсептен чыгаруулар.",
    types: "Эмнени жиберүү",
    typesHint: "Керектүү билдирмелерди күйгүзүп, кайда жөнөтүүнү тандаңыз. Тизме ролуңуздун укуктарына жараша.",
    typesEmpty: "Ролуңуз үчүн билдирмелер жок",
    typesEmptyHint: "Укук берилгенде (мисалы, касса, кампа же аналитика) билдирмелер пайда болот.",
    fromCoca: "Coca'дан",
    whatsNew: "Coca'да жаңы",
    open: "Ачуу",
    typeLabels: {
      "stock_request": "Филиалдардан кампага арыздар",
      purchase_request: "Сатып алууга жаңы арыздар",
      purchase_decision: "Менин сатып алуу арыздарым: чечим жана сатып алуу",
      "stock_expiring": "Жарактуулук мөөнөтү: өткөн жана бүтүп жаткан",
      stock_low: "Азыктар түгөнүп баратат",
      shift_closed: "Касса сменасынын жабылышы (Z-жыйынтык)",
      refund_created: "Кайтаруулар",
      report_daily: "Күндүк отчёт",
      order_qr: "Жаңы QR-заказдар",
      table_call: "Официантты чакыруу жана эсеп суроо (QR)",
      supplier_due: "Жеткирүүчүлөргө төлөм (мөөнөтү өткөн жана бүгүн–эртең)",
      support_reply: "Колдоо кызматынын жооптору",
      support_access: "Coca колдоосунун кабинетке кирүү сурамдары",
      fraud_alert: "Кызматкерлердин шектүү аракеттери",
      sms_quota: "SMS квотасы: 80% жана 100%",
      goal_achieved: "Команданын аткарылган максаттары",
      achievement_earned: "Менин максаттарым жана жетишкендиктерим",
      waiter_table: "Менин столдорум: стол дайындалды же өткөрүлдү",
      platform_message: "Coca'дан билдирүүлөр",
      platform_update: "Coca'нын жаңы мүмкүнчүлүктөрү",
    },
  },
  security: {
    title: "Коопсуздук",
    description: "Аккаунтка кирүүнү коргоо жана активдүү сеанстар.",
    twoFactor: "Эки факторлуу коргоо",
    twoFactorHint: "Кирүүдө сырсөздөн тышкары телефондогу тиркемеден код керек.",
    on: "Күйгүзүлгөн",
    off: "Өчүрүлгөн",
    recommend: "Ээсине жана администраторлорго сунушталат: сырсөз ачыкка чыкса да, телефонсуз кирүүгө болбойт.",
    enable: "Күйгүзүү",
    enableTitle: "Эки факторлуу коргоону күйгүзүү",
    enableHint: "QR-кодду аутентификатор тиркемесинде сканерлеп, ал көрсөткөн кодду киргизиңиз.",
    qrAlt: "Аутентификатор тиркемеси үчүн QR-код",
    manualKey: "Же ачкычты кол менен киргизиңиз:",
    enabledToast: "Эки факторлуу коргоо күйгүзүлдү",
    enabledAt: "{{at}} күйгүзүлгөн. Калган запастык коддор: {{n}}.",
    fewCodes: "Запастык коддор дээрлик калган жок — жаңыларын түзүңүз.",
    regen: "Жаңы запастык коддор",
    regenTitle: "Жаңы запастык коддор",
    regenHint: "Эски коддор иштебей калат. Тиркемеден кодду киргизиңиз.",
    disable: "Өчүрүү",
    disableTitle: "Эки факторлуу коргоону өчүрөсүзбү?",
    disableHint: "Сырсөздү жана тиркемеден кодду (же запастык кодду) киргизиңиз.",
    disabledToast: "Эки факторлуу коргоо өчүрүлдү",
    codeOrBackup: "Тиркемеден код же запастык код",
    backupTitle: "Запастык коддор",
    backupHint: "Аларды ишенимдүү жерде сактаңыз: телефон жоголсо керек болот. Ар бир код — бир кирүү. Алар кайра көрсөтүлбөйт.",
    copy: "Көчүрүү",
    copied: "Коддор көчүрүлдү",
    download: "Жүктөп алуу",
    saved: "Коддорду сактадым",
    sessions: "Активдүү сеанстар",
    sessionsHint: "Аккаунтуңузга кайсы жерден кирилген.",
    current: "ушул",
    lastUsed: "активдүүлүк {{at}}",
    unknownDevice: "Белгисиз түзмөк",
    revoke: "Аяктоо",
    revokeTitle: "Бул сеансты аяктайсызбы?",
    logoutAll: "Бардык түзмөктөрдөн чыгуу",
    logoutAllTitle: "Бардык түзмөктөрдөн чыгасызбы?",
    logoutAllHint: "Бардык сеанстар, ушул сеанс менен кошо, аякталат.",
  },
  approval: {
    descriptionVoid: "Позиция ашканага жиберилген — аны менеджер гана өчүрө алат. Андан PIN-кодун киргизүүнү сураңыз.",
    title: "Менеджердин ырастоосу керек",
    description: "{{action}}: {{value}} — сиздин лимиттен ({{limit}}) жогору. Менеджерден PIN-кодун киргизүүнү сураңыз.",
    confirm: "Ырастоо",
    pin: "Менеджердин PIN-коду",
    pinFormat: "PIN — 4–6 сан",
    wrongPin: "PIN туура эмес",
    noRight: "Бул кызматкер мындай аракетти ырастай албайт",
    self: "Башка кызматкер гана ырастай алат",
    hint: "Ырастоо бир жолу колдонулат жана 2 мүнөт жарактуу. Журналда эки кызматкер тең жазылат.",
    actions: {
      order_discount: "Арзандатуу",
      order_void: "Позицияны өчүрүү",
      payment_refund: "Кайтаруу",
      stock_writeoff: "Эсептен чыгаруу",
      cash_cash_out: "Кассадан алуу",
    },
  },
  roles: {
    limitsTitle: "Ырастоосуз лимиттер",
    limitsHint: "Лимиттен жогору аракетти менеджер PIN-коду менен ырастайт. Бош — чексиз.",
    limitEmpty: "Бош — чексиз",
    limits: {
      orders_discount: "Арзандатуу, ашпаган",
      payments_refund: "Кайтаруу, ашпаган",
      stock_documents_create: "Эсептен чыгаруу, ашпаган",
      cash_shifts_cash_out: "Кассадан алуу, ашпаган",
    },
    description: "Кызматкердин укуктар топтому. Өз укуктарыңыздан кеңири ролду бере албайсыз.",
    newTitle: "Жаңы роль", created: "Роль түзүлдү", updated: "Роль жаңыланды", deleted: "Роль өчүрүлдү", deleteTitle: "«{{name}}» ролу өчүрүлсүнбү?",
    empty: "Ролдор жок", system: "Системалык", systemHint: "Системалык роль — платформанын шаблону, компанияңыз үчүн укуктарын өзгөртсө болот",
    stats: "Укуктар: {{perms}} · Кызматкерлер: {{users}}", scopeCompany: "Бүт компания",
    ownerReadOnly: "Ээсинин ролу өзгөртүлбөйт", ownerReadOnlyHint: "Ээсинде ар дайым толук мүмкүнчүлүк бар, анын ичинде жазылуу.",
    namePlaceholder: "Улук кассир", scope: "Аракет чөйрөсү", scopeFixed: "Ролдун чөйрөсү түзүүдө белгиленет",
    scopeHint: "Бүт бизнеске — бухгалтер, аудитор үчүн; филиалга — кассир, ашпозчу үчүн",
    inBranch: "Филиалда", inCompany: "Бүт компанияда", permissions: "Укуктар",
    findSection: "Бөлүмдү табуу", selectedCount: "Тандалган укуктар: {{count}}",
  },
  systemRoles: {
    owner: "Ээси", company_admin: "Компаниянын администратору", branch_manager: "Филиалдын башкаруучусу", accountant: "Бухгалтер",
    cashier: "Кассир", waiter: "Официант", cook: "Ашпозчу", auditor: "Аудитор", courier: "Курьер",
  },
  permResources: {
    report_resets: "Отчётторду тазалоо",
    purchase_requests: "Сатып алууга арыздар",
    waiter_zones: "Залдар боюнча официанттар",
    goals: "Максаттар жана жетишкендиктер",
    "stock_transfers": "Которуулар",
    "production": "Өндүрүш",
    tips: "Чайпул",
    dashboard: "Башкы панель", pos: "POS", orders: "Заказдар", tables: "Столдор", halls: "Залдар", kitchen: "Ашкана", menu: "Меню",
    stop_list: "Стоп-тизме", recipes: "Рецептуралар", costing: "Калькуляция", warehouses: "Кампалар", stock: "Калдыктар",
    stock_documents: "Кампа документтери", inventory_counts: "Инвентаризация", suppliers: "Жеткирүүчүлөр", supplier_payments: "Жеткирүүчүлөргө төлөмдөр", customers: "Кардарлар", debts: "Карыздар",
    payments: "Төлөмдөр", cash_shifts: "Касса сменалары", reservations: "Брондоолор", employees: "Кызматкерлер", work_shifts: "Жумуш сменалары", payroll: "Айлык акы",
    expenses: "Чыгашалар", analytics: "Аналитика", reports: "Отчеттор", settings: "Жөндөөлөр", branches: "Филиалдар",
    users: "Колдонуучулар", roles: "Ролдор", devices: "Терминалдар", audit: "Аудит", subscription: "Жазылуу", support: "Колдоо", fraud: "Кыянаттыктан коргоо", sms: "SMS-жөнөтүүлөр", services: "Кызматтар жана ижара", banquets: "Банкеттер", promotions: "Акциялар", deliveries: "Жеткирүү",
  },
  permActions: {
    "receive": "Кабыл алуу",
    "complete": "Чыгарууну өткөрүү",
    adjust: "Түзөтүү", write_off: "Эсептен чыгаруу", x_report: "X-отчёт", calculate: "Эсептөө", pay: "Төлөө", grant_access: "Колдоого кирүү уруксаты",
    view: "Көрүү", create: "Түзүү", update: "Өзгөртүү", delete: "Өчүрүү", manage: "Башкаруу", approve: "Ырастоо",
    cancel: "Жокко чыгаруу", refund: "Кайтаруу", discount: "Арзандатуулар", void: "Жокко эсептөө", reopen: "Кайра ачуу", transfer: "Которуу",
    merge: "Бириктирүү", split: "Бөлүү", price_override: "Бааны өзгөртүү", credit_sale: "Карызга сатуу", print: "Басып чыгаруу",
    export: "Экспорт", post: "Өткөрүү", unpost: "Өткөрүүнү жокко чыгаруу", open_shift: "Сменаны ачуу", close_shift: "Сменаны жабуу",
    cash_in: "Акча салуу", cash_out: "Акча алуу", finance: "Каржы", assign: "Дайындоо",
  },
  venue: {
    title: "«{{name}}» мекемеси: валюта жана салык", description: "Kafe Coco кассалары үчүн учурдагы филиалдын жөндөөлөрү — өзгөрүүлөр кассаларга бир нече секундда жетет.",
    currency: "Валюта", currencyHint: "Ачык заказдар жок болгондо гана алмаштырууга болот", symbolPosition: "Валюта белгиси", before: "Суммадан мурун", after: "Суммадан кийин",
    taxRate: "Салык ставкасы, %", taxIncluded: "Салык баага кирет", taxIncludedHint: "Салык чектин суммасына үстүнөн кошулса, өчүрүңүз",
  },
  company: {
    description: "Реквизиттер жана жаңы филиалдар үчүн демейки аймактык жөндөөлөр.",
    legalName: "Юридикалык аталышы", legalNamePlaceholder: "ЖЧК «…»", taxId: "ИНН",
    defaultLocale: "Демейки тил", baseCurrency: "Негизги валюта", baseCurrencyHint: "Колдоо кызматы аркылуу өзгөрөт — отчетторго таасир этет",
  },
  geo: {
    tab: "Картада",
    cardTitle: "Байланыштар жана картадагы жерлер",
    cardDescription: "Коноктор сизди Coca сайтынын «Жакын жерде» бетинен табышат: филиалдардын картадагы чекиттери, байланыштар жана учурдагы акциялар. Сиздин сайтта «Маршрут» баскычы пайда болот.",
    openNearby: "«Жакын жерде» ачуу",
    onMap: "Картада",
    notOnMap: "Көрсөтүлгөн эмес",
    set: "Картада көрсөтүү",
    noAddress: "Дарек көрсөтүлгөн эмес",
    modalTitle: "{{name}} картада",
    branchHint: "Картаны басыңыз же белгини мекеменин кире беришине сүйрөңүз. Чекит конокторго Coca сайтынын «Жакын жерде» бетинде жана сиздин сайттагы «Маршрут» баскычында көрүнөт.",
    contactsHint: "Коноктор үчүн телефон, email жана социалдык тармактар (Instagram, WhatsApp, Telegram…) «Сайт жана QR-меню» бөлүмүндө толтурулат.",
    contactsLink: "Байланыштарды толтуруу",
    findAddress: "Дарек боюнча табуу",
    myLocation: "Менин жайгашкан жерим",
    clear: "Чекитти алып салуу",
    noPoint: "Чекит көрсөтүлгөн эмес",
    hint: "Картаны басуу — белги коюу",
    mapAria: "Карта: филиалдын ордун тандаңыз",
    notFound: "Дарек табылган жок — белгини картага кол менен коюңуз",
    denied: "Жайгашкан жерди аныктоо мүмкүн болбоду — геолокацияга уруксат бериңиз же белгини кол менен коюңуз",
    invalid: "Чекит туура эмес көрсөтүлгөн — белгини кайра коюңуз",
  },

  subscription: {
    description: "Тариф, чектер жана кошулган функциялар. Төлөө жана тарифти алмаштыруу — платформанын менеджери аркылуу (онлайн төлөм кийинчерээк пайда болот).",
    trialLeft: "Сыноо мөөнөтү: {{count}} күн калды", trialHint: "Мөөнөт бүткөндөн кийин чектөөсүз иштөө үчүн тариф тандаңыз.",
    payHint: "Толук мүмкүнчүлүктү кайтаруу үчүн эсепти төлөңүз. Кассадагы сатуулар иштей берет.",
    plan: "{{plan}} тарифи", features: "Функциялар", featuresHint: "Белгиленгендер тарифиңизде жеткиликтүү", available: "Жеткиликтүү", unavailable: "Жеткиликсиз",
    status: {
      trialing: "Сыноо мөөнөтү", active: "Активдүү", past_due: "Төлөм күтүлүүдө", read_only: "Окуу гана", suspended: "Токтотулган",
      cancelled: "Жокко чыгарылган", expired: "Мөөнөтү бүткөн", archived: "Архивде",
    },
    limits: {
      branches: "Филиалдар", terminals: "Терминалдар", users: "Сырсөзү бар колдонуучулар", warehouses: "Кампалар", menu_items: "Меню позициялары",
      ai_requests: "Ушул айдагы Coca AI суроолору",
      storage_gb: "Сактагыч, ГБ", report_history_days: "Отчеттордун тарыхы, күн", api_rps: "API, сурам/сек",
    },
  },
  features: {
    core: {
      pos: "Касса жана заказдар", menu: "Меню", tables: "Зал жана столдор", kds: "Ашкана экраны", inventory_basic: "Негизги кампа",
      recipes: "Рецептуралар жана калькуляция", customers: "Кардарлар", debts: "Кардарлардын карыздары", staff: "Кызматкерлер жана сменалар",
      payroll_basic: "Негизги айлык акы", analytics_basic: "Негизги аналитика", qr_menu: "QR-меню", website: "Мекеменин сайты",
    },
    addon: {
      qr_ordering: "QR-заказ", online_payments: "Онлайн төлөм", inventory_pro: "Кампа (кеңейтилген)", procurement: "Сатып алуулар",
      production: "Өндүрүш", payroll_pro: "Айлык акы (кеңейтилген)", finance: "Каржы", loyalty: "Лоялдуулук",
      promotions_pro: "Акциялар (кеңейтилген)", reservations: "Брондоо", banquets: "Банкеттер", services: "Кызматтар жана ижара",
      delivery: "Жеткирүү", aggregators: "Агрегаторлор", telegram: "Telegram-бот", sms: "SMS-жөнөтүүлөр", analytics_pro: "Отчёттор (кеңейтилген)",
      fraud: "Кыянаттыктан коргоо", reviews: "Пикирлер", custom_domain: "Сайттын өз дареги", api_access: "Тышкы программаларды туташтыруу", offline_mode: "Интернетсиз иштөө",
      desktop: "Компьютер үчүн касса программасы", fiscal: "Фискалдаштыруу", accounting_export: "1Сге жүктөө", ai: "Акылдуу жардамчы",
      white_label: "White label", priority_support: "Артыкчылыктуу колдоо",
    },
  },
  devices: {
    download: "Кассанын программасын жүктөп алуу:", platforms: { windows: "Windows", macos: "macOS" },
    where: "Касса кайда иштейт", whereBrowser: "Браузерде", whereApp: "Компьютер үчүн программа",
    pair: "Кассаны байлоо", pairTitle: "Кассаны байлоо", pairHint: "Компьютердеги касса программасын ачып, кодду киргизиңиз:",
    pairOneTime: "Код бир жолку. Байлангандан кийин касса ушул филиалдын менюсун жана столдорун жүктөйт, кызматкерлер өз PIN менен киришет.",
    description: "Кассалар, ашкана экрандары жана официанттардын планшеттери. PIN менен кирүү катталган түзмөктөрдө гана иштейт.",
    add: "Терминал кошуу", newTitle: "Жаңы терминал", getCode: "Код алуу", namePlaceholder: "Кире бериштеги касса",
    type: "Түзмөктүн түрү", typeShort: "Түрү", activity: "Активдүүлүк",
    empty: "Терминалдар азырынча жок", emptyHint: "Касса же ашкана экранын кошуп, түзмөктү бир жолку код менен активдештириңиз.",
    reset: "Жаңы код", resetTitle: "«{{name}}» үчүн жаңы код берилсинби?", resetHint: "Түзмөк дароо кирүү укугун жоготот, андагы сеанстар токтотулат. Жаңы кодду ушул эле түзмөккө киргизиңиз — аталышы, филиалы жана кассанын номери сакталат.", resetCodeTitle: "«{{name}}» үчүн жаңы код",
    deleteTitle: "«{{name}}» өчүрүлсүнбү?", deleteHint: "Терминал тизмеден жоголуп, дароо кирүү укугун жоготот, лимиттеги орун бошойт. Буйрутмалар жана журнал сакталат.", deleted: "Терминал өчүрүлдү",
    revoke: "Бөгөттөө", revokeTitle: "«{{name}}» бөгөттөлсүнбү?", revokeHint: "Түзмөк дароо кирүү укугун жоготот, андагы бардык сеанстар токтотулат.", revoked: "Терминал өчүрүлдү",
    openBefore: "«{{name}}» түзмөгүндө бул даректи ачыңыз:", openAfter: "жана кодду киргизиңиз:",
    codeCopied: "Код көчүрүлдү", copyCode: "Кодду көчүрүү", codeValid: "Код дагы {{time}} жарактуу", codeExpired: "Коддун мөөнөтү бүттү — терминалдын «⋯ → Жаңы код» аркылуу жаңысын бериңиз",
    oneTimeHint: "Код бир жолку. Активдештирүүдөн кийин кызматкерлер түзмөккө өз PIN-коду менен кирет.",
    oneTimeHintScreen: "Код бир жолку. Активдештирүүдөн кийин экран өзү ачылат — PIN керек эмес.",
    access: { pin: "Кызматкерлер өз PIN-коду менен кирип, өз укуктары менен иштешет.", screen: "PINсиз иштейт: активдештирүүдөн кийин экран дароо ачылат.", app: "Кассанын компьютериндеги Kafe Coco тиркемесинде байланат." },
    status: { pending: "Активдештирүү күтүлүүдө", active: "Активдүү", revoked: "Өчүрүлгөн" },
    types: {
      pos: "Касса (POS)", kds: "Ашкана экраны (KDS)", waiter: "Официант", kiosk: "Өзүн өзү тейлөө киоску", customer_display: "Кардардын экраны",
      ready_screen: "Даярдык экраны", printer_bridge: "Басып чыгаруу сервери", desktop: "Касса (POS)", courier: "Курьер",
    },
  },
  menu: {
    description: "Позициялар, категориялар, модификаторлор жана стоп-тизме. Өзгөртүүлөр кассаларда дароо көрүнөт.",
    tabItems: "Позициялар", tabCategories: "Категориялар", tabModifiers: "Модификаторлор", tabStop: "Стоп-тизме",
    notForSale: "Сатылбайт", stop: "Стоп", remaining: "{{count}} калды", hiddenInBranch: "Филиалда жашырылган", priceFrom: "{{price}} баштап",
    pricePerKg: "{{price}}/кг",
    searchItems: "Аталышы же артикулу боюнча издөө", addItem: "Позиция кошуу", noItems: "Менюда азырынча позициялар жок",
    createCategoryFirst: "Адегенде категория түзүңүз", createCategoryFirstHint: "Мисалы, «Кофе», «Ысык тамактар», «Десерттер» — «Категориялар» өтмөгүндө.",
  },
  bulk: {
    select: "Тандоо", done: "Даяр", selectAll: "Баарын тандоо", selectPage: "Барактагылардын баарын тандоо", change: "Өзгөртүү",
    onSale: "Сатуу", offSale: "Сатуудан алуу", showPublic: "Ачык менюда көрсөтүү", hidePublic: "Ачык менюдан жашыруу",
    allowDiscount: "Арзандатууга уруксат берүү", denyDiscount: "Арзандатууга тыюу салуу", move: "Категорияга которуу…", price: "Бааны өзгөртүү…",
    fromStop: "Сатууга кайтаруу", setPortions: "Калдыкты коюу", stopTitle: "Стопко: {{count}} поз.",
    priceTitle: "Баа: {{count}} поз.", priceUp: "Көтөрүү", priceDown: "Төмөндөтүү", priceMode: "Кантип өзгөртүү", pricePercent: "Пайызга", priceAmount: "Суммага",
    priceHint: "Варианттардын баалары да ошондой өзгөрөт. Баа 0дөн төмөн болбойт, эски баа жаңыдан жогору болбосо өчүрүлөт.",
    moveTitle: "{{count}} поз. которуу", category: "Категория",
    showCategories: "Көрсөтүү", hideCategories: "Жашыруу", channelsTitle: "Сатуу каналдары: {{count}} кат.", keep: "Өзгөртпөө", show: "Көрсөтүү", hide: "Жашыруу",
    deleteItemsTitle: "Позицияларды өчүрөсүзбү ({{count}})?", deleteItemsHint: "Позициялар кассалардан жана сайттан жоголот, сатуу тарыхы сакталат.",
    deleteCategoriesTitle: "Категорияларды өчүрөсүзбү ({{count}})?", deleteCategoriesHint: "Бош категориялар гана өчүрүлөт. Кайсы бирөөндө позиция болсо — эч нерсе өчүрүлбөйт.",
    updated: "Өзгөртүлдү: {{count}}", deleted: "Өчүрүлдү: {{count}}", stopped: "Стопто: {{count}}", unstopped: "Кайра сатууда",
  },
  stop: {
    hint: "Учурдагы филиал үчүн иштейт (жогорку панелде тандалган). Кассалар жана QR-меню позицияны дароо жашырат.",
    add: "Стопко коюу", added: "Позиция стоп-тизмеде", portionsLeft: "Калган порциялар: {{count}}",
    item: "Позиция", state: "Абалы", since: "Качантан", return: "Кайтаруу", backOnSale: "Кайра сатыкта",
    empty: "Стоп-тизме бош", emptyHint: "Бардык позициялар сатууга жеткиликтүү.",
    portions: "Калган порциялар", portionsHint: "Бош — толугу менен түгөндү. Сан — түгөнгөнчө сатылат",
  },
  categories: {
    title: "Категория", newTitle: "Жаңы категория", image: "Категориянын сүрөтү", namePlaceholder: "Кофе", slug: "Дарек (slug)",
    parent: "Ата категория", parentHint: "3 деңгээлге чейин", topLevel: "Жогорку деңгээл",
    channels: "Кайда көрсөтүү", channel: { pos: "Касса", qr: "QR-меню", website: "Сайт", delivery: "Жеткирүү" }, visible: "Категория көрүнөт",
    deleteTitle: "«{{name}}» категориясы өчүрүлсүнбү?", deleted: "Категория өчүрүлдү", itemsCount: "{{count}} поз.", hidden: "Жашырылган",
    subcategory: "Ички категория", empty: "Категориялар азырынча жок", emptyHint: "Мисалы: Кофе, Суусундуктар, Ысык тамактар, Десерттер.",
  },
  modifiers: {
    saved: "Топ сакталды", notSelected: "Тандалган жок", newTitle: "Жаңы модификаторлор тобу", newGroup: "Жаңы топ",
    usedIn: "Топ {{count}} позицияда колдонулат. Ачык заказдар мурунку модификаторлорду сактайт.",
    groupName: "Топтун аталышы", groupNamePlaceholder: "Кошумчалар / Сүт / Бышыруу",
    selection: "Тандоо", selectionType: "Тандоо түрү", single: "Бир вариант", multiple: "Бир нечеси",
    min: "Минимум", minHint: "≥ 1 — милдеттүү топ", max: "Максимум", maxHint: "Бош — чектөөсүз",
    free: "Акысыз, даана", freeHint: "Алгачкы N — кошумча төлөмсүз", allowQuantity: "Бир эле нерседен бир нечени тандоого болот (×2 сыр)",
    namePlaceholder: "Сыр", writeOff: "Азыкты чыгымга чыгаруу", product: "Азык", quantity: "Саны (негизги бирдикте)",
    replaces: "Ингредиентти алмаштырат", replacesHint: "Мисалы, уйдун сүтүнүн ордуна өсүмдүк сүтү", replaced: "Алмаштырылуучу",
    removes: "Ингредиентти алып салат", removesHint: "«Пиязсыз»", removed: "Алынуучу",
    kitchenLabel: "Ашкана үчүн белги", kitchenLabelPlaceholder: "+сыр", isDefault: "Демейки тандалган", add: "Модификатор кошуу",
    required: "Милдеттүү", optional: "Каалоо боюнча", one: "Бирөө", upTo: "{{max}} чейин", inItems: "{{count}} поз. ичинде",
    deleteTitle: "«{{name}}» тобу өчүрүлсүнбү?", empty: "Модификаторлор топтору жок", emptyHint: "Кошумчалар, сүт тандоо, бышыруу деңгээли, «пиязсыз».",
  },
  items: {
    title: "Меню позициясы", newTitle: "Жаңы позиция", newSaved: "Жаңы позиция (сакталды)",
    saved: "Позиция сакталды", createdNext: "Позиция түзүлдү — эми ТТК түзсө болот",
    onSale: "Сатыкта", onSaleHint: "Өчүрүлгөн позиция эч жерде сатылбайт", visiblePublic: "Коноктор көрөт", visiblePublicHint: "QR-меню жана сайт",
    allowDiscount: "Арзандатууларга уруксат", isWeighted: "Салмак менен сатуу",
    isWeightedHint: "Палоо, балык, салаттар салмагы менен: баасы 1 кг үчүн, кассада салмагы граммы же килограммы менен киргизилет", pricePerKg: "1 кг баасы", recipeWeighted: "Позиция салмагы менен сатылат: ТТК чыгышы — килограмм менен. Мисалы, 12 кг палоо казаны — чыгышы 12; 450 г сатуу казандын азыктарынын 0,45 / 12 бөлүгүн чегерет.",
    basePricePlaceholder: "Негизги: {{price}}", branchPrice: "{{name}} филиалындагы баа",
    branchesHint: "Негизги баа компания үчүн жалпы. Филиалда позицияны жашырып же өз баасын коюуга болот — бош талаа негизги бааны билдирет (BR-052).",
    photo: "Позициянын сүрөтү", namePlaceholder: "Латте", oldPrice: "Эски баа (сызылган)", sku: "Артикул",
    stockProduct: "Кампадагы азык", stockProductHint: "Сатууда ТТКсыз түз эле чыгымга чыгарылат",
    weight: "Салмагы, г", volume: "Көлөмү, мл", calories: "Калориясы, ккал", cookingTime: "Даярдоо убактысы, мүн",
    descriptionPlaceholder: "Курамы жана берилиши — коноктор QR-менюда жана сайтта көрөт",
    posTags: "Касса тегдери", posTagsHint: "Kafe Coco кассасындагы тез чыпкалар; жаңы тег үчүн атын териңиз", barcodes: "Штрихкоддор", barcodesHint: "Кассадагы сканер үчүн: кодду киргизип, Enter басыңыз", barcodePlaceholder: "4600000000017", removeBarcode: "{{code}} штрихкодун өчүрүү",
    tagsLabel: "Белгилер", allergensLabel: "Аллергендер",
    minAge: "Жаш чектөөсү", minAgeHint: "Алкоголь жана тамеки үчүн кассир жашты ырастайт (BR-049)",
    variants: "Варианттар", variantsHint: "Өз баасы бар өлчөмдөр жана көлөмдөр (S/M/L, 25/30/40 см). Варианттарсыз негизги баада сатылат.",
    variantPlaceholder: "Мисалы, 300 мл", variantName: "Варианттын аталышы", variantPrice: "Варианттын баасы", byDefault: "Демейки",
    deleteVariant: "Вариантты өчүрүү", addVariant: "Вариант кошуу",
    modifierGroups: "Модификаторлор топтору", modifierGroupsHint: "Кошумчалар, бышыруу, сүт. Милдеттүү топторду кассир өткөрүп жибере албайт (BR-025).",
    noneSelected: "Тандалган жок", groupSummary: "{{count}} даана · {{kind}}",
    recipe: "ТТК", recipeFirst: "Адегенде позицияны түзүңүз — андан кийин технологиялык картаны түзүңүз.",
    types: { dish: "Тамак", drink: "Суусундук", product: "Товар", service: "Кызмат", combo: "Комбо", modifier_only: "Модификатор гана" },
    tags: { new: "Жаңы", hit: "Хит", spicy: "Ачуу", vegan: "Веган", vegetarian: "Вегетариандык", halal: "Халал" },
    allergens: {
      gluten: "Глютен", lactose: "Лактоза", eggs: "Жумуртка", nuts: "Жаңгак", peanuts: "Арахис", soy: "Соя", fish: "Балык", shellfish: "Моллюскалар",
      sesame: "Кунжут", celery: "Сельдерей", mustard: "Горчица", sulfites: "Сульфиттер",
    },
  },
  units: { g: "г", kg: "кг", ml: "мл", l: "л", pcs: "даана", portion: "порция" },
  recipe: {
    noConversion: "Бирдик азыктын бирдигине которулбайт", checkRows: "ТТК саптарын текшериңиз", cycle: "Цикл түрүндөгү шилтеме",
    publishTitle: "ТТК жарыялансынбы?", publishHint: "Жаңы сатуулар ушул версия боюнча чыгымга чыгарылат. Мурунку версия архивге кетет, жабык заказдар өзгөрбөйт.",
    publish: "Жарыялоо", published: "ТТК жарыяланды", discardTitle: "Черновик жокко чыгарылсынбы?", discard: "Черновикти жокко чыгаруу",
    draftV: "Черновик v{{v}}", publishedV: "Жарыяланган v{{v}}", none: "ТТК жок", salesUse: "Сатуулар жарыяланган v{{v}} боюнча чыгымга чыгарылат",
    incomplete: "Өздүк нарк толук эмес", output: "Чыгышы", outputUnit: "Чыгыш бирдиги",
    ingredient: "Ингредиент", gross: "Брутто", unitShort: "Бир.", waste: "Калдык %", loss: "Жоготуу %", netSum: "Нетто / сумма",
    productPlaceholder: "Азык же жарым фабрикат", noPrice: "баасы жок", takeawayOnly: "Ала кетүү гана", deleteRow: "Сапты өчүрүү",
    takeawayHint: "«Ала кетүү» жана жеткирүү үчүн гана (таңгак)", addIngredient: "Ингредиент кошуу",
    cost: "Өздүк нарк", perPortion: "Бир порцияга", perOutput: "Чыгышка",
    instructions: "Даярдоо технологиясы", instructionsPlaceholder: "Даярдоо тартиби, температура, берилиши",
    draftSaved: "Черновик сакталды", saveDraft: "Черновикти сактоо", history: "Версиялардын тарыхы",
    statusActive: "колдонулууда", statusDraft: "черновик", statusArchive: "архив",
    owner: "ТТК эмне үчүн", forItem: "Тамак (жалпы)", variantsHint: "Ар бир варианттын өз ТТКсы бар. Вариантта ал жок болсо, сатууда тамактын ТТКсы эсептен чыгарылат.",
    copy: "Көчүрүү…", copyTitle: "ТТКны көчүрүү", copyAction: "Көчүрүү",
    copyHint: "Курам, технология жана чыгым тандалган варианттардын черновиктерине түшөт (алардын черновиктери алмашат). Ар бирин өзүнчө жарыялаңыз.",
    factorFor: "«{{name}}» үчүн коэффициент", factorHint: "Коэффициент бруттону көбөйтөт: 1 — ошол бойдон, 1.5 — 50% көп (S → L).",
    copied: "Көчүрүлгөн ТТК: {{count}}",
  },
  products: {
    description: "Ингредиенттер, товарлар, жарым фабрикаттар жана таңгак — ТТК менен кампанын негизи.",
    add: "Азык кошуу", newTitle: "Жаңы азык", saved: "Азык сакталды",
    searchPlaceholder: "Аталышы, артикулу же штрихкоду", allTypes: "Бардык түрлөр",
    empty: "Азыктар азырынча жок", emptyHint: "Сатып алуу баасы менен ингредиенттерди кошуңуз — тамактардын өздүк наркы автоматтык эсептелет.",
    namePlaceholder: "Сүт 3.2%", baseUnit: "Эсепке алуу", baseUnitHint: "Азык ТТКда жок болсо гана өзгөрөт",
    baseUnits: { g: "граммдар", ml: "миллилитрлер", pcs: "даана" }, unitColumn: "Эсеп",
    purchasePrice: "Сатып алуу баасы", purchasePriceFor: "{{unit}} үчүн сатып алуу баасы", perBaseHint: "= {{unit}} үчүн {{price}} тыйын", priceAutoHint: "Кабыл алууда автоматтык жаңыланат",
    purchaseLoss: "Сатып алуудагы жоготуу (демейки)", purchaseLossHint: "Сатып алуу сабына коюлат: сөөк, тазалоо, эритүү", purchaseLossQtyHint: "Туруктуу: ар бир сатып алуудан ушунча {{unit}} жоготулат (таңгак, муз)", waste: "Демейки калдык, %", wasteHint: "ТТКга коюлат", barcodes: "Штрихкоддор", barcodesHint: "Үтүр аркылуу",
    density: "Тыгыздыгы, г/мл", densityHint: "ТТКда суюктуктар үчүн граммды көрсөтүү үчүн керек (жана тескерисинче)",
    shelfLife: "Жарактуулук мөөнөтү, күн", minStock: "Минималдуу калдык", minStockHint: "{{unit}} менен — билдирүүлөр үчүн",
    allergensHint: "Меню позициялары ингредиенттердин аллергендерин мурастайт", productionRecipe: "Өндүрүш ТТКсы",
    types: { ingredient: "Ингредиент", goods: "Товар", semi_finished: "Жарым фабрикат", packaging: "Таңгак", consumable: "Сарпталуучу" },
  },
  costing: {
    descriptionGross: "Food cost максаты — {{pct}}%. Өздүк нарк брутто жана учурдагы сатып алуу баалары боюнча.",
    descriptionNet: "Food cost максаты — {{pct}}%. Өздүк нарк нетто жана учурдагы сатып алуу баалары боюнча.",
    settingsTitle: "Калькуляциянын жөндөөлөрү", settingsSaved: "Жөндөөлөр сакталды",
    target: "Максаттуу food cost, %", targetHint: "Максаттан жогорку позициялар белгиленет; сунушталган баа ушундан эсептелет",
    rounding: "Сунушталган бааны тегеректөө", base: "Ингредиенттердин наркын эсептөө", baseShort: "Эсептөө негизи", net: "Нетто",
    overTarget: "Максаттан жогору · {{count}}", noRecipe: "ТТКсыз · {{count}}", costShort: "Өздүк нарк", noRecipeBadge: "ТТК жок", noPrices: "баалар жок",
    margin: "Маржа", markup: "Үстөк баа", recommended: "Сунушталган баа",
    empty: "Позициялар жок", emptyHint: "Меню позицияларын кошуп, алар үчүн ТТК түзүңүз.",
    incompleteNote: "* — өздүк нарк толук эмес: айрым ингредиенттердин сатып алуу баасы жок.",
  },
  upload: {
    photo: "Сүрөт", chooseImage: "Сүрөт тандаңыз", tooLarge: "Файл өтө чоң",
    drop: "Сүрөттү сүйрөп келиңиз же тандоо үчүн басыңыз", formats: "JPEG, PNG, WebP, HEIC · 10 МБ чейин", replace: "Алмаштыруу", remove: "Алып салуу",
  },
  tables: {
    description: "Учурдагы филиалдын зал планы, столдордун абалы жана QR-коддор.",
    status: { free: "Бош", occupied: "Бош эмес", awaiting_payment: "Төлөм күтөт", reserved: "Брондолгон", cleaning: "Тазалоо", unavailable: "Жеткиликсиз" },
    hallTypes: { hall: "Зал", vip: "VIP", terrace: "Терраса", room: "Бөлмө", banquet: "Банкет", bar: "Бар" },
    shapes: { square: "Чарчы", rect: "Тик бурчтук", round: "Тегерек" },
    planOf: "«{{name}}» залынын планы", tableAria: "Стол {{number}}, орундар: {{count}}, {{status}}", seatsShort: "{{count}} орун",
    hall: "Зал", newHall: "Жаңы зал", hallPlaceholder: "Негизги зал", createHall: "Зал түзүү",
    noHalls: "Залдар азырынча жок", noHallsHint: "Зал түзүп, столдорду жайгаштырыңыз — официанттар менен кассирлер столду пландан тандашат.",
    table: "Стол {{number}}", tableShort: "Стол", newTable: "Жаңы стол", tableStatus: "Столдун абалы",
    number: "Номери", seats: "Орундар", shape: "Формасы", width: "Туурасы", height: "Бийиктиги", rotation: "Буруу, °",
    gridTitle: "Кассадагы орду", gridHint: "Kafe Coco кассасындагы зал схемасынын торундагы столдун орду. Бош калса — касса өзү жайгаштырат.", gridRow: "Катар", gridColumn: "Мамыча", gridSpan: "Туурасы, мамыча",
    nameOptional: "Аталышы (милдеттүү эмес)", namePlaceholder: "Терезенин жанында", isActive: "Стол колдонулат",
    qr: "Столдун QR-коду", copy: "Көчүрүү", linkCopied: "Шилтеме көчүрүлдү", qrSticker: { open: "QR-код", title: "{{number}}-стол QR-коду", preview: "Стол үчүн чаптама", print: "Басып чыгаруу", png: "PNG жүктөө", table: "Стол", hintOrder: "Меню, буйрутма жана официантты чакыруу", hintMenu: "Мекеменин менюсу" },
    regenerate: "Кайра чыгаруу", regenerateTitle: "QR кайра чыгарылсынбы?", regenerateHint: "Эски наклейкалар иштебей калат.",
    deleteTable: "{{number}}-стол өчүрүлсүнбү?", planSaved: "Зал планы сакталды",
    view: "Көрүнүш", plan: "План", list: "Тизме", savePlan: "Планды сактоо", arrange: "Жайгаштыруу",
    renameHall: "Залдын атын өзгөртүү", deleteHall: "Залды өчүрүү", deleteHallTitle: "«{{name}}» залы өчүрүлсүнбү?", deleteHallHint: "Залдын столдору да өчүрүлөт.",
    statuses: "Абалдар", dragHint: "Столдорду чычкан же манжа менен сүйрөңүз. Тор — {{grid}} бирдик.",
    noTables: "Залда столдор жок", addTable: "Стол кошуу",
  },
  orders: {
    payments: "Төлөмдөр",
    refunds: "Кайтаруулар",
    refund: "Кайтаруу",
    refundTitle: "{{n}} заказы боюнча кайтаруу",
    refundAmount: "Кайтаруу суммасы",
    refundReason: "Кайтаруунун себеби",
    refundPayment: "Төлөм",
    refundAvailable: "Кайтарууга болот: {{amount}}",
    refundDone: "Кайтаруу катталды",
    paidSum: "Төлөндү",
    refundedSum: "Кайтарылды",
    tax: "Салык",
    taxIncluded: "Анын ичинде салык",
    methods: {
      qr: "QR",
      credit: "Карызга",
      cash: "Накталай",
      card: "Карта",
      deposit: "Банкет депозити",
    },
    anyPayment: "Төлөмгө байланышсыз",
    title: "Заказдар",
    description: "Филиалдын заказдары: ачык жана тарых.",
    open: "Ачык",
    all: "Баары",
    number: "Номер",
    dailyNo: "№{{n}}",
    type: "Түрү",
    table: "Стол",
    tableN: "Стол {{n}}",
    items: "Позициялар",
    total: "Сумма",
    opened: "Ачылган",
    empty: "Заказ жок",
    emptyHint: "Жаңы заказдар кассада түзүлөт",
    history: "Тарых",
    search: "Номер же коноктун аты",
    guests: "Коноктор",
    guest: "Конок",
    comment: "Заказга комментарий",
    cancel: "Заказды жокко чыгаруу",
    cancelTitle: "{{n}} заказын жокко чыгарасызбы?",
    cancelHint: "Жөнөтүлгөн позициялар жокко чыгарылат, ашканага билдирүү барат.",
    reason: "Себеп",
    reasonComment: "Комментарий",
    void: "Жокко чыгаруу",
    voidTitle: "«{{name}}» жокко чыгарасызбы?",
    voidSentHint: "Позиция ашканада — ашпозчуга билдирүү барат.",
    cancelled: "Заказ жокко чыгарылды",
    voided: "Позиция жокко чыгарылды",
    details: "Заказ {{n}}",
    openInPos: "Кассада ачуу",
    events: {
      line_added: "Позиция кошулду",
      qty_changed: "Саны өзгөрдү",
      payment: "Төлөм",
      refund: "Кайтаруу",
      "order.update": "Өзгөртүлдү",
      created: "Түзүлдү",
      items_added: "Позициялар кошулду",
      item_updated: "Позиция өзгөрдү",
      item_voided: "Позиция жокко чыгарылды",
      sent_to_kitchen: "Ашканага жөнөтүлдү",
      cancelled: "Жокко чыгарылды",
      transferred: "Башка столго которулду",
      updated: "Өзгөрдү",
    },
    statuses: {
      draft: "Долбоор",
      open: "Ачык",
      confirmed: "Ырасталды",
      cooking: "Даярдалууда",
      ready: "Даяр",
      served: "Берилди",
      paid: "Төлөндү",
      completed: "Жабылды",
      cancelled: "Жокко чыгарылды",
      refunded: "Кайтарылды",
      partially_refunded: "Жарым-жартылай кайтарылды",
    },
    itemStatuses: {
      new: "Жаңы",
      sent: "Ашканада",
      accepted: "Кабыл алынды",
      cooking: "Даярдалууда",
      ready: "Даяр",
      served: "Берилди",
      voided: "Жокко чыгарылды",
      returned: "Кайтарылды",
    },
    types: {
      dine_in: "Залда",
      takeaway: "Алып кетүү",
      delivery: "Жеткирүү",
      self_service: "Өзүн-өзү тейлөө",
      pickup: "Өзү алып кетүү",
    },
    reasons: {
      guest_mistake: "Коноктун катасы",
      waiter_mistake: "Кызматкердин катасы",
      long_wait: "Узак күтүү",
      out_of_stock: "Жок",
      quality: "Сапат",
      other: "Башка",
    },
  },
  pos: {
    transferWaiter: "Официантка өткөрүү",
    transfer: "Өткөрүү",
    noWaiters: "Официанттар жок: аларды «Залдар боюнча официанттар» бөлүмүндө зоналарга кошуңуз же сменаны белгилеңиз.",
    waiter: "Официант",
    pickWaiter: "Официантты тандаңыз",
    waiterIs: "Официант: {{name}}",
    transferred: "Стол өткөрүлдү",
    promotions: "Акциялар",
    promotionsHint: "Ылайыктуу акциялар автоматтык эсептелет жана буйрутма өзгөргөндө кайра эсептелет.",
    applyPromotions: "Акциялар",
    promotionsOn: "Акциялар күйгүзүлгөн",
    promotionsSwitch: "Акцияларды колдонуу",
    promotionsSwitchHint: "Буйрутмадан бардык акцияларды алып салуу үчүн өчүрүңүз",
    promoCodes: "Промокоддор",
    promoCodesHint: "Үтүр менен, мисалы WELCOME10",
    promoCodeInvalid: "Промокод табылган жок же иштебейт",
    promotionsSaved: "Акциялар кайра эсептелди",
    discount: "Арзандатуу",
    discountHint: "Арзандатууга уруксат берилген позицияларга. Лимиттен жогору — менеджердин PIN-коду керек.",
    applyDiscount: "Колдонуу",
    removeDiscount: "Арзандатууну алып салуу",
    discountKind: "Арзандатуунун түрү",
    discountPercent: "Пайыз",
    discountAmount: "Сумма",
    discountReason: "Себеби",
    discountValueRequired: "Арзандатуунун өлчөмүн көрсөтүңүз",
    discountPreview: "Арзандатуу",
    discountSaved: "Арзандатуу колдонулду",
    addDiscount: "Арзандатуу кошуу",
    changeDiscount: "Арзандатууну өзгөртүү",
    discountReasons: {
      regular: "Туруктуу конок",
      compliment: "Комплимент",
      staff: "Кызматкер",
      promo: "Акция",
      complaint: "Коноктун арызы",
      other: "Башка",
    },
    pickCustomer: "Кардар",
    clearCustomer: "Кардарды алып салуу",
    noShift: "Касса сменасы ачылган эмес",
    noShiftHint: "Кассирден же башкаруучудан веб-кассанын сменасын ачууну сураныңыз.",
    creditNoCustomer: "Карызга сатуу үчүн кардарды тандаңыз",
    creditOverLimit: "Кредит жеткиликсиз же лимит ашты. Жеткиликтүү: {{left}}",
    creditInfo: "{{name}}: карызы {{debt}}, лимити {{limit}}",
    reference: "RRN же акыркы 4 сан",
    referenceHint: "Милдеттүү эмес — терминал менен салыштыруу үчүн",
    payTitle: "{{n}} заказын төлөө",
    due: "Төлөнө турган",
    method: "Төлөө ыкмасы",
    amount: "Төлөм суммасы",
    received: "Коноктон алынды",
    tip: "Чайпул",
    change: "Кайтарым",
    payConfirm: "{{amount}} кабыл алуу",
    paidDone: "Заказ төлөндү",
    partPaid: "{{total}} ичинен {{paid}} төлөндү",
    tax: "Салык",
    taxIncluded: "Анын ичинде салык",
    exact: "Кайтарымсыз",
    notEnough: "Алынган сумма төлөмдөн аз",
    paidAlready: "Төлөндү",
    printReceipt: "Чек басып чыгаруу",
    title: "Касса",
    newOrder: "Жаңы заказ",
    openOrders: "Ачык заказдар",
    orderHistory: "Заказдардын тарыхы",
    reservations: "Брондор",
    noOpen: "Ачык заказ жок",
    searchMenu: "Менюдан издөө…",
    orderDetails: "Заказдын чоо-жайы",
    orderInfo: "Заказ жөнүндө",
    customerName: "Коноктун аты",
    selectTable: "Столду тандаңыз",
    tableN: "Стол {{n}}",
    addNote: "Заказга эскертме",
    notePlaceholder: "Заказга эскертме жазыңыз…",
    addToOrder: "Заказга кошуу",
    empty: "Менюдан позиция кошуңуз",
    subtotal: "Аралык сумма",
    total: "Жалпы",
    send: "Ашканага",
    sendN: "Ашканага · {{n}}",
    sent: "Ашканага жөнөтүлдү",
    precheck: "Алдын ала чек",
    pay: "Төлөө",
    paySoon: "Төлөм кабыл алуу кийинки жаңыртууда пайда болот",
    stopped: "Стоп",
    left: "Калды {{n}}",
    modifiersTitle: "Опцияларды тандаңыз",
    required: "милдеттүү",
    upTo: "{{n}} чейин",
    chooseOne: "бирөөнү тандаңыз",
    quantity: "Саны",
    itemComment: "Позицияга комментарий",
    weight: "Салмагы", weightHint: "Баасы 1 кг үчүн {{price}} — таразага тартып, салмагын киргизиңиз", changeWeight: "Салмагын өзгөртүү", weightLine: "{{weight}} × {{price}}/кг", saveWeight: "Салмагын сактоо",
    add: "Кошуу · {{price}}",
    variant: "Өлчөм",
    course: "{{n}}-курс",
    guestsN: "Коноктор: {{n}}",
    back: "Артка",
    switchUser: "Колдонуучуну алмаштыруу",
    online: "Онлайн",
    reconnecting: "Кайра туташууда…",
    offline: "Байланыш жок",
    orderReady: "№{{n}} заказ даяр",
    cart: "Заказ · {{n}}",
    tableSelect: "Стол тандоо",
    noHalls: "Зал жок — «Залдар жана столдор» бөлүмүндө түзүңүз",
    noOrder: "Заказ тандалган жок",
    quick: {
      noOnion: "пиязсыз",
      spicy: "ачуураак",
      noIce: "музсуз",
      hot: "ысыгыраак",
    },
  },
  kds: {
    title: "Ашкана",
    station: "Станция",
    chooseStation: "Станцияны тандаңыз",
    noStations: "Станция жок — «Ашкана станциялары» бөлүмүн ачыңыз",
    new: "Жаңы",
    cooking: "Даярдалууда",
    ready: "Даяр",
    start: "Баштоо",
    done: "Даяр",
    serve: "Берүү",
    recall: "Кайтаруу",
    accept: "Кабыл алуу",
    empty: "Заказ жок",
    emptyHint: "Жаңы заказдар бул жерде автоматтык түрдө чыгат",
    minutes: "{{n}} мүн",
    soundOn: "Үн күйүк",
    soundOff: "Үндү күйгүзүү",
    keyboardHint: "1–9 — тикетти тандоо, Enter — кийинки кадам",
    recalled: "Кайра ишке кайтарылды",
    print: "Басып чыгаруу",
    repeatReadySound: "Даярдык үнүн кайталоо",
    exit: "Чыгуу",
    newTicket: "Жаңы заказ №{{n}}",
    managerLogin: "Менеджердин кирүүсү",
  },
  readyBoard: {
    title: "Заказдардын даярдыгы",
    preparing: "Даярдалууда",
    ready: "Даяр — алып кетиңиз",
    empty: "Азырынча заказ жок",
    fullscreen: "Толук экран",
    background: "Таблонун фону",
    backgrounds: { white: "Ак", warm: "Жылуу ак", gray: "Ачык боз", graphite: "Графит" },
    palette: "Түс палитрасы",
    palettes: { coca: "Coca", ocean: "Океан", forest: "Изумруд", violet: "Кызгылт көк" },
    voice: "Үн менен айтуу",
    enableVoice: "Үндү күйгүзүү",
    speech: "{{number}}-заказ даяр",
    speechNamed: "{{name}}, сиздин {{number}}-заказыңыз даяр",
  },
  stations: {
    "warehouse": "Станциянын кампасы",
    "warehouseHint": "Бул станциянын позицияларынын сатуусу тандалган кампадан эсептен чыгат",
    "mainWarehouse": "Филиалдын негизги кампасы",
    title: "Ашкана станциялары",
    description: "Ашкананын цехтери жана экрандары: заказдын позициялары кайда барат.",
    add: "Станция кошуу",
    type: "Түрү",
    norm: "Даярдоо нормасы, мүн",
    normHint: "Нормадан кийин тикет сары, 1,5 нормадан кийин кызыл болот",
    simple: "Жөнөкөй режим",
    simpleHint: "Кофейня: тикет бир басуу менен «Даяр»",
    isDefault: "Демейки",
    defaultHint: "Станциясы жок позициялар ушул жерге барат",
    active: "Активдүү",
    activeTickets: "Активдүү тикеттер: {{n}}",
    empty: "Станция жок",
    emptyHint: "Ашканага биринчи жөнөтүүдө «Ашкана» станциясы түзүлөт",
    deleteTitle: "«{{name}}» станциясын өчүрөсүзбү?",
    itemStation: "Ашкана станциясы",
    itemStationHint: "Бош — филиалдын демейки станциясы",
    types: {
      hot: "Ысык цех",
      cold: "Муздак цех",
      bar: "Бар",
      coffee: "Кофе",
      bakery: "Нан-токоч",
      pizza: "Пицца",
      grill: "Гриль",
      dessert: "Десерттер",
      packing: "Таңгактоо",
      expo: "Берүү",
    },
  },
  print: {
    document: "Документ",
    print: "Басып чыгаруу",
    savePdf: "PDF сактоо",
    excel: "Excel жүктөө",
    pdfHint: "Басып чыгаруу терезесинде «PDF катары сактоо» тандаңыз",
    printedAt: "Басылды",
    precheck: "Алдын ала чек",
    notFiscal: "Фискалдык документ эмес",
    table: "Стол",
    guests: "Коноктор",
    total: "Жалпы",
    thanks: "Рахмат!",
    printed: "Басып чыгарууга жөнөтүлдү",
    usb: {
      title: "Чек принтери (USB)",
      description: "Чектер, алдын ала чектер, ашкана тикеттери жана смена отчеттору басып чыгаруу терезесиз түз принтерге чыгат. Жөндөө ушул түзмөктө сакталат.",
      menu: "Чек принтери",
      pick: "USB-принтерди тандоо",
      change: "Башка",
      connected: "Принтер туташты",
      savedHere: "Ушул түзмөккө туташкан",
      howTo: "Чек принтерин (ESC/POS) USB кабели менен ушул компьютерге туташтырып, төмөнкү баскычты басыңыз — браузер түзмөктөрдүн тизмесин көрсөтөт.",
      enabled: "USB-принтерге басып чыгаруу",
      enabledHint: "Өчүк — браузердин терезеси аркылуу басып чыгаруу",
      paper: "Тасманын туурасы",
      mm: "{{n}} мм",
      cut: "Чектен кийин тасманы кесүү",
      test: "Сыноо басып чыгаруу",
      testTitle: "Сыноо басып чыгаруу",
      drawer: "Акча кутусун ачуу",
      forget: "Ажыратуу",
      busyHint: "Принтер жооп бербесе, Windows'то ал өз драйвери менен бош эмес: драйверди WinUSB'га алмаштырыңыз (Zadig программасы). Linux'та usblp модулун өчүрүңүз.",
      unsupportedTitle: "Браузер USB аркылуу басып чыгарууну колдобойт",
      unsupported: "Компьютерде Google Chrome же Microsoft Edge жана https дареги керек. Safari, Firefox жана iPhone'до — браузердин терезеси аркылуу.",
      errors: {
        notFound: "USB-принтер табылган жок: кабелди жана кубатты текшериңиз. Басып чыгаруу — браузердин терезеси аркылуу.",
        busy: "Принтерди системанын драйвери ээлеп турат. Windows'то драйверди WinUSB'га (Zadig) алмаштырыңыз, Linux'та usblp'ни өчүрүңүз.",
        noEndpoint: "Бул түзмөк чек принтерине окшобойт.",
        notConfigured: "USB-принтер тандалган жок.",
        cancelled: "Принтер тандалган жок.",
        denied: "Браузер бул баракта USB'га кирүүгө тыюу салды.",
        failed: "USB-принтерге басып чыгаруу мүмкүн болгон жок: {{message}}",
      },
    },
  },
  reports: {
    title: "Сатуу отчёту",
    description: "Мезгил ичиндеги төлөмдөр жана кайтаруулар боюнча киреше, заказдар, орточо чек жана топ тамактар.",
    from: "Баштап",
    to: "Чейин",
    groupBy: "Топтоо",
    byHour: "Саат боюнча",
    byDay: "Күн боюнча",
    revenue: "Киреше",
    revenueHint: "Төлөмдөр − кайтаруулар",
    orders: "Заказдар",
    avgCheck: "Орточо чек",
    refunds: "Кайтаруулар",
    tips: "Чайпул",
    tax: "Салык",
    cancelled: "Жокко чыгарылды",
    payments: "Төлөмдөр",
    cash: "Накталай",
    card: "Карта",
    chart: "Убакыт боюнча киреше",
    top: "Топ тамактар",
    product: "Тамак",
    qty: "Саны",
    sum: "Сумма",
    noData: "Мезгил ичинде сатуу жок",
    mismatches: "Менюдагы баадан башка баада сатылды",
    mismatchHint: "Касса заказды өз баасы менен кабыл алды (мисалы, меню жаңыланганга чейин оффлайн). Сервер мындай заказдарды кайра эсептебейт.",
    menuPrice: "Менюдагы баа",
    soldPrice: "Сатуу баасы",
    lines: "Саптар",
    presets: {
      today: "Бүгүн",
      yesterday: "Кечээ",
      week: "7 күн",
      month: "30 күн",
    },
  },
  reservations: {
    title: "Брондоо",
    description: "Столдорду брондоо: касса аларды дароо көрөт жана коноктор келерден бир саат мурун столду белгилейт.",
    add: "Жаңы брон",
    edit: "Брон",
    customer: "Коноктун аты",
    phone: "Телефон",
    guests: "Коноктор",
    date: "Күнү",
    time: "Убакыт",
    duration: "Узактыгы",
    startsAt: "Башталышы",
    endsAt: "Аягы",
    tables: "Столдор",
    note: "Комментарий",
    status: "Абалы",
    statuses: {
      booked: "Брондолду",
      seated: "Коноктор келди",
      completed: "Аяктады",
      cancelled: "Жокко чыгарылды",
      no_show: "Келишкен жок",
    },
    empty: "Брон жок",
    emptyHint: "Брон түзүңүз — касса аны көрүп, столду белгилейт",
    cancel: "Бронду жокко чыгаруу",
    cancelTitle: "«{{name}}» бронун жокко чыгарасызбы?",
    cancelled: "Брон жокко чыгарылды",
    saved: "Брон сакталды",
    seat: "Коноктор келди",
    noShow: "Келишкен жок",
    complete: "Аяктоо",
    conflict: "Брон башка түзмөктө өзгөртүлдү — маалымат жаңыланды",
    minutes: "{{n}} мүн",
    hours: "{{n}} саат",
    noTables: "Столсуз",
    prevDay: "Мурунку күн",
    nextDay: "Кийинки күн",
    today: "Бүгүн",
    guestsN: "{{n}} конок",
  },
  orderTypes: {
    dine_in: "Залда",
    takeaway: "Алып кетүү",
    delivery: "Жеткирүү",
    self_service: "Өзүн-өзү тейлөө",
    pickup: "Өзү алып кетет",
  },
  expenseCategories: {
    rent: "Ижара",
    salary: "Айлык",
    utilities: "Коммуналдык",
    repair: "Оңдоо",
    marketing: "Жарнама",
    transport: "Транспорт",
    household: "Чарба буюмдары",
    taxes: "Салыктар",
    other: "Башка",
  },
  writeoffReasons: {
    spoilage: "Бузулган",
    expired: "Мөөнөтү өткөн",
    cooking_error: "Даярдоодо ката",
    breakage: "Сынган",
    staff_meal: "Кызматкерлердин тамагы",
    tasting: "Даамын татуу",
    internal_use: "Ички муктаждык",
    unknown: "Башка",
  },
  insights: {
    depositNote: "Банкет депозиттери: келди {{dep}}, буйрутмаларга эсептелди {{applied}}.",
    laborCost: "Эмгек акы фонду", laborHint: "Айлык эсептөөлөрү боюнча эсептелди", laborPct: "Labor cost {{pct}}%", laborReplaced: "Кол менен киргизилген «Айлык» чыгымдарынын ордуна ({{sum}})", salaryPaid: "Айлык төлөндү", tipPoolNote: "{{n}} күндүн чайпулу пул менен бөлүштүрүлгөн — суммалар заказдардан эмес, бөлүштүрүүдөн алынды.", profitHint: "Киреше − өздүк нарк − эсептен чыгаруу − чыгымдар − эмгек акы",
    methods: { cash: "Накталай", card: "Карта", qr: "QR", credit: "Карызга", deposit: "Банкет депозити" }, debtNote: "Келди = киреше − карызга сатылган ({{credit}}) + төлөнгөн карыздар ({{repaid}}).",
    title: "Кафе аналитикасы",
    description: "Мезгил ичиндеги киреше, чыгымдар, пайда, тамактардын сатылышы, азыктардын сарпталышы, эсептен чыгаруулар жана официанттар.",
    period: "Мезгил",
    presets: {
      today: "Бүгүн",
      yesterday: "Кечээ",
      week: "7 күн",
      month: "Ушул ай",
    },
    tabs: {
      abc: "ABC-анализ",
      matrix: "Меню матрицасы",
      costs: "Food жана labor cost",
      heatmap: "Саат боюнча",
      branches: "Филиалдар",
      finance: "Финансы",
      items: "Тамактар",
      categories: "Категориялар",
      products: "Азыктар",
      writeoffs: "Эсептен чыгаруу",
      waiters: "Официанттар",
    },
    byDays: "Күндөр боюнча",
    date: "Күнү",
    noData: "Мезгил үчүн маалымат жок",
    noSales: "Мезгил ичинде сатуу жок",
    revenue: "Киреше",
    revenueHint: "Кайтаруулар: {{refunds}} · чайпул: {{tips}}",
    costOfSales: "Өздүк нарк",
    foodCost: "Food cost {{pct}}%",
    costHint: "ТТК боюнча азыктар",
    expenses: "Чыгымдар",
    expensesHint: "Ижара, айлык жана башкалар",
    profit: "Пайда",
    margin: "Маржа {{pct}}%",
    grossProfit: "Дүң пайда",
    grossProfitHint: "Киреше − өздүк нарк",
    purchases: "Сатып алуулар",
    writeoffs: "Эсептен чыгаруу",
    cashLeft: "Калган акча",
    cashLeftHint: "Келди − сатып алуулар − чыгымдар",
    noRecipeTitle: "Бардык тамактарда ТТК жок",
    noRecipeHint: "Өздүк нарк жана азык сарпталышы эсептелген жок: {{items}}. Менюда техкарталарды толтуруңуз.",
    whereFrom: "Киреше кайдан келди",
    whereFromHint: "Меню категориялары боюнча (позициялардын суммасы)",
    noCategory: "Категориясыз",
    whereTo: "Акча кайда кетти",
    whereToHint: "Чыгымдар, сатып алуулар жана эсептен чыгаруулар",
    noExpenses: "Мезгил ичинде чыгым жок",
    byOrderType: "Заказдын түрү боюнча",
    ordersN: "заказ: {{n}}",
    byMethod: "Төлөө ыкмасы боюнча",
    moneyFlow: "Акчанын кыймылы",
    moneyFlowHint: "Канча келди, канча кетти жана канча калды",
    cameIn: "Келди",
    purchasesPaid: "Сатып алууга төлөндү",
    supplierCreditNote: "Жеткирүүчүлөрдөн карызга сатып алынды: {{amount}} — төлөгөндө акчадан чыгат",
    profitByDay: "Күндөр боюнча пайда",
    categoriesQty: "Категориялар боюнча сатылды",
    categoriesHint: "Ар бир категорияда канча сатылды; күндөр боюнча көрүү үчүн сапты басыңыз",
    pcs: "даана",
    category: "Категория",
    sold: "Сатылды",
    perDay: "Күнүнө орточо",
    itemsTitle: "Тамактар боюнча сатуу",
    itemsHint: "Күндөр боюнча сатууну көрүү үчүн тамакты басыңыз",
    searchItem: "Тамак же категорияны издөө",
    purchased: "Сатып алынды",
    usedCost: "Сарпталган сумма",
    usedHint: "Сатылган тамактардын ТТКсы боюнча",
    writtenOff: "Эсептен чыгарылды",
    topUsed: "Эң көп сарпталат",
    topUsedHint: "Сарпталгандын наркы боюнча",
    noUsage: "Мезгил ичинде азык кыймылы жок",
    productsTitle: "Азыктар",
    searchProduct: "Азыкты издөө",
    product: "Азык",
    used: "Сарпталды",
    noWriteoffs: "Мезгил ичинде эсептен чыгаруу жок",
    documents: "Документтер",
    byReason: "Себептер боюнча",
    docsN: "{{n}} док.",
    byProduct: "Азыктар боюнча",
    reasons: "Себептер",
    noWaiter: "Официантсыз",
    waitersRevenue: "Официанттар боюнча киреше",
    waiter: "Официант",
    guests: "Коноктор",
    itemsSold: "Позициялар",
    serviceTime: "Тейлөө убактысы",
    minutes: "{{n}} мүн",
    cancels: "Жокко чыгаруу / өчүрүү",
    pro: {
      locked: "«Отчёттор (кеңейтилген)» кошумчасы менен жеткиликтүү",
      lockedHint: "ABC-анализ, меню матрицасы, food cost жана labor cost, саат боюнча сатуулар жана филиалдарды салыштыруу — эмне киреше берет, эмнени алып салуу же кымбаттатуу керек.",
      export: "CSV жүктөө",
      abcBy: "Көрсөткүч",
      abcByOptions: {
        revenue: "Тамактар киреше боюнча",
        margin: "Тамактар маржа боюнча",
        qty: "Тамактар саны боюнча",
        products: "Продуктылар чыгым боюнча",
        customers: "Кардарлар сумма боюнча",
      },
      abcClass: "{{c}} классы",
      abcClassHint: "{{count}} поз. · {{value}}",
      pareto: "Pareto: жогорку 20%",
      paretoHint: "{{count}} мыкты позициянын үлүшү",
      abcHint: "A — алгачкы 80%, B — кийинки 15%, C — калганы. C классындагылар — алмаштырууга талапкерлер.",
      name: "Аталышы",
      value: "Көрсөткүч",
      share: "Үлүшү",
      cumulative: "Топтолгон",
      class: "Класс",
      noRecipe: "техкарта жок",
      matrixHint: "Популярдуу — сатуудагы үлүшү {{pop}} жогору; пайдалуу — порциянын маржасы {{margin}} жогору. Өздүк нарк — техкарталар боюнча.",
      matrixNoRecipes: "Техкарталарды толтуруңуз — аларсыз маржа эсептелбейт.",
      quad: {
        star: "Жылдыздар",
        plowhorse: "Иш аттары",
        puzzle: "Табышмактар",
        dog: "Иттер",
      },
      quadHint: {
        star: "Популярдуу жана пайдалуу — сапатын жана менюдагы ордун сактаңыз.",
        plowhorse: "Жакшы сатылат, бирок пайда аз — баасын көтөрүңүз же өздүк наркын азайтыңыз.",
        puzzle: "Пайдалуу, бирок аз сатылат — жарнамалаңыз: сүрөт, менюдагы орун, официанттын кеңеши.",
        dog: "Аз сатылат жана пайда аз — алмаштырууга талапкерлер.",
      },
      matrixRow: "{{qty}} даана · маржа {{margin}} · fc {{fc}}",
      withoutRecipe: "Техкартасыз — матрицада жок",
      foodCost: "Food cost",
      laborCost: "Labor cost",
      primeCost: "Prime cost",
      primeCostHint: "Өздүк нарк + эмгек акы",
      perLaborHour: "Эмгек саатына киреше",
      laborHours: "Жумуш сменалары боюнча {{hours}} саат",
      foodCostByDays: "Күндөр боюнча food cost",
      byCategory: "Категориялар боюнча",
      revenue: "Киреше",
      hours: "Саат",
      branchesTitle: "Филиалдарды салыштыруу",
      branchesTotal: "Баары: {{revenue}}, буйрутмалар {{orders}}, пайда {{profit}}",
      orders: "Буйрутмалар",
      avgCheck: "Орточо чек",
      profit: "Пайда",
      heatmapTitle: "Апта күндөрү жана сааттар боюнча киреше",
      heatmapHint: "Канчалык караңгы — ошончолук киреше көп. Убакыт — мекеменин жергиликтүү убактысы.",
      ordersN: "буйрутмалар: {{count}}",
      less: "аз",
      more: "көп",
      heatmapDays: "{{from}} — {{to}}",
      weekdays: {
        "1": "Дш",
        "2": "Шш",
        "3": "Шр",
        "4": "Бш",
        "5": "Жм",
        "6": "Иш",
        "7": "Жк",
      },
    },
  },
  expenses: {
    title: "Чыгымдар",
    description: "Ижара, айлык, коммуналдык жана башка чыгымдар. Азык сатып алуу — «Сатып алуулар» бөлүмүндө.",
    add: "Чыгым кошуу",
    editTitle: "Чыгымды өзгөртүү",
    saved: "Чыгым сакталды",
    category: "Категория",
    date: "Күнү",
    amount: "Сумма",
    comment: "Комментарий",
    commentPlaceholder: "Мисалы: октябрдын ижарасы",
    deleteTitle: "«{{name}}» чыгымын {{sum}} өчүрөсүзбү?",
    allCategories: "Бардык категориялар",
    total: "Жыйынтык",
    empty: "Азырынча чыгым жок",
    emptyHint: "Чыгымдарды кошуңуз — алар финансылык отчетко жана пайдага кирет.",
  },
  inventory: {
    stockTitle: "Кампадагы калдыктар",
    stockDescription: "Филиалдын кампасында канча азык бар жана канча сумага. Сатуулар азыктарды техкарта боюнча автоматтык түрдө чегерет.",
    search: "Азык, артикул же штрихкод",
    onlyLow: "«Аз» жана «минуста» гана",
    showAll: "Кыймылы жок азыктар менен",
    quantity: "Калдык",
    minStock: "Минимум",
    value: "Наркы",
    totalValue: "Калдыктардын наркы",
    state: "Абалы",
    states: {
      ok: "Жетиштүү",
      low: "Аз",
      negative: "Минуста",
    },
    empty: "Калдыктар азырынча жок",
    emptyHint: "Сатып алууну же инвентаризацияны өткөрүңүз — калдыктар ушул жерде пайда болот.",
    card: "Кыймыл картасы",
    opening: "Башында",
    closing: "Аягында",
    incoming: "Кирүү",
    outgoing: "Чыгым",
    balance: "Кийинки калдык",
    operation: "Операция",
    when: "Качан",
    order: "заказ №{{n}}",
    noMovements: "Мезгил ичинде кыймыл жок",
    moveTypes: {
      "disassembly": "Бөлүү",
      "assembly": "Чогултуу",
      "return_to_supplier": "Жеткирүүчүгө кайтаруу",
      "transfer_out": "Которуу (чыгым)",
      "transfer_in": "Которуу (кириш)",
      "production": "Өндүрүш",
      receipt: "Сатып алуу",
      writeoff: "Чегерүү",
      consumption: "Сатуу",
      inventory_adjustment: "Инвентаризация",
      reversal: "Сторно",
      cost_adjustment: "Баа оңдоосу",
    },
    countsTitle: "Инвентаризация",
    countsDescription: "Азыктарды кайра саноо. Саноо учурундагы сатуулар эсепке алынат, айырма акт менен өткөрүлөт.",
    newCount: "Инвентаризацияны баштоо",
    newCountHint: "Системадагы калдык башталган учурда бекитилет, сатууну токтотпосо болот.",
    start: "Баштоо",
    scope: "Эмнени санайбыз",
    scopes: {
      "location": "Сактоо орду",
      all: "Бардык азыктар",
      category: "Категория",
      products: "Тандалган азыктар",
    },
    pickProducts: "Азыктарды тандаңыз",
    blind: "Сокур",
    blindHint: "Санаган адам системадагы калдыкты көрбөйт",
    blindNote: "Сокур инвентаризация: системадагы калдык жана айырма жашырылган.",
    started: "№{{n}} инвентаризация башталды",
    countTitle: "№{{n}} инвентаризация",
    number: "Номер",
    status: "Статус",
    statuses: {
      counting: "Саноо жүрүүдө",
      posted: "Өткөрүлдү",
      cancelled: "Жокко чыгарылды",
    },
    counted: "Саналды",
    countedOf: "{{total}} ичинен {{n}} саналды",
    system: "Система боюнча",
    fact: "Факт",
    diff: "Айырма",
    shortage: "Жетишпестик",
    surplus: "Ашыкча",
    result: "Жыйынтык",
    onlyDiff: "Айырмалар гана",
    notCounted: "саналган жок",
    noDiff: "Айырма жок",
    saveCounts: "Санакты сактоо",
    savedCounts: "Санак сакталды",
    post: "Өткөрүү",
    postTitle: "№{{n}} инвентаризацияны өткөрөсүзбү?",
    postHint: "Саналбаган саптар өзгөрбөйт. Жетишпестик партиялар боюнча чегерилет, ашыкча акыркы сатып алуу баасы менен кирилет.",
    posted: "Инвентаризация өткөрүлдү",
    cancel: "Жокко чыгаруу",
    cancelTitle: "№{{n}} инвентаризацияны жокко чыгарасызбы?",
    cancelHint: "Калдыктар өзгөрбөйт.",
    cancelled: "Инвентаризация жокко чыгарылды",
    emptyCounts: "Инвентаризация али болгон эмес",
    emptyCountsHint: "Биринчисин баштаңыз — ал кампанын баштапкы калдыктарын да коёт.",
  },
  stockDocs: {
    backToList: "Сатып алууларга",
    receiptPageDescription: "Эмне, канча жана канчадан сатып алдыңыз. Кабыл алуудагы жоготуу (сөөк, тазалоо, эритүү) кампага кирүүнү азайтат — бирдиктин баасы таза салмактан эсептелет.",
    newProduct: "Жаңы азык",
    createProduct: "«{{name}}» азыгын кошуу",
    loss: "Жоготуу",
    lossMode: "Жоготуу пайыз же сан менен",
    lossQty: "Жоготуу",
    toStock: "Кампага",
    wasPrice: "мурда {{price}}",
    "expiresAt": "Жарактуу",
    "expiresHint": "бош — продукттун сактоо мөөнөтү боюнча",
    receiptsTitle: "Сатып алуулар",
    writeoffsTitle: "Эсептен чыгаруу",
    receiptsDescription: "Эмне жана канчадан сатып алынды. Сатып алуу азыктын баасын жаңылайт — тамактын өздүк наркы ошондон эсептелет.",
    writeoffsDescription: "Бузулган, мөөнөтү өткөн жана башка себеп менен эсептен чыгарылган азыктар.",
    newReceipt: "Жаңы сатып алуу",
    newWriteoff: "Жаңы эсептен чыгаруу",
    post: "Өткөрүү",
    saved: "Документ өткөрүлдү",
    supplier: "Жеткирүүчү",
    supplierPlaceholder: "Жеткирүүчүнү тандаңыз же кошуңуз",
    dueTitle: "Төлөө мөөнөтүн жылдыруу",
    returnEmpty: "Канча кайтарарын көрсөтүңүз",
    returnFromReceipt: "Сатып алуу боюнча жеткирүүчүгө кайтаруу",
    returnReason: "Себеби: брак, туура эмес товар…",
    returnable: "{{bought}} ичинен {{qty}} кайтарууга болот",
    returnSum: "Кайтаруунун суммасы (сатып алуу баасы менен)",
    returnHint: "Товар ушул сатып алуунун партиясынан кампадан чыгат, жеткирүүчүгө карыз кайтаруу суммасына азаят; сатып алуу төлөнгөн болсо — сумма аванс болот.",
    returnToSupplier: "Жеткирүүчүгө кайтаруу",
    byReceipt: "сатып алуу боюнча",
    toPay: "Төлөөгө",
    price: "Баасы",
    returned: "Кайтарылды",
    settlements: "Төлөмдөр жана эсептешүүлөр",
    returnsTitle: "Сатып алуу боюнча кайтаруулар",
    returnsPageTitle: "Жеткирүүчүлөргө кайтаруу",
    returnsPageDescription: "Жеткирүүчүлөргө кайтарылган товар: кампадан сатып алуу баасы менен, сумма карызды азайтат же аванс болот",
    searchReturn: "Жеткирүүчү, продукт же комментарий",
    emptyReturns: "Жеткирүүчүлөргө кайтаруулар жок",
    allSuppliers: "Бардык жеткирүүчүлөр",
    newReturn: "Жеткирүүчүгө кайтаруу",
    return: "Жеткирүүчүгө кайтаруу",
    createSupplier: "«{{name}}» жеткирүүчүсүн кошуу",
    payment: "Төлөм",
    onCredit: "Карызга",
    mixedUnpaid: "Сатып алуу өткөрүлдү, бирок толук төлөнгөн жок — жеткирүүчүнүн карточкасынан кошумча төлөңүз.",
    dueDate: "Төлөө мөөнөтү",
    dueHint: "Жеткирүүчүнүн кечиктирүүсү: {{n}} күн",
    paymentAll: "Бардык сатып алуулар",
    paymentUnpaid: "Төлөнгөн эмес",
    reason: "Себеби",
    addLine: "Азык кошуу",
    byLastPrice: "акыркы сатып алуу баасы боюнча",
    byFifo: "өткөрүүдө партиялар боюнча (FIFO)",
    receipt: "Сатып алуу",
    writeoff: "Эсептен чыгаруу",
    products: "Азыктар",
    open: "Ачуу",
    deleteTitle: "{{date}} күнкү {{sum}} документти өчүрөсүзбү?",
    deleteHint: "Калдыктар өткөрүүгө чейинки абалга кайтат, документ отчёттордон чыгат. Азыктын баасы кайтарылбайт.",
    searchReceipt: "Жеткирүүчү, азык, комментарий",
    searchWriteoff: "Азык, комментарий",
    emptyReceipts: "Мезгил ичинде сатып алуу жок",
    emptyWriteoffs: "Мезгил ичинде эсептен чыгаруу жок",
    emptyHint: "Документтер азык жана финансы аналитикасына кирет.",
  },
  cash: {
    title: "Касса сменалары",
    description: "Веб-кассанын сменасы: майда акча, салуу жана алуу, X-отчёт жана Z-отчёт менен жабуу. Филиалдын бардык кассаларынын сменалар архиви.",
    webRegister: "Веб-касса",
    register: "Касса",
    shift: "Смена",
    open: "Сменаны ачуу",
    openHint: "Майда акчаны көрсөтүңүз — смена башындагы кассадагы накталай.",
    opened: "Смена ачылды",
    close: "Сменаны жабуу",
    closeHint: "Кассадагы накталайды санаңыз. Жабылгандан кийин Z-отчётту өзгөртүүгө болбойт.",
    closeAndPrint: "Жабуу жана Z басуу",
    closed: "Смена жабылды",
    noShift: "Смена ачылган эмес",
    noShiftHint: "Веб-кассада төлөм кабыл алуу үчүн сменаны ачыңыз.",
    statusOpen: "Ачык",
    statusClosed: "Жабык",
    status: "Абалы",
    openedAt: "Ачылды",
    closedAt: "Жабылды",
    cashier: "Кассир",
    float: "Майда акча",
    expected: "Күтүлгөн накталай",
    counted: "Иш жүзүндө",
    difference: "Айырма",
    diffComment: "Айырмага комментарий",
    diffCommentRequired: "Айырманын себебин жазыңыз",
    sales: "Сатуулар",
    refunds: "Кайтаруулар",
    net: "Киреше",
    checks: "Чектер",
    avgCheck: "Орточо чек",
    tips: "Чайпул",
    cancelled: "Жокко чыгарылган заказдар",
    debtRepaymentsCash: "Карыздарды накталай төлөө",
    operation: "Салуу / алуу",
    operationType: "Операция",
    operationDone: "Операция аткарылды",
    operations: "Операциялар",
    amount: "Сумма",
    reason: "Себеби",
    xReport: "X-отчёт",
    zReport: "Z-отчёт",
    printX: "X-отчётту басуу",
    printZ: "Z-отчётту басуу",
    archive: "Сменалар архиви",
    archiveEmpty: "Азырынча смена болгон жок",
    ops: {
      banquet_deposit: "Банкет депозити",
      banquet_refund: "Банкет депозитин кайтаруу",
      salary_payout: "Эмгек акы төлөө",
      supplier_payment: "Жеткирүүчүгө төлөм",
      supplier_refund: "Жеткирүүчүдөн акча кайтаруу",
      cash_in: "Салуу",
      cash_out: "Алуу",
      collection: "Инкассация",
      expense: "Кассадан чыгым",
      tip_payout: "Чайпул төлөө",
      debt_repayment: "Карызды төлөө",
      correction_in: "Түзөтүү +",
      correction_out: "Түзөтүү −",
    },
  },
  suppliers: {
    avgShort: "орточо {{price}}",
    payAdvance: "Аванс төлөө",
    refund: "Акчаны кайтаруу",
    refunded: "Акча кайтаруу өткөрүлдү",
    refundTitle: "Жеткирүүчү акча кайтарат: {{name}}",
    refundShort: "Жеткирүүчүдөн акча кайтаруу",
    refundCashHint: "Накталай ачык кассалык сменага түшөт",
    voidRefundTitle: "{{amount}} акча кайтарууну жокко чыгарасызбы?",
    voidRefundHint: "Жеткирүүчүдөгү аванс калыбына келет. Смена ачык болсо, накталай кассадан алынат.",
    products: "Товарлар",
    noProducts: "Бул жеткирүүчүдөн азырынча сатып алуу болгон эмес",
    bought: "Сатып алынды",
    returnedQty: "кайтарылды {{qty}}",
    lastPrice: "Акыркы баа",
    avgPrice: "Орточо баа",
    refundMethods: {
      cash: "Кассага накталай",
      bank: "Эсепке",
    },
    advance: "Аванс",
    advanceHint: "Карыздан көп төлөөгө болот — калдыгы кийинки сатып алууларга эсептелет",
    advanceAlert: "Жеткирүүчүдөгү аванс: {{amount}} — кийинки сатып алууга эсептелет",
    advanceLeft: "Аванс: {{amount}}",
    advancesNote: "Жеткирүүчүлөргө аванстар: {{amount}} — кийинки сатып алууларга эсептелет",
    statement: {
      open: "Салыштыруу акты",
      title: "Өз ара эсептешүүлөрдү салыштыруу акты",
      print: "Басып чыгаруу",
      period: "{{from}} – {{to}} мезгили",
      date: "Күнү",
      operation: "Операция",
      increase: "Сатып алуу, акча кайтаруу",
      decrease: "Төлөмдөр, товар кайтаруу",
      balance: "Сальдо",
      opening: "Башындагы сальдо",
      closing: "Аягындагы сальдо",
      turnover: "Мезгилдеги жүгүртүү",
      empty: "Мезгилде операциялар жок",
      weOwe: "Жеткирүүчүнүн пайдасына карыз: {{amount}}",
      theyOwe: "Сатып алуучунун пайдасына карыз (ашыкча төлөм): {{amount}}",
      settled: "Карыз жок",
      kinds: {
        receipt: "Сатып алуу",
        return: "Жеткирүүчүгө кайтаруу",
        payment: "Төлөм",
        refund: "Жеткирүүчүдөн акча кайтаруу",
      },
    },
    title: "Жеткирүүчүлөр",
    description: "Жеткирүүчүлөр, карызга сатып алуулар жана аларга төлөмдөр",
    add: "Жеткирүүчү кошуу",
    all: "Бардык жеткирүүчүлөр",
    payablesTab: "Канча карызбыз",
    search: "Аталышы, ИНН, телефон",
    empty: "Азырынча жеткирүүчүлөр жок",
    emptyHint: "Жеткирүүчүнү кошуңуз же сатып алууда тандаңыз — карыз өзү эсептелет",
    name: "Аталышы",
    contactPerson: "Байланышуучу адам",
    phone: "Телефон",
    email: "Email",
    terms: "Төлөмдү кечиктирүү",
    termsHint: "Сатып алуу күнүнөн төлөө мөөнөтүнө чейинки күндөр; 0 — дароо",
    taxId: "ИНН",
    legalName: "Юридикалык аталышы",
    address: "Дареги",
    notes: "Эскертүүлөр",
    active: "Активдүү",
    activeHint: "Активдүү эмес жеткирүүчүнү жаңы сатып алууда тандоого болбойт",
    inactive: "Активдүү эмес",
    info: "Реквизиттер",
    lastPurchase: "Акыркы сатып алуу",
    nextDue: "Жакынкы мөөнөт",
    weOweShort: "Биздин карыз",
    weOwe: "Биздин карыз: {{amount}}",
    overdue: "Мөөнөтү өттү",
    dueSoon: "7 күндө төлөө",
    purchased: "Бардыгы сатып алынды",
    paidTotal: "Бардыгы төлөндү",
    noTerms: "Дароо",
    overdueAlert: "Жеткирүүчүгө төлөмдүн мөөнөтү өттү: {{amount}}",
    documents: "Сатып алуулар",
    noDocuments: "Азырынча сатып алуулар жок",
    noDocumentsHint: "Сатып алууну өткөрүп, ушул жеткирүүчүнү тандаңыз",
    payments: "Төлөмдөр",
    noPayments: "Азырынча төлөмдөр жок",
    voided: "Жокко чыгарылды",
    pay: "Төлөө",
    paid: "Төлөм өткөрүлдү",
    payTitle: "Жеткирүүчүгө төлөм: {{name}}",
    payDoc: "{{date}} сатып алуу, төлөөгө {{amount}}",
    method: "Төлөө ыкмасы",
    methods: {
      cash: "Кассадан накталай",
      bank: "Которуу менен",
      return: "Товарды кайтаруу",
    },
    reference: "Төлөм тапшырмасынын номери",
    cashHint: "Накталай ачык кассалык сменадан берилет жана кассадагы сумманы азайтат",
    fifoHint: "Сумма эң эски төлөнбөгөн сатып алууларды жабат",
    void: "Төлөмдү жокко чыгаруу",
    voidTitle: "{{amount}} төлөмүн жокко чыгарасызбы?",
    voidHint: "Жеткирүүчүгө карыз кайтып келет. Смена ачык болсо, накталай кассага кайтат.",
    deleteTitle: "«{{name}}» жеткирүүчүсүн өчүрөсүзбү?",
    deleteHint: "Сатып алуулар тарыхта калат. Карызы бар жеткирүүчүнү өчүрүүгө болбойт.",
    statuses: {
      paid: "Төлөндү",
      partially_paid: "Жарым-жартылай төлөндү",
      unpaid: "Төлөнгөн эмес",
      overdue: "Мөөнөтү өттү",
    },
    segments: {
      all: "Баары",
      debt: "Карызы бар",
      overdue: "Төлөм мөөнөтү өттү",
      inactive: "Активдүү эмес",
    },
    aging: {
      d1_30: "1–30 күн кечикти",
      d31_60: "31–60 күн кечикти",
      d60: "> 60 күн кечикти",
    },
    creditors: "Кимге карызбыз",
    noCreditors: "Жеткирүүчүлөргө карыз жок",
    unpaidDocs: "Төлөнбөгөн сатып алуулар",
  },
  customers: {
    title: "Кардарлар",
    description: "Коноктор базасы: заказдардын тарыхы, сүйүктүү тамактар, арзандатуулар жана карыздар. Бардык филиалдар үчүн жалпы.",
    add: "Жаңы кардар",
    search: "Телефон (акыркы сандар) же аты",
    empty: "Азырынча кардарлар жок",
    emptyHint: "Конокторду кассада же бул жерде кошуңуз",
    name: "Кардар",
    firstName: "Аты",
    lastName: "Фамилиясы",
    phone: "Телефон",
    email: "Email",
    birthDate: "Туулган күнү",
    discount: "Жеке арзандатуу",
    notes: "Эскертүүлөр",
    consent: "Билдирүүлөргө макулдук",
    consentHint: "Маркетинг билдирүүлөрү — макулдук менен гана (күнү сакталат)",
    creditAllowed: "Карызга сатууга уруксат",
    creditHint: "Касса лимит чегинде кардардын заказдарын карызга төлөй алат",
    creditLimit: "Кредиттик лимит",
    creditBadge: "{{limit}} чейин кредит",
    blocked: "Бөгөттөлгөн",
    blockedHint: "Жаңы кредит жана онлайн-заказ жок",
    orders: "Заказдар",
    ordersN: "заказдар: {{n}}",
    spent: "Сатып алуулардын суммасы",
    avgCheck: "Орточо чек",
    lastVisit: "Акыркы келүү",
    visitEvery: "Келип турат",
    days: "{{n}} күн",
    debt: "Карыз",
    debtShort: "карыз {{amount}}",
    overdueAlert: "Мөөнөтү өттү: {{amount}} — жаңы кредит жеткиликсиз",
    favorites: "Сүйүктүү тамактар",
    history: "Заказдар",
    noOrders: "Заказдар жок",
    anonymize: "Жеке маалыматтарды өчүрүү",
    anonymizeTitle: "Кардардын жеке маалыматтарын өчүрөсүзбү?",
    anonymizeHint: "Аты, телефону, email жана эскертүүлөр өчүрүлөт. Заказдар жана карыз калат. Кайтарылбайт.",
    anonymized: "Маалыматтар өчүрүлдү",
    pick: "Заказдын кардары",
    quickAdd: "Жаңы кардар",
    createAndPick: "Түзүү жана тандоо",
    segments: {
      all: "Бардык кардарлар",
      debtors: "Карыздарлар",
      overdue: "Мөөнөтү өткөн",
      inactive: "Көптөн бери келбегендер",
      vip: "Сатып алуу суммасы боюнча",
      blocked: "Бөгөттөлгөндөр",
      birthday: "Ушул жумада туулган күнү",
    },
  },
  debts: {
    owedToUs: "Бизге карыз",
    weOwe: "Биз жеткирүүчүлөргө карызбыз",
    title: "Карыздар",
    description: "Карыздарлар, мөөнөтү өткөн карыздар жана карыздын жашы. Төлөө — кардардын карточкасында.",
    total: "Бардык карыз",
    overdue: "Мөөнөтү өткөн",
    debtors: "Карыздарлар",
    noDebtors: "Карыздарлар жок",
    oldest: "Эң эски карыз",
    aging: {
      d0_7: "7 күнгө чейин",
      d8_30: "8–30 күн",
      d31_60: "31–60 күн",
      d60: "60 күндөн ашык",
    },
    ledger: "Карыз журналы",
    noEntries: "Карыздар болгон эмес",
    repay: "Төлөө",
    repayTitle: "Карызды төлөө: {{name}}",
    repaid: "Карыз төлөндү",
    balance: "Учурдагы карыз: {{amount}}",
    amount: "Сумма",
    comment: "Комментарий",
    reason: "Себеби",
    cashHint: "Накталай веб-кассанын ачык сменасына түшөт.",
    adjustTitle: "Карызды түзөтүү",
    increase: "Эсептөө",
    decrease: "Азайтуу",
    dueDate: "Төлөө мөөнөтү",
    due: "{{date}} чейин",
    remaining: "{{amount}} калды",
    writeOff: "Эсептен чыгаруу",
    writeOffTitle: "{{amount}} карызды эсептен чыгарасызбы?",
    writeOffHint: "Үмүтсүз карыз толугу менен эсептен чыгарылат. Аракет аудитке жазылат.",
    writeOffComment: "Үмүтсүз карыз",
    writtenOff: "Карыз эсептен чыгарылды",
    kinds: {
      charge: "Эсептөө",
      repayment: "Төлөө",
      adjustment: "Түзөтүү",
      write_off: "Эсептен чыгаруу",
    },
    statuses: {
      open: "Ачык",
      partially_paid: "Жарым-жартылай төлөнгөн",
      paid: "Төлөнгөн",
      overdue: "Мөөнөтү өткөн",
      written_off: "Эсептен чыгарылган",
    },
  },
  staff: {
    employeesTitle: "Кадрлар",
    employeesDescription: "Филиалдын кызматкерлери: кызмат орду, кабыл алынган күнү, төлөө схемасы, ким азыр сменада. Бошотуу кирүүнү бөгөттөйт, маалыматтар сакталат.",
    employee: "Кызматкер",
    position: "Кызмат орду",
    noPosition: "Кызмат ордусуз",
    hiredAt: "Кабыл алынган күнү",
    payScheme: "Төлөө",
    own: "өзүнүн",
    ownScheme: "Өзүнчө төлөө схемасы",
    ownSchemeHint: "Болбосо — кызмат ордунун схемасы боюнча",
    employmentHint: "Кызмат орду, кабыл алуу жана төлөө схемасы. Ставкалардын өзгөрүшү аудитке жазылат.",
    status: "Абалы",
    offShift: "Сменада эмес",
    onShiftSince: "{{time}} бери сменада",
    dismissedAt: "{{date}} бошотулган",
    noEmployees: "Кызматкерлер жок",
    dismiss: "Бошотуу",
    dismissTitle: "{{name}} бошотосузбу?",
    dismissHint: "Кирүү жана PIN бөгөттөлөт, ачык смена жабылат. Маалыматтар жана эсептөөлөр сакталат.",
    dismissDate: "Бошотуу күнү",
    dismissReason: "Себеби",
    dismissed: "Кызматкер бошотулду",
    restore: "Калыбына келтирүү",
    restoreTitle: "{{name}} калыбына келтиресизби?",
    positionsTitle: "Кызмат орундары",
    positionsDescription: "Кызмат орундары жана алардын кызматкерлери үчүн демейки төлөө схемасы.",
    addPosition: "Жаңы кызмат орду",
    deletePosition: "«{{name}}» кызмат ордун өчүрөсүзбү?",
    noPositions: "Азырынча кызмат орундары жок",
    defaultScheme: "Демейки төлөө схемасы",
    scheme: {
      hourlyRate: "Сааттык ставка",
      shiftRate: "Сменалык ставка",
      monthlySalary: "Айлык маяна",
      salesPercent: "Жеке сатуудан %",
      tierFrom: "Жогорку % суммадан",
      tierHint: "Тепкич: суммадан ашкан сатуу бөлүгү",
      tierPercent: "Жогорку %",
      nightCoef: "Түнкү коэффициент",
      nightHint: "1,5 — түнкү саат +50% (22:00–06:00)",
      tipsViaPayroll: "Чайпулду эмгек акы менен төлөө",
      perHour: "{{v}}/саат",
      perShift: "{{v}}/смена",
      perMonth: "{{v}}/ай",
      ofSales: "сатуудан {{v}}%",
    },
  },
  shifts: {
    title: "Жумуш сменалары",
    description: "Кызматкерлердин келиши жана кетиши: терминалда PIN менен, кабинеттен же кол менен. Себеби менен түзөтүүлөр, табелди бекитүү.",
    add: "Кол менен смена",
    onShift: "Азыр сменада: {{n}}",
    nobody: "Сменада эч ким жок",
    list: "Сменалар",
    timesheet: "Табель",
    date: "Күнү",
    time: "Убакыт",
    worked: "Иштелди",
    night: "Түнкү",
    total: "Жыйынтык",
    shiftsCount: "Сменалар",
    unapproved: "бекитилген эмес: {{n}}",
    empty: "Мезгил ичинде смена жок",
    select: "Сменаны тандоо",
    approveAll: "Баарын бекитүү ({{n}})",
    approveSelected: "Тандалгандарды бекитүү ({{n}})",
    approvedN: "Бекитилген сменалар: {{n}}",
    clockIn: "Башталышы",
    clockOut: "Аягы",
    breakMinutes: "Тыныгуу, мүн",
    reason: "Себеби",
    correctTitle: "Түзөтүү: {{name}}",
    correctHint: "Баштапкы убакыт сакталат, өзгөртүү аудитке жазылат.",
    original: "Болгон: {{in}} — {{out}}",
    statuses: {
      open: "Сменада",
      closed: "Жабык",
      auto_closed: "Автоматтык жабылды",
      corrected: "Түзөтүлдү",
      approved: "Бекитилди",
    },
  },
  payroll: {
    title: "Эмгек акы",
    description: "Мезгил боюнча төлөө схемалары аркылуу эсептөө, текшерүү, бекитүү жана төлөө. Бекитилген ведомость өзгөрбөйт — түзөтүүлөр кийинки мезгилде.",
    calculate: "Эсептөө",
    runs: "Эсептөөлөр",
    noRuns: "Азырынча эсептөө болгон жок",
    period: "Мезгил",
    version: "Версия",
    employees: "Кызматкерлер",
    gross: "Эсептелди",
    net: "Төлөөгө",
    calculatedAt: "Эсептелген",
    sheetTitle: "Ведомость {{from}} — {{to}} (v{{v}})",
    approve: "Бекитүү",
    approved: "Ведомость бекитилди",
    immutableHint: "Ведомость бекитилген жана өзгөрбөйт. Түзөтүүлөр — кийинки мезгилде бонус же кармоо катары.",
    payCash: "Кассадан {{amount}} төлөө",
    payBank: "Банк аркылуу төлөө",
    payOne: "{{amount}} төлөө",
    paid: "Төлөм жүргүзүлдү",
    noLines: "Эсептөөлөр жок — төлөө схемаларын жана сменаларды текшериңиз",
    employeeTotals: "Эсептелди {{gross}} · төлөөгө {{net}} · төлөндү {{paid}}",
    adjustments: "Бонустар жана кармоолор",
    noAdjustments: "Бонустар жана кармоолор жок",
    addAdjustment: "Бонус же кармоо",
    adjustmentHint: "Күнү боюнча мезгилдин эсебине кирет. Себеби милдеттүү.",
    type: "Түрү",
    amount: "Сумма",
    date: "Күнү",
    reason: "Себеби",
    statuses: {
      calculated: "Эсептелди",
      approved: "Бекитилди",
      paid: "Төлөндү",
      superseded: "Кайра эсептөө менен алмашты",
    },
    components: {
      hourly: "Саат сайын",
      night: "Түнкү саат",
      fixed_shift: "Сменалар үчүн",
      fixed_monthly: "Айлык маяна",
      personal_sales_percent: "Сатуудан %",
      tips: "Чайпул",
      bonus: "Бонус",
      penalty: "Айып",
      advance: "Аванс",
      deduction: "Кармап калуу",
      carry_over: "Кармоолорду которуу",
      carry_in: "Мурунку мезгилден кармоо",
    },
    basis: {
      hourly: "{{h}} саат × {{rate}}",
      night: "{{h}} түнкү саат, коэф. {{coef}}",
      shifts: "{{n}} смена × {{rate}}",
      monthly: "{{salary}} маянадан {{days}} күн",
      sales: "{{sales}} сатуудан {{pct}}%",
    },
  },
  tips: {
    title: "Чайпул",
    description: "Коноктордун чайпулу — мекеменин кирешеси эмес. Бөлүштүрүү: заказдын официантына, пул менен тең же иштеген саат боюнча; кассадан же эмгек акы менен төлөө.",
    mode: "Бөлүштүрүү",
    modes: {
      individual: "Заказдын официантына",
      pool_equal: "Пул тең",
      pool_hours: "Пул саат боюнча",
    },
    modeHints: {
      individual: "Ар ким өз заказдарынын чайпулун алат; официантсыз — иштегендер арасында тең.",
      pool_equal: "Мезгилдин бардык чайпулу мезгилде иштегендер арасында тең.",
      pool_hours: "Мезгилде иштеген саатка жараша.",
    },
    total: "Мезгилдеги чайпул: {{amount}}",
    distribute: "Бөлүштүрүү",
    created: "Чайпул бөлүштүрүлдү",
    empty: "Мезгил ичинде чайпул жок",
    basis: "Негизи",
    hours: "{{h}} саат",
    ownOrders: "Өз заказдары",
    equalShare: "Тең үлүш",
    amount: "Сумма",
    pools: "Бөлүштүрүүлөр",
    noPools: "Азырынча бөлүштүрүү болгон жок",
    payout: "Төлөө",
    payoutAll: "Баарына {{amount}} төлөө",
    paidOut: "Чайпул төлөндү",
    paidCash: "Төлөндү",
    viaPayroll: "Эмгек акы менен",
    statuses: {
      calculated: "Бөлүштүрүлдү",
      paid: "Төлөндү",
    },
  },
  me: {
    title: "Менин кабинетим",
    description: "Менин сменаларым, сатууларым, чайпулум жана эсеп баракчаларым.",
    onShift: "Сиз {{since}} бери сменадасыз",
    offShift: "Сиз сменада эмессиз",
    clockIn: "Сменаны баштоо",
    clockOut: "Сменаны бүтүрүү",
    clockedIn: "Смена башталды",
    clockedOut: "Смена бүттү",
    worked: "Иштелди",
    orders: "Заказдар",
    sales: "Сатуулар",
    tips: "Чайпул",
    payslip: "Эсеп баракчасы {{from}} — {{to}}",
    payslipTotals: "Төлөөгө {{net}} · төлөндү {{paid}}",
    shifts: "Менин сменаларым",
  },
  audit: {
    title: "Аудит журналы",
    description: "Ким, эмнени жана качан өзгөрттү: баалар, жокко чыгаруулар, кайтаруулар, касса операциялары, карыздар, сменалар жана эмгек акы.",
    actionFilter: "Бөлүм",
    at: "Убакыт",
    action: "Аракет",
    user: "Ким",
    entity: "Объект",
    system: "Система",
    empty: "Жазуулар жок",
    before: "Болгон",
    after: "Болду",
    ...auditKy,
  },
  docs: docsKy,
  billing: {
    pageDescription: "Тариф, лимиттер, кошумчалар жана эсептер. Кошумча төлөмү бар өзгөртүүлөр эсеп төлөнгөндөн кийин күчүнө кирет, тарифти төмөндөтүү — кийинки мезгилдин башынан.",
    plans: "Тарифтер",
    period: "Төлөө мезгили",
    periods: {
      month: "Ай",
      quarter: "Квартал",
      year: "Жыл",
    },
    periodTill: "{{period}}, {{date}} чейин төлөнгөн",
    current: "Учурдагы",
    choose: "Тандоо",
    changePeriod: "Мезгилди алмаштыруу",
    changeTo: "«{{plan}}» тарифи",
    byContract: "Келишим боюнча",
    pay: "Төлөө",
    save: "пайда {{pct}}%",
    planInvoice: {
      term: "Төлөм мөөнөтү",
      custom: "Датага чейин",
      customHint: "Өз аяктоо датасы: айлар — мезгилдин баасы менен, калган күндөр — күн боюнча",
      until: "Төлөнгөн күн (кошо алганда)",
      perMonth: "айына {{amount}}",
      saving: "айына {{amount}} · пайда {{pct}}% ({{save}})",
      termLine: "Мөөнөт: {{from}} – {{to}}",
      trialHint: "Тариф дароо күйөт, төлөнгөн мөөнөт сыноо мезгилинен кийин башталат.",
      paidHint: "Мөөнөт төлөнгөндөн кийин башталат — {{date}} күндөн. Тариф эсеп төлөнгөндөн кийин алмашат.",
      noPrice: "Тарифтин баасы жок — Coca колдоо кызматына кайрылыңыз.",
    },
    planLimits: "Филиалдар: {{branches}} · терминалдар: {{terminals}} · колдонуучулар: {{users}}",
    addons: "Кошумчалар",
    addonsHint: "Төлөөдөн кийин дароо кошулат; өчүрүү — мезгилдин аягында, маалыматтар сакталат.",
    addon: "Кошумча",
    price: "Мезгил үчүн баа",
    included: "Тарифке кирет",
    active: "Кошулган",
    enable: "Кошуу",
    enableAddon: "«{{name}}» кошуу",
    disable: "Өчүрүү",
    addonCancelled: "Кошумча мезгилдин аягында өчөт",
    endsAt: "{{date}} өчөт",
    apply: "Колдонуу",
    issueInvoice: "{{amount}} эсеп чыгаруу",
    toPay: "Төлөөгө",
    discount: "Арзандатуу",
    afterPayment: "Өзгөртүү эсеп төлөнгөндөн кийин күчүнө кирет.",
    trialFree: "Сыноо мезгилинде өзгөртүүлөр акысыз жана дароо күчүнө кирет.",
    term: {
      label: "Мөөнөт",
      subscription: "Жазылуу менен",
      custom: "Өз мөөнөтү",
      subscriptionHint: "Төлөнгөн мөөнөттүн аягына чейин — {{date}} чейин, андан ары жазылуу менен узартылат.",
      subscriptionTrialHint: "Биринчи төлөнүүчү мезгил — {{date}} чейин, андан ары жазылуу менен узартылат.",
      from: "Баштап",
      to: "Чейин (кошо)",
      months: "{{count}} ай",
      customHint: "Тандалган күндөр үчүн бир жолу төлөнөт жана өзү узартылбайт.",
      past: "Бүгүндөн эрте эмес",
      order: "Башталыш күнүнөн эрте",
    },
    paidUntil: "{{date}} чейин төлөнгөн",
    startsAt: "{{date}} баштап",
    extend: "Узартуу",
    scheduled: "Өзгөртүү {{date}} күчүнө кирет — кийинки мезгилдин башынан.",
    scheduledChange: "Кийинки мезгилден пландалган: тариф {{plan}}, мезгил {{period}}",
    downgradeBlocked: "Колдонуу жаңы тарифтин лимиттеринен ашат: ашыкча филиалдарды, терминалдарды же колдонуучуларды өчүрүңүз.",
    addonsDropped: "Жаңы тарифте жок кошумчалар өчүрүлөт: {{names}}. Маалыматтар сакталат.",
    invoiceIssued: "{{n}} эсеби чыгарылды",
    changeApplied: "Өзгөртүү колдонулду",
    invoices: "Эсептер",
    noInvoices: "Азырынча эсептер жок",
    number: "Номер",
    issued: "Чыгарылган",
    due: "Төлөө мөөнөтү",
    total: "Сумма",
    print: "Басып чыгаруу",
    bankTitle: "Төлөө реквизиттери",
    invoiceStatus: {
      open: "Төлөм күтүүдө",
      paid: "Төлөндү",
      void: "Жокко чыгарылды",
      refunded: "Кайтарылды",
      draft: "Долбоор",
    },
    limitNear: "Түгөнүп калды",
    limitReached: "Түгөндү",
    banner: {
      trial: "Аяктагандан кийин тарифти тандап, эсепти төлөңүз.",
      past_due: "Эсепти {{date}} чейин төлөңүз, болбосо кирүү окуу үчүн гана болот.",
      read_only: "Окуу үчүн гана: кассадагы сатуу иштейт, калганы — төлөгөндөн кийин. Токтотулганга чейин: {{date}}.",
      suspended: "Жазылуу токтотулду. Кирүүнү калыбына келтирүү үчүн эсепти төлөңүз.",
      expired: "Сыноо мезгили бүттү. Тарифти тандаңыз.",
      archived: "Жазылуу архивде.",
      cancelled: "Жазылуу жокко чыгарылды жана {{date}} чейин иштейт.",
    },
    bannerPastDue: "Жазылуу төлөм күтүүдө — кирүүнү жоготпоо үчүн эсепти төлөңүз.",
    bannerReadOnly: "Окуу үчүн гана: касса сатат, өзгөртүүлөр төлөгөнгө чейин жеткиликсиз.",
    payNow: "Төлөө",
    choosePlan: "Тарифти тандоо",
    supportReadOnly: "Coca колдоо сеансы — көрүү гана",
    supportFull: "Coca колдоо сеансы — өзгөртүү укугу менен",
    supportExit: "Сеансты аяктоо",
    supportLinkInvalid: "Колдоо сеансынын шилтемеси жараксыз",
    inviteTitle: "Coca'га кош келиңиз",
    inviteHint: "ERPге кирүү үчүн сырсөз ойлоп табыңыз.",
    inviteInvalid: "Чакыруу шилтемеси жараксыз",
    inviteExpired: "Шилтеме эскирдиби? Сырсөздү калыбына келтирүү аркылуу коюңуз",
    inviteSubmit: "Сырсөз коюп кирүү",
  },
  onboarding: {
    title: "Мекемени ырастоо",
    defaultHall: "Негизги зал",
    next: "Кийинки",
    back: "Артка",
    skip: "Өткөрүп жиберүү",
    skipped: "өткөрүлдү",
    todo: "Аткаруу",
    optional: "Милдеттүү эмес",
    company: {
      title: "Компания",
      hint: "Бизнесиңиздин аталышы. Юридикалык маалыматтарды кийин кошсо болот.",
      name: "Аталышы",
      country: "Өлкө",
      legalName: "Юридикалык аталышы",
      taxId: "ИНН",
    },
    branch: {
      title: "Мекеме",
      hint: "Формат демейки заказ түрлөрүн белгилейт — функцияларды тариф гана чектейт.",
      format: "Мекеменин форматы",
      name: "Түйүндүн аталышы",
      phone: "Телефон",
      city: "Шаар",
      address: "Дарек",
    },
    currency: {
      title: "Валюта жана убакыт",
      hint: "Баалардын жана чектердин валютасы, саат алкагы жана отчёттор үчүн бизнес-күндүн чеги.",
      currency: "Валюта",
      timezone: "Саат алкагы",
      cutoff: "Күндүн чеги",
      cutoffHint: "Ушул убакытка чейинки сатуулар мурунку күнгө кирет",
    },
    menu: {
      packsTitle: "Толук меню керекпи?", packsHint: "«Каталог → Даяр менюлар» бөлүмүндө шаурмачы, кофейня, балмуздак кафеси, улуттук ашкана, пиццерия, суши-бар жана башка форматтар үчүн топтомдор бар: сүрөттөрү жана сүрөттөмөлөрү бар тамактар, азыктар, жарым фабрикаттар жана калькуляциясы бар техкарталар. Бир жолу сатылып алынат.",
      title: "Меню",
      hint: "Форматка ылайык демо-менюну жүктөңүз — бааларды жана позицияларды өзгөртсө же өчүрсө болот.",
      manual: "Менюну өзүм түзөм",
      load: "Жүктөө",
      loaded: "Демо-меню жүктөлдү",
      has: "Менюда {{n}} позиция бар",
      templates: {
        coffee: "Кофе (өлчөмдөр, сүт, сироптор), чай, бышырылган азыктар, десерттер",
        cafe: "Салаттар, шорполор, ысык тамактар, суусундуктар — ашкана жана бар",
        fast_food: "Кошумчалары бар бургерлер, соустар менен закускалар, суусундуктар",
      },
    },
    tables: {
      title: "Столдор",
      hint: "Залдын тез планы: столдор тор менен жайгашат, ар биринде меню үчүн QR.",
      hall: "Зал",
      count: "Столдор",
      capacity: "Столдогу орундар",
      generate: "Столдорду түзүү",
      created: "Түзүлгөн столдор: {{n}}",
      has: "Столдор бар: {{n}}",
    },
    employees: {
      title: "Кызматкерлер",
      hint: "Кассирлер жана официанттар кассага PIN менен кирет — сырсөз керек эмес.",
      name: "Аты",
      role: "Ролу",
      pinHint: "4–6 сан",
      add: "Кызматкер кошуу",
    },
    cash: {
      title: "Касса",
      hint: "Веб-кассанын сменасын майда акча менен ачыңыз — анан сатсаңыз болот. Терминалдар «Жөндөөлөр → Терминалдар» бөлүмүндө туташтырылат.",
      open: "Сменаны ачуу",
    },
    finish: {
      title: "Биринчи сатууга даяр",
      hint: "Өткөрүлгөн кадамдарды кийин жөндөөлөрдө бүтүрсө болот.",
      openPos: "Кассаны ачуу",
      openDashboard: "Дашбордго өтүү",
    },
    steps: {
      company: "Компания",
      branch: "Мекеме",
      currency: "Валюта жана убакыт",
      menu: "Меню",
      tables: "Столдор",
      employees: "Кызматкерлер",
      cash: "Касса",
      finish: "Даяр",
    },
    formats: {
      cafe: "Официанттары бар кафе",
      coffee: "Кофейня",
      fast_food: "Фастфуд",
      self_service: "Өзүн-өзү тейлөө",
      food_court: "Фудкорт",
    },
    formatHints: {
      cafe: "Зал, столдор, тамактан кийин төлөө",
      coffee: "Ала кетүү жана залда, суусундук модификаторлору",
      fast_food: "Заказ номери, дароо төлөө",
      self_service: "Стойкада заказ, даярдык экраны",
      food_court: "Жалпы зал, бир нече ашкана",
    },
    countries: {
      KG: "Кыргызстан",
      KZ: "Казакстан",
      UZ: "Өзбекстан",
      TJ: "Тажикстан",
      RU: "Россия",
    },
  },
  site: {
    contacts: { title: "Байланыштар жана социалдык тармактар", hint: "Сайттын төмөнкү бөлүгүндө жана башкы бетинде көрүнөт. Бош талаалар сайтта көрүнбөйт. Социалдык тармактар — шилтеме же аккаунттун аты (@name).", phone: "Мекеменин телефону", email: "Коноктор үчүн email" },
    title: "Сайт жана QR-меню",
    description: "Мекеменин ачык сайты, столдордогу QR-меню жана коноктордун телефондон заказы.",
    open: "Сайтты ачуу",
    slug: "Сайттын дареги (субдомен)",
    heroTitle: "Башкы беттеги аталыш",
    about: "Мекеме жөнүндө",
    seoTitle: "SEO-аталыш",
    seoTitleHint: "60 белгиге чейин",
    seoDescription: "SEO-сүрөттөмө",
    seoDescriptionHint: "155 белгиге чейин",
    qrOrdering: "QR аркылуу коноктордун заказы",
    qrOrderingHint: "Коноктор телефонунан заказ беришет, заказ дароо кассада пайда болот",
    qrOrderingAddon: "«QR боюнча заказ» кошумчасы менен жеткиликтүү — аны «Жазылуу» барагында кошуңуз",
    requireName: "Коноктун атын суроо",
    autoKitchen: "Дароо ашканага жөнөтүү",
    autoKitchenHint: "Болбосо заказ официанттын ырастоосун күтөт",
    qrTitle: "Столдордун QR-коддору",
    qrHint: "Столдорго чаптамалар: конок сканерлеп менюну көрөт, заказ берет жана официантты чакырат.",
    printAll: "Чаптамаларды басуу ({{n}})",
    noTables: "Азырынча столдор жок — «Залдар жана столдор» бөлүмүндө түзүңүз.",
    counterQr: "Стойка жана витрина үчүн QR",
    scanCaption: "Меню үчүн сканерлеңиз",
    callWaiter: "{{n}}-стол официантты чакырууда",
    requestBill: "{{n}}-стол эсеп сурап жатат",
    domain: {
      title: "Сайттын өз дареги",
      description: "Сайт жана QR-меню өз доменинизде — мисалы, платформанын дарегинин ордуна navat.kg.",
      addon: "«Сайттын өз дареги» кошумчасы менен жеткиликтүү",
      addonHint: "Аны «Жазылуу» барагында кошуңуз — сайт өз дарегиңизде ачылат, платформанын дарегиндеги шилтемелер да ошол жакка алып барат.",
      input: "Сиздин домен",
      inputHint: "Домен регистратордон мурун сатылып алынган болушу керек (мисалы, navat.kg же menu.navat.kg)",
      connect: "Туташтыруу",
      none: "Өз дарек туташтырылган эмес.",
      pending: "DNS жөндөөсүн күтүүдө",
      active: "Иштеп жатат",
      since: "{{date}} тастыкталган",
      steps: "Бул жазууларды домен регистраторунун панелине кошуп, «Текшерүү» баскычын басыңыз. DNS өзгөрүүлөрү адатта 5–30 мүнөттө, кээде бир суткада жетет.",
      type: "Түрү",
      name: "Аты",
      value: "Мааниси",
      copy: "Көчүрүү",
      copied: "Көчүрүлдү",
      verify: "Текшерүү",
      change: "Даректи алмаштыруу",
      remove: "Даректи өчүрүү",
      removeTitle: "Өз даректи өчүрөсүзбү?",
      removeHint: "Сайт платформанын дареги боюнча ачыла берет. DNS жазууларын регистратордон өчүрсөңүз болот.",
      noTxt: "TXT жазуусу азырынча көрүнбөйт. Атын жана маанисин текшериңиз же күтө туруңуз — DNS дароо жаңыланбайт.",
      noRouting: "Домен бизге багытталган эмес (CNAME же A жазуусу). Ал жок болсо, сайт бул дарек боюнча ачылбайт.",
      sslHint: "Коопсуз туташуу (https) домен бизге багытталгандан кийин бир нече мүнөттө өзү күйөт.",
      activeToast: "{{domain}} дареги тастыкталды",
    },
  },
  supportAccess: {
    title: "Coca колдоосу уруксат сурап жатат",
    description: "Колдоо кызматкери {{name}} кабинетиңизге киргиси келет. Сиздин уруксатыңызсыз кире албайт.",
    approve: "Кирүүгө уруксат берүү",
    deny: "Четке кагуу",
    mode: "Режим",
    modeReadOnly: "Көрүү гана",
    modeFull: "Көрүү жана өзгөртүү",
    reason: "Себеби",
    until: "Жооп берүү мөөнөтү",
    readOnlyHint: "Кызматкер кабинетти сиздин көзүңүз менен көрөт, бирок эч нерсени өзгөртө албайт. Сеанс — 60 мүнөткө чейин, баары аудит журналына жазылат.",
    fullHint: "Кызматкер ээсинин атынан өзгөртүүлөрдү киргизе алат. Жардам өзүңүз сураган болсоңуз гана уруксат бериңиз. Сеанс — 60 мүнөткө чейин, бардык аракеттер аудит журналына жазылат.",
    approved: "Уруксат берилди — колдоо кызматкери 10 мүнөттүн ичинде кире алат",
    denied: "Сурам четке кагылды",
  },
  support: {
    title: "Колдоо",
    description: "Бизге жазыңыз — ушул бөлүмдө жооп берип, билдирүү жөнөтөбүз.",
    new: "Колдоого жазуу",
    empty: "Азырынча кайрылуулар жок",
    emptyHint: "Бир нерсе иштебей калса же суроо болсо — жазыңыз, жардам беребиз.",
    subject: "Тема",
    category: "Кайрылуунун түрү",
    body: "Билдирүү",
    bodyHint: "Эмне болгонун жана эмнени күткөнүңүздү жазыңыз. Буйрутманын номери же экран жардам берет.",
    send: "Жөнөтүү",
    reply: "Жооп берүү",
    replyPlaceholder: "Жообуңуз…",
    close: "Маселе чечилди",
    closeConfirm: "Кайрылууну жабасызбы?",
    closeHint: "Маселе кайталанса — ушул эле кайрылууга жазыңыз.",
    sent: "Кайрылуу жөнөтүлдү",
    replied: "Билдирүү жөнөтүлдү",
    closed: "Кайрылуу жабылды",
    you: "Сиз",
    supportName: "Coca колдоосу",
    number: "№ {{n}}",
    createdBy: "Автор",
    updated: "Акыркы билдирүү",
    slaNormal: "{{hours}} сааттын ичинде жооп беребиз",
    slaHigh: "Тез колдоо: {{hours}} сааттын ичинде жооп, кайрылууларыңыз — биринчи",
    slaUpsell: "Тезирээк керекпи? «Тез колдоону» кошуңуз — 2 саатта жооп.",
    slaUpsellAction: "Жазылуу",
    waitUntil: "{{time}} чейин жооп беребиз",
    overdue: "Жооп кечигип жатат — алектенип жатабыз",
    statuses: {
      open: "Жооп күтүүдө",
      answered: "Жооп бар",
      closed: "Чечилди",
    },
    categories: {
      question: "Суроо",
      problem: "Бир нерсе иштебейт",
      billing: "Төлөм жана жазылуу",
      idea: "Сунуш",
    },
    filterAll: "Баары",
    priorityHigh: "Шашылыш",
  },
  brand: {
    title: "Өз бренд",
    description: "Coca ордуна сиздин аталыш, логотип жана түс — программада, сайтта жана каттарда.",
    addon: "«Coca ордуна өз бренд» кошумчасы менен жеткиликтүү",
    addonHint: "Кызматкерлер жана коноктор сиздин брендди гана көрүшөт: программанын башы, баскычтардын түсү, «Coca'да иштейт» жазуусу жок сайт, сиздин атыңыздан каттар.",
    name: "Аталышы",
    nameHint: "Башында, браузердин өтмөгүндө жана каттын колунда. Бош болсо — компаниянын аталышы",
    color: "Негизги түс",
    logo: "Логотип",
    logoHint: "Тунук фондогу, туурасынан узун PNG жакшы",
    colors: {
      orange: "Кызгылт сары (Coca)",
      red: "Кызыл",
      rose: "Малина түстүү",
      violet: "Кызгылт көк",
      blue: "Көк",
      teal: "Бирюза",
      green: "Жашыл",
      brown: "Күрөң",
    },
  },
  fraud: {
    title: "Кыянаттыктан коргоо",
    description: "Кызматкерлердин шектүү аракеттери: өчүрүүлөр, кайтаруулар, арзандатуулар, жетишпестиктер. Ар саат сайын өзү текшерилет.",
    scan: "Азыр текшерүү",
    scanFound: "Жаңылары табылды: {{count}}",
    scanNothing: "Жаңы шектүү аракеттер жок",
    settings: "Эрежелер",
    alertsTab: "Сигналдар",
    peopleTab: "Кызматкерлер",
    peopleTitle: "Ким сигналдарга көбүрөөк түшөт",
    peopleHint: "Тобокелдик — салмактардын суммасы: олуттуу 5, орточо 3, төмөн 1. Жалган коркунучтар эсептелбейт.",
    empty: "Шектүү аракеттер жок",
    emptyHint: "Тандалган мөөнөттө эрежелер эч нерсе тапкан жок.",
    all: "Баары",
    status: "Абалы",
    rule: "Эмне болду",
    employee: "Кызматкер",
    date: "Күнү",
    amount: "Сумма",
    risk: "Тобокелдик",
    alerts: "Сигналдар",
    noUser: "Кызматкерсиз",
    decision: "Чечим",
    comment: "Комментарий",
    statuses: {
      new: "Жаңы",
      reviewed: "Каралды",
      dismissed: "Жалган коркунуч",
      confirmed: "Бузуу",
    },
    severities: {
      low: "Төмөн",
      medium: "Орточо",
      high: "Олуттуу",
    },
    units: {
      count: "Көп, жолу",
      percent: "Көп, %",
      days: "Төлөмсүз күндөр",
      sigma: "Орточодон жогору, σ",
    },
    rules: {
      void_many: "Көп өчүрүлгөн позициялар",
      void_after_kitchen: "Ашканадан кийин позицияны өчүрүү",
      cancel_after_kitchen: "Ашканадан кийин буйрутманы жокко чыгаруу",
      refunds_many: "Көп кайтаруулар",
      refund_cash_for_card: "Карта менен төлөмгө накталай кайтаруу",
      discount_share: "Көп кол менен арзандатуулар",
      price_below_menu: "Менюдан арзан сатуу",
      writeoff_outlier: "Адаттан тыш чоң эсептен чыгаруу",
      cash_shortage: "Кассада жетишпестик",
      credit_unpaid: "Төлөнбөгөн карыз",
    },
    ruleHints: {
      void_many: "Кызматкер бир күндө адаттагыдан көп позицияны өчүргөн.",
      void_after_kitchen: "Тамак даярдалып, анан өчүрүлгөн — продуктылар коротулган, акча жок.",
      cancel_after_kitchen: "Буйрутма ашканага кетип, анан жокко чыгарылган.",
      refunds_many: "Бир күндө адаттагыдан көп кайтаруу.",
      refund_cash_for_card: "Конок карта менен төлөгөн, кайтаруу накталай берилген — акча чыгаруунун классикалык схемасы.",
      discount_share: "Кызматкердин кол менен арзандатуулары — анын күндүк сатуусунун байкаларлык үлүшү.",
      price_below_menu: "Позициялар менюдагы баадан арзан сатылган.",
      writeoff_outlier: "Эсептен чыгаруу бул мекеме үчүн адаттагыдан бир топ чоң.",
      cash_shortage: "Сменаны жапканда накталай болушу керектен аз. 30 күндүн ичинде кайталанса — олуттуу.",
      credit_unpaid: "Карызга сатуу, ал боюнча көптөн бери бир да төлөм жок.",
    },
    d: {
      count: "{{count}} жолу (чек {{threshold}})",
      order: "буйрутма № {{n}}",
      pct: "{{pct}}% (чек {{threshold}}%)",
      lines: "позициялар: {{count}}",
      average: "адатта болжол менен {{avg}}",
      repeats: "кайталанды: 30 күндө {{count}}",
      customer: "кардар {{name}}",
      paidBy: "төлөм: {{methods}}",
    },
  },
  sms: {
    title: "SMS-жөнөтүүлөр",
    description: "Сегменттер боюнча кардарларга билдирүүлөр: акциялар, жаңылыктар, эскертүүлөр. Макулдук бергендерге гана.",
    usage: "{{month}} үчүн SMS",
    usageValue: "{{quota}} ичинен {{used}}",
    noQuota: "Айга SMS жок",
    lowQuota: "SMS калды: {{count}}",
    packHint: "«SMS 1000» пакети «Жазылуу» барагында кошулат жана ар ай сайын иштейт.",
    buyPack: "Жазылуу",
    new: "Жаңы жөнөтүү",
    test: "Сыноо SMS",
    campaigns: "Жөнөтүүлөр",
    empty: "Азырынча жөнөтүүлөр жок",
    emptyHint: "Биринчисин түзүңүз — мисалы, дем алыш күндөргө арзандатуу менен чакыруу.",
    name: "Аталышы",
    nameHint: "Өзүңүз үчүн, кардарлар аны көрүшпөйт",
    segment: "Кимге",
    allCustomers: "Макулдугу бар бардык кардарларга",
    tag: "Кардардын теги",
    tagHint: "Милдеттүү эмес: ушул тег менен кардарлар гана",
    text: "Текст",
    counter: "{{length}} белги · {{parts}} SMS ({{perPart}} боюнча)",
    noRecipients: "Алуучулар жок: кардардын карточкасында телефон жана «жөнөтүүлөргө макул» белгиси керек.",
    previewText: "Алуучулар: {{recipients}}, SMS: {{total}}. Бул айда калды: {{remaining}}.",
    notEnough: "SMS жетишпейт — пакет сатып алыңыз.",
    consentHint: "«Жөнөтүүлөргө макул» белгиси, телефону бар жана бөгөттөлбөгөн кардарлар гана алышат.",
    confirmTitle: "Жөнөтүүнү жибересизби?",
    confirmText: "Алуучулар: {{recipients}}, SMS коротулат: {{total}}. Жөнөткөндөн кийин жокко чыгарууга болбойт.",
    send: "Жөнөтүү",
    started: "Жөнөтүү башталды — билдирүүлөр бир мүнөттүн ичинде кетет",
    phone: "Номер",
    testText: "Биздин кафеден SMS текшерүү",
    testQueued: "SMS жөнөтүлүүдө",
    date: "Качан",
    recipients: "Алуучулар",
    delivered: "Жеткирилди",
    notSent: "кеткен жок: {{count}}",
    statuses: {
      sending: "Жөнөтүлүүдө",
      sent: "Жөнөтүлдү",
    },
  },
  services: {
    title: "Кызматтар жана ижара",
    description: "Кальян, караоке, бөлмө ижарасы: таймер серверде жүрөт, токтотулганда кызмат өзү буйрутмага түшөт.",
    start: "Кызматты баштоо",
    startTimer: "Таймерди иштетүү",
    sell: "Сатуу",
    started: "Таймер иштетилди",
    sold: "Кызмат буйрутмага кошулду",
    stopped: "Кызмат буйрутмага кошулду",
    tabs: {
      now: "Азыр",
      rooms: "Бөлмөлөр",
      tariffs: "Тарифтер",
      report: "Отчёт",
    },
    statuses: {
      running: "Жүрүүдө",
      paused: "Тыным",
      stopped: "Аяктады",
      cancelled: "Жокко чыгарылды",
    },
    pause: "Тыным",
    resume: "Улантуу",
    stop: "Аяктоо",
    stopTitle: "Аяктап, буйрутмага кошосузбу?",
    stopHint: "Убакыт тариф боюнча эсептелет (кадам жана тегеректөө), сумма буйрутмага түшөт.",
    cancel: "Жокко чыгаруу",
    cancelTitle: "Төлөмсүз жокко чыгарасызбы?",
    cancelHint: "Убакыт төлөнбөйт. Аракет журналга жазылат.",
    elapsed: "Өттү {{time}}",
    planned: "{{time}} чейин төлөнгөн",
    overPlanned: "Төлөнгөн убакыт бүттү",
    noActive: "Азыр эч нерсе жүрбөйт",
    noActiveHint: "Кызматты иштетиңиз — кальян, караоке же бөлмө ижарасы.",
    recent: "Акыркылар",
    when: "Башталышы",
    duration: "Убакыт",
    amount: "Сумма",
    service: "Кызмат",
    room: "Бөлмө",
    noRoom: "Бөлмөсүз",
    busy: "бош эмес",
    free: "Бош",
    quantity: "Саны",
    plannedMinutes: "Төлөнгөн убакыт, мүн",
    plannedHint: "Милдеттүү эмес: убакыт бүткөндө таймер белгиленет",
    orderHint: "Буйрутма тандалбаса жаңысы түзүлөт — бөлмөнүн үстөлүнө, эгер көрсөтүлсө.",
    noReady: "Жөндөлгөн кызматтар жок: «Кызмат» түрүндөгү меню позициясын кошуп, «Тарифтер» өтмөгүндө тариф коюңуз.",
    billing: "Кантип эсептөө",
    billingHourly: "Убакыт боюнча",
    billingUnit: "Даана менен",
    unitHint: "Баасы — менюдан ({{price}}); техкарта болсо продуктылар (тамеки, көмүр) эсептен чыгат.",
    hourlyPrice: "Сааттын баасы",
    minDuration: "Минимум, мүн",
    step: "Кадам, мүн",
    rounding: "Тегеректөө",
    roundings: {
      up: "Жогору",
      nearest: "Жакынкыга",
      down: "Төмөн",
    },
    tierLabel: "Биринчи сааттан кийин башка баа",
    tierHint: "Мисалы: биринчи саат 1000, андан ары 800дөн",
    tierFrom: "Кайсы мүнөттөн",
    tierPrice: "Андан аркы сааттын баасы",
    commission: "Комиссия",
    commissions: {
      none: "Комиссиясыз",
      fixed: "Сумма",
      percent: "Пайыз",
      mixed: "Сумма + пайыз",
    },
    commissionPercent: "Пайыз",
    commissionFixed: "Сумма",
    addRoom: "Бөлмө кошуу",
    roomName: "Аталышы",
    minOrder: "Минималдуу буйрутма",
    minOrderHint: "Ижара аяктаганда буйрутма ушул суммага чейин толукталат",
    deposit: "Депозит",
    roomActive: "Колдонулат",
    inactive: "Өчүк",
    noRooms: "Азырынча бөлмөлөр жок",
    noRoomsHint: "VIP-бөлмө же караоке залын кошуңуз.",
    tariffsHint: "Кызматтар — «Кызмат» түрүндөгү меню позициялары. Бул жерде — аларды кантип эсептөө жана аткаруучуга комиссия.",
    noServices: "Азырынча кызматтар жок",
    noServicesHint: "Менюда «Кызмат» түрүндөгү позицияны түзүңүз.",
    notConfigured: "Жөндөлгөн эмес",
    perHour: "Саатына {{price}}, кадам {{step}} мүн",
    perUnit: "Даанасы {{price}}",
    revenue: "Киреше",
    roomsLoad: "Бөлмөлөрдүн жүктөмү",
    hours: "Сааттар",
    sessions: "Сессиялар",
    load: "Жүктөм",
    commissionsTitle: "Кызматкерлерге комиссия",
    commissionsHint: "Кайтаруулар жана өчүрүлгөн позициялар эсептелбейт.",
    noCommissions: "Комиссия жок",
    employee: "Кызматкер",
    sales: "Сатуулар",
  },
  banquets: {
    title: "Банкеттер",
    description: "Үйлөнүү той, туулган күн, корпоративдер: конокко меню, депозиттер, залды брондоо жана иш-чара күнү буйрутма.",
    new: "Жаңы банкет",
    empty: "Банкеттер жок",
    emptyHint: "Арыз түзүңүз — меню менен депозитти кийин кошсоңуз болот.",
    name: "Аталышы",
    type: "Түрү",
    startsAt: "Башталышы",
    endsAt: "Аякташы",
    guests: "Коноктор",
    guestsN: "Коноктор: {{count}}",
    halls: "Залдар",
    hallsHint: "Тастыктагандан кийин залдар кадимки брондорго жабылат",
    depositRequired: "Тастыктоо үчүн депозит",
    depositRequiredHint: "0 — депозитсиз тастыктоо",
    notes: "Эскертүүлөр",
    types: {
      wedding: "Үйлөнүү той",
      birthday: "Туулган күн",
      corporate: "Корпоратив",
      anniversary: "Юбилей",
      other: "Башка",
    },
    statuses: {
      inquiry: "Арыз",
      tentative: "Алдын ала",
      confirmed: "Тастыкталды",
      in_progress: "Жүрүүдө",
      completed: "Аяктады",
      cancelled: "Жокко чыгарылды",
    },
    statusActions: {
      inquiry: "Арыздарга",
      tentative: "Алдын ала",
      confirmed: "Тастыктоо",
      in_progress: "Баштоо",
      completed: "Аяктоо",
      cancelled: "Жокко чыгаруу",
    },
    cancelTitle: "Банкетти жокко чыгарасызбы?",
    cancelHint: "Залдар бошойт. Кайтарылбаган депозиттерди «Депозиттер» өтмөгүндө кайтарыңыз.",
    cancelReason: "ERPде жокко чыгарылды",
    start: "Банкетти баштоо",
    startTitle: "Банкетти баштайсызбы?",
    startHint: "Менюдан буйрутма түзүлөт, депозит төлөмгө эсептелет. Ачык касса сменасы керек.",
    started: "Банкет буйрутмасы түзүлдү",
    complete: "Аяктоо",
    completed: "Банкет аяктады",
    print: "Сунуш",
    proposal: "Коммерциялык сунуш",
    orderN: "Буйрутма № {{n}}",
    tabs: {
      menu: "Меню",
      deposits: "Депозиттер",
      summary: "Жыйынтык",
    },
    addItem: "Тамак кошуу",
    menuEmpty: "Меню бош",
    menuEmptyHint: "Тамактарды кошуңуз — санын конокко көрсөтсөңүз болот.",
    dish: "Тамак",
    course: "Берүү",
    qty: "Саны",
    perGuest: "конокко",
    price: "Баасы",
    sum: "Сумма",
    menuTotal: "Бардыгы {{total}} · конокко {{perGuest}}",
    depositState: "{{required}} ичинен {{paid}} киргизилди; буйрутмага эсептелди {{applied}}",
    depositAmount: "Депозиттин суммасы",
    method: "Ыкма",
    methods: {
      cash: "Накталай",
      card: "Карта",
      bank: "Которуу",
    },
    takeDeposit: "Кабыл алуу",
    depositAdded: "Депозит кабыл алынды",
    noDeposits: "Депозиттер жок",
    when: "Качан",
    refunded: "Кайтарылды",
    refund: "Кайтаруу",
    refundTitle: "Депозитти кайтарасызбы?",
    refundHint: "{{amount}} — накталай кассадан берилет.",
    menuSum: "Меню",
    orderSum: "Буйрутма № {{n}}",
    costSum: "Техкарталар боюнча өздүк нарк",
    costPartial: "бардык тамактардын техкартасы жок",
    extraCosts: "Кошумча чыгымдар",
    profit: "Пайда",
    deposits: "Депозиттер",
    due: "Төлөөгө",
    productsTitle: "Банкетке продуктылар",
    productsHint: "Бардык конокторго меню техкарталары боюнча; калдыктан тышкары канча сатып алуу керек.",
    missingRecipes: "Техкартасыз: {{names}}",
    noProducts: "Техкартасы бар тамактар жок",
    product: "Продукт",
    need: "Керек",
    inStock: "Кампада",
    toBuy: "Сатып алуу",
  },
  promotions: {
    title: "Акциялар",
    description: "Эрежелер боюнча арзандатуулар: happy hours, комбо, «2+1», белектер, промокоддор. Шайкештик — артыкчылык жана топтор боюнча.",
    posHint: "Кассада акциялар буйрутмадагы «Акциялар» баскычы менен күйгүзүлөт — промокод да ошол жерде киргизилет.",
    new: "Жаңы акция",
    empty: "Азырынча акциялар жок",
    emptyHint: "Мисалы: «Сыра −30% 17ден 19га чейин» же «Бургер + фри + суусундук = 450».",
    tabs: {
      list: "Акциялар",
      report: "Канчага турду",
    },
    name: "Аталышы",
    code: "Промокод",
    codeHint: "Милдеттүү эмес: акция ушул код менен гана иштейт",
    type: "Түрү",
    types: {
      percent: "Пайыз менен арзандатуу",
      fixed: "Сумма менен арзандатуу",
      combo: "Атайын баадагы комбо",
      bogo: "X сатып ал — Y ал",
      gift: "Белек",
    },
    percent: "Пайыз",
    amount: "Арзандатуунун суммасы",
    buyQty: "Сатып ал",
    getQty: "Ал",
    getPercent: "«Ал» үчүн арзандатуу, %",
    slot: "Слот {{n}}",
    addSlot: "Слот",
    removeSlot: "Слотту алып салуу",
    comboPrice: "Топтомдун баасы",
    gift: "Белек",
    giftHint: "Позиция буйрутмада болушу керек — ал акысыз болот",
    target: "Эмнеге колдонулат",
    scopes: {
      order: "Бүт буйрутма",
      categories: "Категориялар",
      items: "Позициялар",
    },
    conditions: "Шарттар",
    minSubtotal: "Буйрутма ...дан",
    days: "Апта күндөрү",
    daysHint: "Бош — күн сайын",
    timeFrom: "Баштап",
    timeTo: "Чейин",
    timeHint: "Happy hours; түн ортосу аркылуу да болот",
    dateFrom: "Колдонулат ...дан",
    dateTo: "Колдонулат ...га чейин",
    customerTag: "Кардардын теги",
    customerTagHint: "Мисалы: staff — кызматкерлерге арзандатуу",
    usageLimit: "Колдонуу чеги",
    firstOrder: "Кардардын биринчи буйрутмасы гана",
    stackGroup: "Шайкештик тобу",
    stackGroupHint: "Бир топтон бирөө, эң пайдалуусу колдонулат",
    priority: "Артыкчылык",
    exclusive: "Өзгөчө",
    exclusiveHint: "Ылайык келсе — башка акциялар колдонулбайт",
    active: "Иштейт",
    on: "Иштейт",
    off: "Өчүк",
    orders: "Буйрутмалар",
    cost: "Арзандатуу",
    revenue: "Буйрутмалардын кирешеси",
    reportEmpty: "Мөөнөттө акциялар колдонулган жок",
    deleteTitle: "Акцияны өчүрөсүзбү?",
    fromSum: "{{sum}} баштап",
    limitN: "чеги {{n}}",
  },
  deliveries: {
    formatOff: "Филиал жеткирүүдө иштебейт",
    formatOffHint: "Филиалдын жөндөөлөрүндө «Жеткирүү» форматын күйгүзүңүз — ансыз жеткирүү буйрутмасын түзүүгө болбойт.",
    formatOffAction: "Филиалдын жөндөөлөрү",
    title: "Жеткирүү",
    description: "Диспетчердик: абалдар боюнча буйрутмалар, убада кылынган убакытка чейинки таймерлер, курьерлер жана зоналар.",
    new: "Жаңы жеткирүү",
    createAndOpen: "Түзүп, кассада ачуу",
    created: "Жеткирүү тариздалды — позицияларды кошуңуз",
    empty: "Иштеги жеткирүүлөр жок",
    emptyHint: "Жеткирүү тариздеңиз — позициялар кассада кошулат.",
    tabs: {
      board: "Иште",
      done: "Аяктагандар",
      zones: "Зоналар",
      couriers: "Курьерлер",
    },
    statuses: {
      new: "Жаңы",
      confirmed: "Тастыкталды",
      cooking: "Даярдалууда",
      ready: "Даяр",
      courier_assigned: "Курьер дайындалды",
      on_the_way: "Жолдо",
      delivered: "Жеткирилди",
      failed: "Болбоду",
      cancelled: "Жокко чыгарылды",
      returned: "Кайтарылды",
    },
    statusActions: {
      new: "Жаңы",
      confirmed: "Тастыктоо",
      cooking: "Даярдалууда",
      ready: "Даяр",
      courier_assigned: "Дайындоо",
      on_the_way: "Жолдо",
      delivered: "Жеткирилди",
      failed: "Болбоду",
      cancelled: "Жокко чыгаруу",
      returned: "Кайтты",
    },
    payments: {
      prepaid: "Төлөнгөн",
      cash: "Курьерге накталай",
      card: "Курьерге карта",
    },
    changeFrom: "{{sum}} кайтарым",
    changeFromLabel: "Купюрадан кайтарым",
    lateBy: "{{n}} мүн кечигүү",
    leftN: "{{n}} мүн калды",
    noItems: "позициялар азырынча жок",
    noCourier: "Курьерсиз",
    courier: "Курьер",
    openPos: "Кассада",
    reasonHint: "Аракет журналга жазылат.",
    byDispatcher: "Диспетчер белгиледи",
    customer: "Коноктун аты",
    phone: "Телефон",
    street: "Көчө, үй",
    entrance: "Подъезд",
    floor: "Кабат",
    apartment: "Батир",
    comment: "Курьерге комментарий",
    zone: "Зона",
    zoneHint: "Координаттар боюнча өзү аныкталат",
    noZone: "Зонасыз (баасы кол менен)",
    coords: "Координаттар",
    coordsHint: "Кеңдик, узундук — карталардан (милдеттүү эмес)",
    payment: "Төлөм",
    scheduledAt: "Убакытка",
    scheduledHint: "Бош — мүмкүн болушунча тез",
    entranceN: "{{n}}-подъезд",
    floorN: "{{n}}-кабат",
    aptN: "{{n}}-батир",
    address: "Дарек",
    promised: "Убада",
    newZone: "Жаңы зона",
    zoneName: "Аталышы",
    zoneKind: "Формасы",
    kinds: {
      circle: "Тегерек",
      polygon: "Көп бурчтук",
    },
    center: "Борбор",
    radius: "Радиус, м",
    polygon: "Чокулар",
    polygonHint: "Ар бир сапка бирден: кеңдик, узундук",
    fee: "Баасы",
    freeFrom: "Акысыз ...дан",
    freeFromHint: "0 — дайыма акылуу",
    minOrder: "Мин. буйрутма",
    eta: "Жеткирүү убактысы, мүн",
    zoneActive: "Иштейт",
    off: "Өчүк",
    noZones: "Азырынча зоналар жок",
    noZonesHint: "Зонасыз дарек текшерилбейт — баасы кол менен көрсөтүлөт.",
    radiusN: "радиус {{n}} м",
    pointsN: "{{n}} чекит",
    freeFromN: "{{sum}} баштап акысыз",
    minN: "{{n}} мүн",
    noCouriers: "Курьерлер жок",
    noCouriersHint: "«Курьер» ролундагы кызматкерди кошуңуз.",
    activeN: "Иште",
    onHand: "Колундагы накталай",
    handover: "Накталайды кабыл алуу",
    handoverTitle: "{{name}} накталайын кабыл аласызбы?",
    handoverHint: "Курьер {{sum}} тапшырат.",
    handedOver: "Накталай кабыл алынды",
    reportTitle: "Курьерлер боюнча отчёт",
    noData: "Маалымат жок",
    delivered: "Жеткирилди",
    lateCount: "Кечигүүлөр",
    failedCount: "Болбоду",
    avgTime: "Орточо убакыт",
    cash: "Накталай",
  },
  courier: {
    title: "Менин жеткирүүлөрүм",
    description: "Сизге дайындалган буйрутмалар: дарек, чалуу, маршрут жана абалы.",
    empty: "Жеткирүүлөр жок",
    emptyHint: "Диспетчер буйрутма дайындаганда ал ушул жерде пайда болот.",
    paid: "Төлөнгөн",
    collectCash: "Накталай алуу {{sum}}",
    collectCard: "Карта менен төлөм {{sum}}",
    call: "Чалуу",
    route: "Маршрут",
    go: "Чыктым",
    delivered: "Жеткирилди",
    failed: "Болбоду",
    failTitle: "Жеткирүү болбодубу?",
    failHint: "Диспетчер себебин көрүп, эмне кылууну чечет.",
    failReason: "Тапшыра алган жокмун",
    deliveredToast: "Белгиленди: жеткирилди",
  },
  ai: {
    "quota": {
      "left": "Ушул айда {{limit}} суроонун {{remaining}} калды",
      "more": "Суроо кошуу",
      "exhausted": "Ушул айга Coca AI суроолору түгөндү. «Жазылуу» бөлүмүнөн «+500 жардамчыга суроо» пакетин кошуңуз же кийинки айды күтүңүз."
    },
    "hint": {
      "title": "Coca AI кеңеши",
      "updated": "Жаңыртылды {{time}}",
      "get": "Кеңеш алуу",
      "refresh": "Кеңешти жаңыртуу (1 суроо)",
      "hide": "Жашыруу",
      "topics": {
        "sales": "Мезгилдеги сатуудагы маанилүү нерсе — 1 суроо",
        "menu": "Менюда эмнени өзгөртүү керек — 1 суроо",
        "writeoffs": "Эсептен чыгарууну кантип азайтуу — 1 суроо",
        "products": "Азыктын ашыкча коромжусу кайда — 1 суроо",
        "waiters": "Команда кантип иштеп жатат — 1 суроо",
        "finance": "Акча кайда кетип жатат — 1 суроо",
        "stock": "Эмнени кошумча заказ кылуу — 1 суроо"
      }
    },
    "button": "Coca AI — жакында",
    "title": "Coca AI",
    "soon": "Жакында",
    "eyebrow": "Coca AI · жакында",
    "heroTitle": "Рестораныңыз ээ болот",
    "heroAccent": "өз интеллектине",
    "heroText": "Ар бир чекти, ар бир сменаны жана кампадагы ар бир граммды көргөн жардамчы. Ал сиз сурай электе эле алдын ала айтат, кеңеш берет жана аракет кылат.",
    "explore": "Эмне кыла алат",
    "notify": "Мага биринчи кабарлагыла",
    "notified": "Сиз биринчилердин тизмесиндесиз",
    "notifyDone": "Даяр! Coca AI ишке киргенин биринчилерден болуп билесиз.",
    "featuresTitle": "Супер күчтөр —",
    "featuresAccent": "бүт командага",
    "featuresText": "Мекемеңиздин маалыматтарында үйрөтүлгөн нейротармак: меню, сатуулар, кампа, кызматкерлер жана коноктор — бир сүрөттө.",
    "finalEyebrow": "Тамак-аш тармагынын келечеги",
    "soonBig": "Жакында",
    "finalText": "Биз Coca AI'ды азыр үйрөтүп жатабыз. Арыз калтырыңыз — мекемеңиз биринчилерден болуп кирүү алат.",
    "chat": {
      "button": "Coca AI — жардамчы",
      "eyebrow": "Coca AI · бета",
      "ask": "Суроо берүү",
      "text": "Сатуу, меню, официанттар, эсептен чыгаруу же кампа жөнүндө сураңыз — жардамчы филиалыңыздын отчётторун өзү карап, сандар менен жооп берет. Ролуңузга уруксат берилгенди гана көрөт.",
      "subtitle": "Филиалыңыздын маалыматы боюнча жооп берет",
      "live": "Иштеп жатат",
      "hello": "Саламатсызбы! Мен бул филиалдын отчётторун карайм. Мисалы, сураңыз:",
      "suggestions": {
        "yesterday": "Кечээки күн кандай өттү?",
        "menu": "Айдын ичинде кайсы тамактар эң аз сатылды?",
        "stock": "Кампада эмне түгөнүп баратат?",
        "waiters": "Жуманын эң мыкты официанты ким?"
      },
      "placeholder": "Сурооңуз…",
      "send": "Жөнөтүү",
      "clear": "Кайра баштоо",
      "voice": "Үн менен киргизүү",
      "voiceStop": "Жазууну токтотуу",
      "voiceDenied": "Микрофонго уруксат жок — браузердин жөндөөлөрүнөн уруксат бериңиз.",
      "voiceFailed": "Сүйлөгөнүңүз таанылган жок. Кайра аракет кылыңыз.",
      "thinking": "Маалыматты карап жатам…",
      "sources": "Караган",
      "tools": {
        "sales_report": "сатуу",
        "menu_report": "тамактар боюнча сатуу",
        "waiters_report": "официанттар",
        "writeoffs_report": "эсептен чыгаруу",
        "products_report": "азыктар",
        "finance_report": "финансы",
        "low_stock": "кампа"
      },
      "empty": "Жооп түзө алган жокмун. Башкача сурап көрүңүз.",
      "notConfigured": "Жардамчы туташкан эмес: серверде ЖИ ачкычы (Claude же Gemini) коюлган эмес.",
      "unavailable": "Жардамчы убактылуу жеткиликсиз. Бир мүнөттөн кийин кайталаңыз.",
      "disclaimer": "Жоопторду ЖИ даярдайт — маанилүү чечимдерди отчёттор менен салыштырыңыз."
    },
    "demo": {
      "eyebrow": "Жөн гана сураңыз",
      "heading": "Бизнес менен адамдын тилинде сүйлөшүңүз",
      "text": "Чыпкалар да, жүктөөлөр да жок. Башкаруучудан сурагандай сураңыз — Coca AI сандар, себептер жана даяр иш-план менен жооп берет.",
      "title": "Coca AI",
      "subtitle": "Аналитик, ашпозчу жана маркетолог бир терезеде",
      "thinking": "ИИ ойлонуп жатат",
      "dialogs": {
        "revenue": {
          "q": "Шейшембиде эмне үчүн киреше 18% аз болду?",
          "a": "Орточо чек өзгөргөн жок, бирок кечинде 40 конок аз болду: жамгыр жана футбол. Ушундай күндөрү «экөөнө кечки тамак» комбосу иштейт — кийинки шейшембиге иштетебизби?"
        },
        "purchase": {
          "q": "Дем алыш күндөргө жеткирүүчүлөрдөн эмне заказ кылуу керек?",
          "a": "Болжол: жумуш күндөрүнө караганда +35%. Уй эти — 14 кг, каймак — 9 л, лосось — 6 кг. Заказдардын долбоорлору даяр, ырастоо гана калды."
        },
        "menu": {
          "q": "Менюдан кайсы тамактарды алып салуу керек?",
          "a": "3 позиция сейрек сатылат жана дээрлик маржа бербейт. «Креветка кошулган паста» — сиздин жылдызыңыз: аны менюда жогору көтөрүңүз, андан түшкөн киреше 12% өсүшү мүмкүн."
        }
      }
    },
    "features": {
      "forecast": {
        "title": "Суроо-талап болжолу",
        "text": "Аба ырайын, майрамдарды жана шаардагы иш-чараларды эске алып, конокторду, кирешени жана ашкананын жүгүн саат сайын алдын ала айтат.",
        "tag": "Болжолдоочу аналитика"
      },
      "purchasing": {
        "title": "Автосатып алуу",
        "text": "Эч нерсе түгөнбөшү жана эч нерсе бузулбашы үчүн эмнени жана канча заказ кылууну өзү эсептейт.",
        "tag": "Нөл чыгым"
      },
      "menu": {
        "title": "ИИ-ашпозчу",
        "text": "Менюнун жылдыздарын жана артыкчасын табат, бааларды жана кампада бар нерседен жаңы тамактарды сунуштайт.",
        "tag": "Меню-инжиниринг"
      },
      "fraud": {
        "title": "Кыянаттык радары",
        "text": "Шектүү өчүрүүлөрдү, арзандатууларды жана жетишпестиктерди адатка айланганга чейин байкайт.",
        "tag": "24/7 коргоо"
      },
      "staff": {
        "title": "Акылдуу график",
        "text": "Сменаларды жүктөм болжолуна жараша түзөт: эң көп учурда адам жетиштүү, тынч сааттарда ашыкчасы жок.",
        "tag": "Эмгек акыга үнөм"
      },
      "marketing": {
        "title": "Автопилоттогу маркетинг",
        "text": "Конокторду сегменттерге бөлөт, ар бирине SMS жана акцияларды жазат жана жөнөтүүгө эң ыңгайлуу учурду өзү тандайт. Көптөн бери келбегендерди кайтарат.",
        "tag": "Жекелештирүү"
      },
      "voice": {
        "title": "Үн жардамчысы",
        "text": "Официант заказды айтат — касса аны жазып алат. Колдор бош, ката азыраак.",
        "tag": "Үн → заказ"
      }
    },
    "stats": {
      "title": "Coca AI'ды ушул максаттар үчүн үйрөтүп жатабыз",
      "waste": {
        "value": "−30%",
        "label": "азык-түлүк чыгымы"
      },
      "check": {
        "value": "+15%",
        "label": "орточо чекке"
      },
      "hours": {
        "value": "10 с",
        "label": "башкаруучуга жумасына үнөм"
      },
      "always": {
        "value": "24/7",
        "label": "дайыма байланышта, дем алышсыз"
      }
    },
    "steps": {
      "title": "Бул кантип иштейт",
      "data": {
        "title": "Маалымат",
        "text": "Сатуулар, кампа, сменалар жана коноктор Coca'да чогултулган — эч нерсе тууралоонун кереги жок."
      },
      "brain": {
        "title": "Интеллект",
        "text": "Модель таблицаларда көрүнбөгөн мыйзам ченемдүүлүктөрдү таап, аларды жөнөкөй сөз менен түшүндүрөт."
      },
      "action": {
        "title": "Аракет",
        "text": "Ар бир кеңеште баскыч бар: заказ кылуу, акция баштоо, графикти оңдоо. Чечим дайыма сизде."
      }
    }
  },
  "warehouse": {
    "warehouse": "Кампа",
    "pick": "Кампа",
    "kinds": {
      "main": "Негизги",
      "kitchen": "Ашкана",
      "bar": "Бар",
      "central": "Борбордук",
      "other": "Башка"
    },
    "title": "Кампалар",
    "description": "Калдыктар кампалар боюнча сакталат. Негизги кампадан сатуулар техкарта боюнча эсептен чыгат, ашкана менен бар товарды которуу аркылуу алат.",
    "add": "Кампа кошуу",
    "editTitle": "Кампа",
    "name": "Аталышы",
    "namePlaceholder": "Ысык цехтин ашканасы",
    "kind": "Максаты",
    "mainKindHint": "Негизги кампанын максаты өзгөрбөйт",
    "negative": "Минуска кетүүгө уруксат",
    "negativeHint": "Калдыктан ашык эсептен чыгаруу жана которуу бөгөттөлбөйт",
    "negativeShort": "Минуска болот",
    "makeDefault": "Негизги кылуу",
    "defaultHint": "Техкарта боюнча сатуулар ушул кампадан эсептен чыгат",
    "default": "Негизги",
    "defaultChanged": "Негизги кампа: {{name}}",
    "deleteTitle": "«{{name}}» кампасын өчүрөсүзбү?",
    "deleteHint": "Жолдо которуусу жок бош кампаны гана өчүрүүгө болот.",
    "count": "Кампалар: {{count}}",
    "limit": "тарифтин лимити — {{n}}",
    "products": "Калдыгы бар продукттар",
    "openStock": "Калдыктар",
    "onlyMain": "Азырынча негизги кампа гана",
    "onlyMainHint": "Ашкана, бар же борбордук кампа кошуп, товарды алардын ортосунда которуңуз."
  },
  "expiry": {
    "title": "Жарактуулук мөөнөтү",
    "description": "Филиалдын кампаларындагы мөөнөтү бар партиялар. Сатуу жана эсептен чыгаруу эң мурун бүтө турганынан башталат.",
    "expired": "Мөөнөтү өткөн партиялар",
    "soon": "{{n}} күндө бүтөт",
    "filter": "Көрсөтүү",
    "states": {
      "expired": "Мөөнөтү өткөн",
      "soon": "Жакында бүтөт",
      "dated": "Мөөнөтү барлар",
      "all": "Бардык партиялар"
    },
    "days": "Мөөнөт",
    "inDays": "{{count}} күндүн ичинде",
    "received": "Келди",
    "expiresAt": "Жарактуу",
    "noDate": "Мөөнөтсүз",
    "overdue": "{{count}} күн мурун өттү",
    "today": "Бүгүн бүтөт",
    "left": "{{count}} күн калды",
    "writeoff": "Эсептен чыгаруу",
    "writeoffTitle": "«{{name}}» эсептен чыгарылсынбы?",
    "writeoffHint": "{{qty}} {{sum}} суммасына эсептен чыгат. Мөөнөтү эң жакын партиялар биринчи чыгат.",
    "writeoffComment": "Жарактуулук мөөнөтү {{date}} чейин",
    "writtenOff": "Эсептен чыгарылды",
    "empty": "Мөөнөтү бүтүп жаткан партия жок",
    "emptyExpired": "Мөөнөтү өткөн партия жок",
    "emptyHint": "Сатып алууда мөөнөттү көрсөтүңүз же продукттун сактоо мөөнөтүн коюңуз — ал өзү коюлат."
  },
  "transfers": {
    "title": "Которуулар",
    "description": "Кампалар ортосунда товар: филиалдын ичинде — дароо, башка филиалга — кабыл алынганга чейин «жолдо».",
    "new": "Жаңы которуу",
    "from": "Каяктан",
    "to": "Каякка",
    "pickBoth": "Эки кампаны тең тандаңыз",
    "addLines": "Продукттарды жана санын кошуңуз",
    "send": "Жөнөтүү",
    "move": "Которуу",
    "externalHint": "«{{branch}}» филиалынын кампасы: товар «жолдо» болот, алуучуда калдык кабыл алынгандан кийин пайда болот.",
    "internalHint": "Сиздин филиалдын кампасы: товар дароо которулат.",
    "doneInternal": "№{{n}} которуу өткөрүлдү",
    "doneSent": "№{{n}} которуу «{{branch}}» филиалына жөнөтүлдү",
    "titleN": "№{{n}} которуу",
    "sent": "Жөнөтүлдү",
    "received": "Кабыл алынды",
    "receive": "Кабыл алуу",
    "receiveHint": "Санын текшериңиз: аз келсе — чыныгы санын жазыңыз, жетишпестик катталат.",
    "receiveComment": "Кабыл алуу боюнча комментарий",
    "receiveCommentPlaceholder": "Мисалы: пакет бузулган",
    "receivedToast": "№{{n}} которуу кабыл алынды",
    "cancel": "Которууну жокко чыгаруу",
    "cancelTitle": "№{{n}} которуу жокко чыгарылсынбы?",
    "cancelHint": "Товар жөнөтүүчү кампага кайтат.",
    "print": "Акт",
    "actTitle": "№{{n}} которуу акты",
    "signFrom": "Берген",
    "signTo": "Кабыл алган",
    "shipped": "Жөнөтүлдү",
    "receivedAt": "Кабыл алынды",
    "shortage": "Жетишпестик",
    "shortageNote": "Кабыл алууда жетишпестик: {{sum}}.",
    "statuses": {
      "in_transit": "Жолдо",
      "received": "Кабыл алынды",
      "cancelled": "Жокко чыгарылды"
    },
    "incoming": "Кирүүчү которуулар: {{count}}",
    "incomingHint": "Товар сиздин филиалга жөнөтүлдү — калдыкта пайда болушу үчүн кабыл алыңыз.",
    "showIncoming": "Көрсөтүү",
    "direction": "Багыты",
    "dirAll": "Баары",
    "dirIn": "Кирүүчү",
    "dirOut": "Чыгуучу",
    "allStatuses": "Бардык статустар",
    "route": "Маршрут",
    "empty": "Азырынча которуу жок",
    "emptyHint": "Продукттарды кампадан ашканага же башка филиалга которуңуз."
  },
  "production": {
    "suggest": "План сунуштоо",
    "suggestComment": "Болжол боюнча",
    "suggestCreated": "Пландалган заказдар: {{count}}",
    "suggestTitle": "{{date}} үчүн болжол боюнча план",
    "suggestHint": "{{weeks}} жуманын ошол эле күнүндөгү орточо чыгым + {{pct}}% запас − кампалардагы калдык − пландалганы.",
    "suggestCreate": "Пландоо: {{count}}",
    "suggestEmpty": "Техкартасы бар жарым фабрикат жок",
    "suggestEmptyHint": "«Жарым фабрикат» түрүндөгү продукт түзүп, анын техкартасын жарыялаңыз.",
    "suggestSales": "Жумалар боюнча чыгым",
    "suggestAvg": "Болжол",
    "suggestHave": "Бар жана планда",
    "suggestMake": "Жасоо",
    "title": "Өндүрүш",
    "description": "Техкарта боюнча жарым фабрикаттар: күндүк план, так өздүк нарк менен чыгаруу, жарактуулук мөөнөтү жана этикеткалар.",
    "new": "Өндүрүштү пландоо",
    "newHint": "Техкартасы бар жарым фабрикатты жана канча жасоону тандаңыз — чийки затка муктаждык өзү эсептелет.",
    "plan": "Пландоо",
    "product": "Жарым фабрикат",
    "productHint": "«Жарым фабрикат» түрү, жарыяланган техкартасы менен",
    "productPlaceholder": "Камыр, соус, сорпо…",
    "qty": "Канча жасоо керек",
    "date": "Күнү",
    "rawWarehouse": "Чийки зат кампасы",
    "outWarehouse": "Даяр продукция кампасы",
    "requirements": "Чийки затка муктаждык",
    "estTotal": "Болжолдуу нарк",
    "shortagesTitle": "Жетишпеген продукттар: {{count}}",
    "shortagesHint": "Чыгарууга чейин продукттарды сатып алыңыз же чийки зат кампасына которуңуз.",
    "fillProduct": "Жарым фабрикатты жана санын тандаңыз",
    "created": "№{{n}} заказ пландалды",
    "raw": "Чийки зат",
    "semi": "ЖФ",
    "need": "Керек",
    "used": "Эсептен чыкты",
    "cost": "Нарк",
    "available": "Кампада",
    "short": "{{qty}} жетишпейт",
    "enough": "Жетишет",
    "estCost": "Болжол",
    "completeTitle": "Чыгаруу: {{name}}",
    "completeHint": "Чийки зат кампадан эсептен чыгат, жарым фабрикат кампага мөөнөтү бар партия болуп келет.",
    "complete": "Чыгарууну өткөрүү",
    "actual": "Чыныгы чыгым",
    "planned": "План: {{qty}}",
    "expiresAt": "Жарактуу",
    "shelfLife": "Продукттун сактоо мөөнөтү: {{count}} күн",
    "noShelfLife": "Продукттун сактоо мөөнөтү коюлган эмес",
    "deviation": "Чыгымдын пландан четтөөсү: {{pct}}%",
    "customUsage": "Чыгым техкартадан айырмаланды",
    "customUsageHint": "Чийки заттын чынында канчасы кеткенин жазыңыз",
    "shortWarn": "Кампада чийки зат керектүүдөн аз: кампа минуска уруксат бербесе, чыгаруу өтпөйт.",
    "fillActual": "Чыныгы чыгымды жазыңыз",
    "completedToast": "№{{n}} чыгаруу өткөрүлдү",
    "start": "Баштоо",
    "cancel": "Жокко чыгаруу",
    "cancelTitle": "№{{n}} заказ жокко чыгарылсынбы?",
    "cancelHint": "Калдыктар өзгөрбөйт.",
    "cancelDoneTitle": "№{{n}} чыгаруу жокко чыгарылсынбы?",
    "cancelDoneHint": "Чийки зат кампага кайтат, жарым фабрикат эсептен чыгат. Эгер ал колдонулуп кетсе — жокко чыгаруу өтпөйт.",
    "statuses": {
      "planned": "Пландалды",
      "in_progress": "Иште",
      "completed": "Даяр",
      "cancelled": "Жокко чыгарылды"
    },
    "planShort": "План",
    "fact": "Факт",
    "rawCost": "Чийки заттын наркы",
    "unitCost": "{{unit}} үчүн өздүк нарк",
    "unitCostShort": "Өздүк нарк",
    "lowYield": "Чыгым пландан {{pct}}% аз — салынышын жана жоготууларды текшериңиз.",
    "label": "Этикетка",
    "labelHint": "Аталышы, чыгарылган күнү, {{date}} чейин жарактуу, ашпозчу",
    "copies": "Нуска",
    "printLabel": "Этикеткаларды басуу",
    "labelMade": "Жасалды",
    "labelUntil": "Жарактуу",
    "labelQty": "Саны",
    "labelBy": "Ашпозчу",
    "createdBy": "Түзгөн: {{name}}, {{at}}",
    "completedBy": "Чыгарган: {{name}}, {{at}}",
    "yield": "Чыгым {{pct}}%",
    "prevDay": "Мурунку күн",
    "nextDay": "Кийинки күн",
    "today": "Бүгүн",
    "addToPlan": "Планга кошуу",
    "emptyDay": "Бул күнгө эч нерсе пландалган эмес",
    "emptyDayHint": "Даярдоолорду пландаңыз — ашкана аларды ушул жерден көрөт.",
    "emptyColumn": "Бош",
    "allStatuses": "Бардык статустар",
    "planFact": "План / факт",
    "empty": "Өндүрүш заказдары жок",
    "tabPlan": "Күндүк план",
    "tabHistory": "Бардык заказдар",
    "tabReport": "Отчёт",
    "repOrders": "Чыгаруулар",
    "repLowYield": "Чыгымы пландан төмөн позициялар",
    "repYield": "Чыгым",
    "repEmpty": "Бул мезгилде чыгаруу жок"
  },
  "promo": {
    "badge": "Кошумча · туташтырылган эмес",
    "genericTagline": "«{{name}}» сиздин тарифке кирбейт. Туташтырыңыз — бөлүм дароо иштей баштайт.",
    "connect": "Туташтыруу",
    "connectFor": "Айына {{price}} туташтыруу",
    "changePlan": "Тарифти алмаштыруу",
    "openSubscription": "Жазылууну ачуу",
    "askOwner": "Ээси же администратор туташтыра алат — «Жазылуу» бөлүмүн ачууну сураныңыз.",
    "allAddons": "Бардык кошумчалар",
    "inPlans": "Тарифке кирет: {{plans}}",
    "fineprint": "Адегенде сумманы көрсөтөбүз — туташтыруу сиз ырастагандан кийин гана. Каалаган убакта өчүрсөңүз болот.",
    "insideTitle": "Ичинде эмне бар",
    "bandTitle": "Сынап көрөсүзбү?",
    "bandText": "«{{name}}» бир мүнөттө иштейт — маалыматтар жана жөндөөлөр сакталат.",
    "items": {
      "inventory_pro": {
        "title": "Жоготуусуз кампа: бир нече кампа, мөөнөттөр жана которуулар",
        "tagline": "Ашкана, бар жана борбордук кампа — ар биринин өз калдыгы бар. Система жарактуулук мөөнөтүн көзөмөлдөйт, биринчи бузула тургандарын эсептен чыгарат жана товарды эки чыкылдатуу менен которот.",
        "b1": {
          "t": "Мөөнөттөр көзөмөлдө",
          "d": "Ар бир партия өз мөөнөтүн эстейт. Ар күнү эртең менен — бүтүп жаткандардын тизмеси, сатуу эң «эскисинен» башталат."
        },
        "b2": {
          "t": "Бир нече кампа",
          "d": "Негизги кампа, ашкана, бар, тармактын борбордук кампасы — калдык жана нарк ар бири боюнча өзүнчө."
        },
        "b3": {
          "t": "Түйүндөр ортосунда которуу",
          "d": "Кампа → ашкана — дароо; башка филиалга — кабыл алынганга чейин «жолдо». Жетишпестик өзү катталат."
        },
        "b4": {
          "t": "Аз чыгым — көп пайда",
          "d": "Эмне жана канча суммага бузулганы турганы көрүнөт — убагында колдонуп же акцияга салып үлгүрөсүз."
        },
        "f1": "FEFO: биринчи эрте бүтө турганы кетет",
        "f2": "Партиянын мөөнөтү: сатып алууда же сактоо мөөнөтү боюнча өзү",
        "f3": "Тиркемеде жана Telegramда «бүтүп жатат» эскертүүсү",
        "f4": "Басууга акты менен которуулар",
        "f5": "Ар бир кампа боюнча калдыктар жана кыймыл карточкасы",
        "f6": "Өзүнчө кампанын инвентаризациясы",
        "who": "Ашканасы жана бары бар мекемелер, борбордук кампасы бар тармактар жана тез бузулуучу продукттар менен иштегендер үчүн."
      },
      "production": {
        "title": "Жарым фабрикаттарды өндүрүү",
        "tagline": "Камыр, соустар, сорполор жана даярдоолор — техкарта боюнча, так өздүк нарк жана жарактуулук мөөнөтү менен. Ашпозчу күндүк планды, сиз ар бир килограммдын баасын көрөсүз.",
        "b1": {
          "t": "Күндүк план",
          "d": "Ашкана бүгүн эмнени жана канча даярдоону көрөт: «пландалды» → «иште» → «даяр»."
        },
        "b2": {
          "t": "Тыйынына чейин так нарк",
          "d": "Чийки зат техкарта боюнча эсептен чыгат, ЖФ наркы = чийки зат наркы ÷ чыныгы чыгым. Ал тамактардын наркына да кирет."
        },
        "b3": {
          "t": "Чыгымды көзөмөлдөө",
          "d": "Чыныгы чыгымдын пландан четтөөсү дароо көрүнөт — продукт кайда жоголгону түшүнүктүү."
        },
        "b4": {
          "t": "Этикеткалар жана мөөнөттөр",
          "d": "ЖФ партиясы жарактуулук мөөнөтүн алат, этикетка бир чыкылдатуу менен басылат: аталышы, күнү, мөөнөтү, ашпозчу."
        },
        "f1": "Иш башталганга чейин чийки затка муктаждык жана жетишпестик",
        "f2": "Бир аракет менен чыгаруу: чийки зат эсептен чыкты, ЖФ кампада",
        "f3": "Техкартадан айырмаланса, чийки заттын өз чыгымы",
        "f4": "Сатууда ун менен суу эмес, даяр ЖФ эсептен чыгат",
        "f5": "Отчёт: план, факт, чыгымдын четтөөсү, нарк",
        "f6": "Чыгарууну жокко чыгаруу — чийки затты кайтаруу менен сторно",
        "who": "Пиццериялар, нан бышыруучу жайлар, даярдоосу бар кафелер жана соус менен жарым фабрикатты алдын ала даярдаган ашканалар үчүн."
      },
      "procurement": {
        "title": "Сатып алуулар жана жеткирүүчүлөр",
        "tagline": "Бардык жеткирүүчүлөр, алардын эсептери, төлөө мөөнөттөрү жана карыздары — бир терезеде. Дептерсиз жана унутулган төлөмсүз.",
        "b1": {
          "t": "Жеткирүүчүлөргө карыз көзөмөлдө",
          "d": "Канча, кимге жана кайсы күнгө чейин төлөш керек — кечиктирүү эскертүүсү менен."
        },
        "b2": {
          "t": "Төлөмдөр жана аванстар",
          "d": "Кассадан накталай же которуу менен, бөлүп же алдын ала — баары өзү туура келет."
        },
        "b3": {
          "t": "Жеткирүүчүгө кайтаруу",
          "d": "Товар кайтарылды — карыз сатып алуу баасы боюнча өзү азаят."
        },
        "b4": {
          "t": "Бир мүнөттө салыштыруу акты",
          "d": "Мезгил боюнча салыштыруу актын басып, жеткирүүчү менен суроолорду жабасыз."
        },
        "f1": "Төлөө мөөнөтү бар жеткирүүчүлөр маалымдамасы",
        "f2": "Сатып алуу = мөөнөтү бар жеткирүүчүнүн эсеби",
        "f3": "Төлөө мөөнөтү жана кечиктирүү тууралуу эскертүү",
        "f4": "Товарды кайтаруу жана жеткирүүчүдөн акча кайтаруу",
        "f5": "Ар биринен эмне жана канчага сатып алынганы",
        "f6": "A4 салыштыруу акты",
        "who": "Жеткирүүчүлөр менен карызга же мөөнөт менен иштегендердин баары үчүн."
      },
      "finance": {
        "title": "Мекеменин финансылары",
        "tagline": "Пайда, чыгымдар жана акча агымы — ай аягында эмес, ар күнү. Акча кайда кетип жатканы жана чынында канча тапканыңыз көрүнөт.",
        "b1": {
          "t": "Каалаган мезгилге пайда",
          "d": "Киреше, өздүк нарк, эмгек акы, ижара жана башка чыгымдар — бир отчётто."
        },
        "b2": {
          "t": "Категориялар боюнча чыгымдар",
          "d": "Ижара, коммуналдык, маркетинг — бир секундда киргизилет, отчёт өзү эсептейт."
        },
        "b3": {
          "t": "Акча агымы",
          "d": "Накталай жана накталай эмес канча келип-кетти, сизге жана сиз канча карызсыз."
        },
        "b4": {
          "t": "Сандарга негизделген чечимдер",
          "d": "Эмнени кыскартып, эмнени өнүктүрүү керектиги түшүнүктүү."
        },
        "f1": "Пайда жана зыян отчёту",
        "f2": "Категория жана филиал боюнча чыгымдар",
        "f3": "Эмгек акы жана чайпулдар отчётко өзү кирет",
        "f4": "Конок жана жеткирүүчүлөр карызы — акча агымында",
        "f5": "Кассадан чыгымдар — дароо отчётто",
        "who": "Кирешени гана эмес, чыныгы пайданы билгиси келген ээлер үчүн."
      },
      "fraud": {
        "title": "Кыянаттыктан коргоо",
        "tagline": "Система ар саат сайын өчүрүүлөрдү, арзандатууларды, кайтарууларды жана жетишпестиктерди текшерип, шектүүсүн дароо билдирет. Сиз жок кезде да касса көзөмөлдө.",
        "b1": {
          "t": "Шектүүсү дароо көрүнөт",
          "d": "Ашканадан кийинки өчүрүүлөр, карта үчүн накталай кайтаруу, ченемден ашык арзандатуулар — бир лентада."
        },
        "b2": {
          "t": "Кызматкерлер боюнча тобокелдик",
          "d": "Ар бир кызматкердин тобокелдик баллы бар: кимге көңүл буруу керек экени көрүнөт."
        },
        "b3": {
          "t": "Telegramдагы эскертүүлөр",
          "d": "Олуттуусу — дароо, жумасына бир жолу — жыйынтык."
        },
        "b4": {
          "t": "Сиздин эрежелер",
          "d": "Ар бир эреженин босогосу мекемеңизге ылайыкталат."
        },
        "f1": "Ашканадан кийин позицияларды өчүрүү жана жокко чыгаруу",
        "f2": "Кайтаруулар, анын ичинде карта үчүн накталай",
        "f3": "Кол менен берилген арзандатуулардын үлүшү жана менюдан арзан сатуу",
        "f4": "Адаттан тыш чоң эсептен чыгаруулар",
        "f5": "Кассадагы жетишпестиктер жана алардын кайталанышы",
        "f6": "Чечимдер: текшерилди, жалган коркунуч, ырасталды",
        "who": "Мекемеде күн сайын боло албаган ээлер үчүн."
      },
      "sms": {
        "title": "Конокторго SMS-жөнөтүүлөр",
        "tagline": "Керектүү учурда өзүңүздү эстетиңиз: акция, жаңы меню, туулган күн менен куттуктоо. Тандалган конокторго эки чыкылдатуу менен жөнөтүү.",
        "b1": {
          "t": "Так максатка",
          "d": "Сегменттер жана тегдер: туруктуу, көптөн бери келбегендер, жуманын туулган күндүүлөрү."
        },
        "b2": {
          "t": "Макулдугу менен гана",
          "d": "Билдирүү алууга макул болгон конокторго гана жөнөтүлөт."
        },
        "b3": {
          "t": "Ачык чыгым",
          "d": "Айга канча SMS калганы көрүнөт; 80% жана 100% болгондо эскертүү келет."
        },
        "b4": {
          "t": "Конокторду кайтарыңыз",
          "d": "SMSтеги кыска сунуш — жана конок кайра сизде."
        },
        "f1": "Сегмент же тег боюнча жөнөтүү",
        "f2": "Туулган күн менен куттуктоолор",
        "f3": "Жөнөтүүгө чейин SMS бөлүктөрүн эсептөө",
        "f4": "Өзүңүзгө сыноо SMS",
        "f5": "Жеткирүү статустары",
        "who": "Туруктуу кардарларды көбүрөөк көргүсү келген, конок базасы бар мекемелер үчүн."
      },
      "services": {
        "title": "Кызматтар жана ижара",
        "tagline": "Караоке, бильярд, кальян, VIP-бөлмөлөр — сервердеги таймер менен сааттык тарификация, минималдык заказ жана персоналдын комиссиялары өзү эсептелет.",
        "b1": {
          "t": "Ишенимдүү таймер",
          "d": "Убакыт серверде жүрөт, тыныгуулар эсепке алынат — конок менен талаш жок."
        },
        "b2": {
          "t": "Ийкемдүү тарифтер",
          "d": "Сааттын баасы, тегеректөө кадамы, минимум, баскычтар жана график боюнча баа."
        },
        "b3": {
          "t": "Бөлмөнүн минималдык заказы",
          "d": "Жетпей калса — кошумча төлөм эсепке өзү кошулат."
        },
        "b4": {
          "t": "Персоналга комиссиялар",
          "d": "Белгиленген, пайыз же аралаш — дароо отчётто."
        },
        "f1": "Сааттык жана даана кызматтар",
        "f2": "Минималдык заказы бар бөлмөлөр",
        "f3": "Сессияны тындыруу жана улантуу",
        "f4": "Кызмат дароо коноктун эсебинде",
        "f5": "Кызматкерлердин комиссиялары жана отчёт",
        "who": "Караоке, лаунж-барлар, бильярдканалар, кальянканалар жана VIP-бөлмөсү бар мекемелер үчүн."
      },
      "banquets": {
        "title": "Банкеттер жана иш-чаралар",
        "tagline": "Арыздан эсепти жапканга чейин: конокко меню, депозиттер, залдарды брондоо жана нарк — баары банкеттин бир карточкасында.",
        "b1": {
          "t": "Бир да арыз жоголбойт",
          "d": "Арыз → алдын ала → ырасталды → жүрүп жатат → бүттү."
        },
        "b2": {
          "t": "Чаташуусуз депозиттер",
          "d": "Депозит кабыл алынып, банкеттин эсебине өзү эсептелет."
        },
        "b3": {
          "t": "Зал эки жолу сатылбайт",
          "d": "Ырасталган банкет залды брондор үчүн бөгөттөйт."
        },
        "b4": {
          "t": "Нарк жана продукттар",
          "d": "Банкеттин маржасы жана канча продукт сатып алуу керек экени дароо көрүнөт."
        },
        "f1": "Конокко жана бүт дасторконго меню",
        "f2": "Накталай жана которуу менен депозиттер",
        "f3": "Коммерциялык сунушту басуу",
        "f4": "Техкарта боюнча продуктка муктаждык",
        "f5": "Кассада банкет заказы бир чыкылдатуу менен",
        "who": "Майрам жана корпоративдерди кабыл алган ресторандар, банкет залдары жана кафелер үчүн."
      },
      "promotions_pro": {
        "title": "Акциялар жана промокоддор",
        "tagline": "Бактылуу сааттар, комбо, «экинчиси белекке», белектер жана промокоддор — касса кассирдин катасысыз эң пайдалуу акцияны өзү колдонот.",
        "b1": {
          "t": "Каалаган механика",
          "d": "Пайыз же сумма менен арзандатуу, комбо, «1+1», заказга белек."
        },
        "b2": {
          "t": "Так шарттар",
          "d": "Жуманын күндөрү, сааттар, даталар, филиалдар, заказдын түрү, биринчи заказ, коноктун теги."
        },
        "b3": {
          "t": "Чыр-чатаксыз",
          "d": "Эксклюзивдүү жана шайкеш акциялар: конок эң пайдалуусун алат."
        },
        "b4": {
          "t": "Натыйжа сандарда",
          "d": "Отчёт: акция канча жолу иштеди жана канчага турду."
        },
        "f1": "Бактылуу сааттар, анын ичинде түн ортосунан ашып",
        "f2": "Лимиттүү промокоддор",
        "f3": "Комбо-топтомдор жана «1+1»",
        "f4": "Заказга белек",
        "f5": "Акциялар боюнча отчёт",
        "who": "Тынч сааттарды толтуруп, орточо чекти көтөргүсү келген мекемелер үчүн."
      },
      "delivery": {
        "title": "Өз жеткирүү",
        "tagline": "Картадагы зоналар, курьерлер, статустар жана курьерлердеги акча — жеткирүү саат сыяктуу иштейт, конок заказдын статусун көрөт.",
        "b1": {
          "t": "Зоналар жана баа",
          "d": "Полигондор жана радиустар, минималдык заказ, суммадан баштап акысыз жеткирүү."
        },
        "b2": {
          "t": "Жеткирүү тактасы",
          "d": "Жаңы → даярдалып жатат → жолдо → жеткирилди: таймерлер кечигүүнү көрсөтөт."
        },
        "b3": {
          "t": "Курьердин экраны",
          "d": "«Менин жеткирүүлөрүм», статустар жана жайгашкан жер — телефондон."
        },
        "b4": {
          "t": "Накталай көзөмөлдө",
          "d": "Ар бир курьерде канча акча бар экени көрүнөт; кассага өткөрүү — бир чыкылдатуу."
        },
        "f1": "Даректи зона боюнча текшерүү",
        "f2": "Курьерди дайындоо",
        "f3": "Конок үчүн жеткирүү статусу",
        "f4": "Курьердин накталай акчаны өткөрүүсү",
        "f5": "Жеткирүүлөр боюнча отчёт",
        "who": "Өз курьерлери бар мекемелер үчүн."
      },
      "reservations": {
        "title": "Столдорду брондоо",
        "tagline": "Кассада жана ERPде брондор: стол алдын ала брондолгон деп белгиленет — эч ким конокторду башканын ордуна отургузбайт.",
        "b1": {
          "t": "Брондору бар зал",
          "d": "Кайсы столдор бош эмес, бош жана брондолгону көрүнөт."
        },
        "b2": {
          "t": "Кабатташуусуз",
          "d": "Бир столго кабатташкан бронду түзүүгө болбойт."
        },
        "b3": {
          "t": "Бир саат мурун «бронь»",
          "d": "Коноктор келгенге чейин стол өзү белгиленет."
        },
        "b4": {
          "t": "Коноктун тарыхы",
          "d": "Бронь кардардын карточкасына байланат."
        },
        "f1": "Кассадан жана ERPден брондор",
        "f2": "Конок саны жана комментарий",
        "f3": "Которуу жана жокко чыгаруу",
        "f4": "Кассада интернетсиз да иштейт",
        "f5": "Күндүк брондор тизмеси",
        "who": "Столдор алдын ала брондолгон ресторандар жана кафелер үчүн."
      },
      "analytics_pro": {
        "title": "Кеңейтилген аналитика",
        "tagline": "ABC-талдоо, меню-инжиниринг, food cost жана жүктөлүштүн жылуулук картасы — кайсы тамактар бизнести тойгузуп, кайсылары артка тартканы көрүнөт.",
        "b1": {
          "t": "Меню-инжиниринг",
          "d": "Жылдыздар, жумушчу аттар, табышмактар жана аутсайдерлер: эмнени жылдыруу, өзгөртүү же алып салуу керек."
        },
        "b2": {
          "t": "ABC-талдоо",
          "d": "Позициялардын кайсы 20% кирешенин жана маржанын 80% берет."
        },
        "b3": {
          "t": "Food cost жана labor cost",
          "d": "Күндөр жана категориялар боюнча продукт жана эмгек наркы."
        },
        "b4": {
          "t": "Жылуулук картасы",
          "d": "Жуманын күндөрү жана сааттар боюнча жүктөлүш — чыныгы конок агымына жараша смена графиги."
        },
        "f1": "Киреше, маржа, сан, продукт жана конок боюнча ABC",
        "f2": "Меню матрицасы",
        "f3": "Prime cost жана эмгек саатына киреше",
        "f4": "Филиалдарды салыштыруу",
        "f5": "Excel үчүн CSV жүктөө",
        "who": "Сандарга таянып чечим кабыл алган ээлер жана башкаруучулар үчүн."
      },
      "telegram": {
        "title": "Ээсинин Telegram-боту",
        "tagline": "Күндүк киреше, кампа, жеткирүүчүлөргө төлөмдөр жана коркунучтар — кайда болбоңуз, түз Telegramда.",
        "b1": {
          "t": "Күндүк отчёт",
          "d": "Ар кечте — киреше, чектер, орточо чек, эң көп сатылган тамактар."
        },
        "b2": {
          "t": "Маанилүүсү — дароо",
          "d": "Кайтаруулар, сменаны жабуу, «кампада бүтүп жатат»."
        },
        "b3": {
          "t": "/today буйругу",
          "d": "Күндүн жыйынтыгы сураныч боюнча бир билдирүүдө."
        },
        "b4": {
          "t": "Ар кимге өзүнүкү",
          "d": "Кызматкер укугу жеткендерди гана алат."
        },
        "f1": "Филиалдар боюнча күндүк отчёт",
        "f2": "Сменалар жана кайтаруулар тууралуу эскертүүлөр",
        "f3": "Кампа: бүтүп жатат жана мөөнөтү өтүп жатат",
        "f4": "Жеткирүүчүлөргө төлөмдөр",
        "f5": "Бир шилтеме менен туташтыруу",
        "who": "Абалды дайыма билип тургусу келген ээлер жана башкаруучулар үчүн."
      },
      "qr_ordering": {
        "title": "QR-код менен заказ",
        "tagline": "Конок столдогу QRди сканерлеп, тамак тандап, заказ жөнөтөт — ал дароо кассада жана ашканада пайда болот. Күтүү аз, заказ көп.",
        "b1": {
          "t": "Официантты күтпөй",
          "d": "Конок даяр болгондо заказ берет — жана көбүрөөк алат."
        },
        "b2": {
          "t": "Түз ашканага",
          "d": "Заказ ашкананын экранына өзү кетет."
        },
        "b3": {
          "t": "Официантты жана эсепти чакыруу",
          "d": "Коноктун телефонундагы баскычтар — кассада эскертүү."
        },
        "b4": {
          "t": "Заказдын статусу",
          "d": "Конок тамак даярдалып жатканын көрөт."
        },
        "f1": "Ар бир стол үчүн басылуучу QR",
        "f2": "Тамактын варианттары жана модификаторлору",
        "f3": "Ошол эле эсепке кошумча заказ",
        "f4": "Заказ спамынан коргоо",
        "f5": "Официанттарга эскертүүлөр",
        "who": "Залда тейлөөсү бар кафелер жана ресторандар үчүн."
      },
      "debts": {
        "title": "Коноктордун карыздары",
        "tagline": "Туруктуу конокторго жана компания кызматкерлерине «карызга» сатуу — лимит, мөөнөт жана кассада төлөө менен. Дептерсиз.",
        "b1": {
          "t": "Конокко лимит",
          "d": "Касса насыя лимитинен ашырууга жол бербейт."
        },
        "b2": {
          "t": "Кассада төлөө",
          "d": "Смена аркылуу накталай; карыз өзү жабылат, эскилери — биринчи."
        },
        "b3": {
          "t": "Кечиктирүү отчёту",
          "d": "Ким, канча жана канчадан бери карыз."
        },
        "b4": {
          "t": "Түзөтүүлөр жана эсептен чыгаруу",
          "d": "Баары себеби менен жана журналда."
        },
        "f1": "Кассада «карызга» төлөө",
        "f2": "Бөлүп төлөө",
        "f3": "Карыздардын мөөнөтү",
        "f4": "Ар бир коноктун тарыхы",
        "f5": "Үмүтсүз карызды эсептен чыгаруу",
        "who": "Туруктуу коноктору жана корпоративдик кардарлары бар мекемелер үчүн."
      }
    }
  },
  "invSettings": {
    "title": "Кампанын жөндөөлөрү",
    "description": "Компаниянын бардык кампалары үчүн эрежелер.",
    "expiry": "Жарактуулук мөөнөтү",
    "blockExpired": "Мөөнөтү өткөн партиялардан сатпоо",
    "blockExpiredHint": "Сатуу адегенде жаңы партияларды алат; мөөнөтү өткөндөрү — башкасы жок болсо гана, жана эсептен чыгарууну күтөт",
    "warningDays": "Канча күн мурун эскертүү",
    "warningDaysHint": "Мөөнөтү ушул убакытта бүтө турган партиялар «Жакында бүтөт» жана эртең мененки билдирүүгө кирет",
    "production": "Өндүрүш",
    "explode": "Жарым фабрикат жок — чийки зат менен эсептен чыгаруу",
    "explodeHint": "Даяр жарым фабрикат жетишпесе, сатуу анын техкартасы боюнча чийки затты эсептен чыгарат. Өчүрсөңүз — жарым фабрикат минуска кетет жана аны даярдабаганы көрүнөт",
    "safety": "Өндүрүш планынын болжолуна запас",
    "safetyHint": "Орточо чыгымдан канча пайыз көп жасоо",
    "nothing": "Жөндөөлөр «Кампа (кеңейтилген)» же «Өндүрүш» кошумчалары менен пайда болот."
  },
  "locations": {
    "title": "Сактоо орундары",
    "short": "Орду",
    "description": "«{{name}}» кампасы: текчелер, муздаткычтар, зоналар",
    "placeholder": "Мисалы: №1 муздаткыч",
    "name": "Ордунун аталышы",
    "add": "Кошуу",
    "empty": "Азырынча орун жок",
    "emptyHint": "Текчелерди жана муздаткычтарды кошуңуз — алар боюнча инвентаризация жасоо ыңгайлуу.",
    "products": "Продукттар: {{count}}",
    "deleteTitle": "«{{name}}» ордун өчүрөсүзбү?",
    "deleteHint": "Продукттар кампада ордусуз калат.",
    "hint": "Продуктту орунга «Калдыктар» бөлүмүндө бекитсе болот: «Орду» тилкеси.",
    "all": "Бардык орундар",
    "pick": "Орунду тандаңыз",
    "countHint": "Бул орунга бекитилген продукттар эсептелет"
  },
  "purchaseRequests": {
    "tabRequests": "Арыздар",
    "tabSuggest": "Эмнени заказ кылуу керек",
    "suggest": {
      "purchaseComment": "Сунуштар боюнча: чыгым жана калдыктар",
      "coverDays": "Канча күнгө",
      "days": "{{count}} күн",
      "history": "Чыгымды кароо",
      "lastDays": "{{count}} күндө",
      "safety": "Запас",
      "showAll": "Чыгымы барлардын баарын көрсөтүү",
      "how": "{{history}} күндөгү чыгым (техкарталар боюнча сатуулар, эсептен чыгаруулар, өндүрүш) → акыркы жуманы эске алган күндүк болжол → {{cover}} күнгө +{{safety}}% запас, кошуу минималдык калдык, кемитүү калдык жана арыздардагысы.",
      "summaryMoney": "Заказ кылууну сунуштайбыз: {{count}} позиция, болжол менен {{sum}}",
      "summary": "Заказ кылууну сунуштайбыз: {{count}} позиция",
      "summaryHint": "Керектүүсүн белгилеп, санын оңдоп, арыз же дароо сатып алуу түзүңүз. Сумма — акыркы сатып алуунун баасы боюнча.",
      "selectAll": "Баарын тандоо",
      "lastPurchase": "{{date}} сатып алынган",
      "stock": "Калдык",
      "daysLeft": "~{{n}} күнгө жетет",
      "daily": "Күнүнө чыгым",
      "trendUp": "жума: +{{pct}}%",
      "trendDown": "жума: −{{pct}}%",
      "pending": "Арыздарда бар",
      "order": "Заказ кылуу",
      "estimate": "Болжол менен",
      "why": "Эмне үчүн",
      "reasons": {
        "negative": "Минуста",
        "below_min": "Минимумдан төмөн",
        "runs_out": "Жакында түгөнөт",
        "low_data": "Маалымат аз"
      },
      "empty": "Азырынча заказ кыла турган эч нерсе жок",
      "emptyHint": "Чыгым техкарталуу сатуулар жана эсептен чыгаруулар боюнча эсептелет. Продукттун карточкасында минималдык калдыкты коюңуз — качан сатып алуу керектигин айтабыз.",
      "toRequest": "Арыз түзүү"
    },
    "title": "Сатып алууга арыздар",
    "description": "Кызматкерлер эмне сатып алуу керектигин жазат — башкаруучу жактырат, арыз боюнча сатып алат же баш тартат. Ким жана качан жазганы, чечкени көрүнөт.",
    "new": "Жаңы арыз",
    "newHint": "Эмнени жана канча сатып алуу керек. Продуктту маалымдамадан тандаңыз же жөн гана атын жазыңыз.",
    "send": "Арызды жөнөтүү",
    "addLines": "Саны менен жок дегенде бир сап кошуңуз",
    "saved": "Арыз сакталды",
    "created": "№{{n}} арыз жөнөтүлдү",
    "editTitle": "№{{n}} арыз: өзгөртүү",
    "what": "Эмне сатып алуу керек",
    "whatPlaceholder": "Продукт же аты",
    "addAsText": "«{{name}}» маалымдамасыз кошуу",
    "lineNote": "Сапка эскертме",
    "lineNotePlaceholder": "Эскертме: маркасы, майлуулугу, өлчөмү…",
    "priority": "Шашылыштыгы",
    "priorities": {
      "normal": "Кадимки",
      "urgent": "Шашылыш"
    },
    "neededBy": "Качанга керек",
    "neededByShort": "{{date}} чейин керек",
    "comment": "Эскертме",
    "commentHint": "Эмне үчүн, кайсы иш-чарага, кайдан сатып алган жакшы",
    "commentPlaceholder": "Мисалы: ишембидеги банкетке, сүт түгөнүп баратат",
    "rejectReason": "Баш тартуунун себеби",
    "rejectReasonRequired": "Баш тартуунун себебин көрсөтүңүз",
    "decisionNote": "Авторго эскертме",
    "done": {
      "approve": "№{{n}} арыз жактырылды",
      "reject": "№{{n}} арызга баш тартылды",
      "purchased": "№{{n}} арыз жабылды — сатылып алынды"
    },
    "decision": {
      "approve": "№{{n}} арызды жактырасызбы?",
      "reject": "№{{n}} арызга баш тартасызбы?",
      "purchased": "№{{n}} арызды «сатылып алынды» деп белгилейсизби?"
    },
    "decisionHint": {
      "approve": "Автор билдирүү алат. Дароо сатып алса болот — «Сатып алууну тариздөө» баскычы.",
      "reject": "Автор баш тартуунун себебин көрөт.",
      "purchased": "Кампага киргизилбеген сатып алуу үчүн. Товар кампага келиши үчүн — «Сатып алууну тариздөө»."
    },
    "actions": {
      "approve": "Жактыруу",
      "reject": "Баш тартуу",
      "purchased": "Сатылып алынды",
      "cancel": "Кайтарып алуу",
      "makePurchase": "Сатып алууну тариздөө"
    },
    "cancelTitle": "№{{n}} арызды кайтарып аласызбы?",
    "history": {
      "created": "Түзгөн",
      "updated": "Өзгөрткөн",
      "approved": "Жактырган",
      "rejected": "Баш тарткан",
      "purchased": "Сатып алган",
      "cancelled": "Кайтарып алган"
    },
    "titleN": "Сатып алууга №{{n}} арыз",
    "purchaseLink": "{{date}} сатып алуу, {{sum}}",
    "commentBy": "{{name}} эскертмеси",
    "rejectedTitle": "Баш тартылды: {{name}}",
    "noteFrom": "{{name}} эскертмеси",
    "notInCatalog": "маалымдамада жок",
    "statuses": {
      "submitted": "Чечим күтүүдө",
      "approved": "Жактырылды",
      "purchased": "Сатылып алынды",
      "rejected": "Баш тартылды",
      "cancelled": "Кайтарылып алынды"
    },
    "pending": "Чечим күтүүдө: {{count}}",
    "pendingHint": "Кызматкерлер жооп күтүүдө — жактырыңыз, сатып алыңыз же баш тартыңыз.",
    "show": "Көрсөтүү",
    "approvedCount": "Жактырылып, сатып алууну күтүүдө: {{count}}",
    "approvedHint": "Арызды ачып, «Сатып алууну тариздөө» баскычын басыңыз — саптар өзү толтурулат.",
    "scope": "Кимдин арыздары",
    "scopeAll": "Баары",
    "scopeMine": "Меники",
    "search": "Товар же эскертме боюнча издөө",
    "author": "Ким жазды",
    "empty": "Азырынча арыз жок",
    "emptyHint": "Бир нерсе түгөнүп баратабы? Арыз жазыңыз — башкаруучу аны дароо көрөт.",
    "purchaseComment": "Сатып алууга №{{n}} арыз боюнча",
    "purchaseFor": "№{{n}} арыз боюнча сатып алуу ({{name}})",
    "textLinesHint": "Маалымдамада жок — кол менен кошуңуз: {{lines}}"
  },
  "requests": {
    "title": "Кампага арыздар",
    "description": "Филиал борбордук кампадан товар заказ кылат, кампа аны которуу менен жөнөтөт, филиал кабыл алат.",
    "new": "Жаңы арыз",
    "newHint": "Кампаңызга эмне жана канча керек. Жеткирүүчү кампа эскертүү алат.",
    "send": "Арыз жөнөтүү",
    "supplier": "Кайсы кампадан",
    "supplierHint": "Адатта тармактын борбордук кампасы",
    "target": "Кайсы кампага",
    "neededBy": "Качанга керек",
    "commentPlaceholder": "Мисалы: дем алыш күндөргө, банкет күтүлүүдө",
    "pickSupplier": "Жеткирүүчү кампаны тандаңыз",
    "created": "№{{n}} арыз жөнөтүлдү: {{wh}}",
    "titleN": "№{{n}} арыз",
    "ship": "Жөнөтүү",
    "reject": "Баш тартуу",
    "cancel": "Кайтарып алуу",
    "shippedToast": "№{{n}} арыз жөнөтүлдү — товар жолдо",
    "rejectTitle": "№{{n}} арыздан баш тартасызбы?",
    "rejectHint": "Филиал баш тартуунун себебин көрөт.",
    "rejectReason": "Баш тартуунун себеби",
    "openTransfer": "№{{n}} которуу",
    "transferN": "№{{n}} которуу",
    "neededByShort": "{{date}} чейин керек",
    "rejected": "Баш тартылды",
    "shipHint": "Санын текшериңиз: заказдан азыраак же товар жок болсо 0 жөнөтүүгө болот. «Жолдо» которуу түзүлөт.",
    "ordered": "Заказ кылынды",
    "ourStock": "Биздин кампада",
    "toShip": "Жөнөтүү",
    "shipped": "Жөнөтүлдү",
    "createdBy": "Түзгөн: {{name}}, {{at}}",
    "decidedBy": "Чечим: {{name}}, {{at}}",
    "statuses": {
      "submitted": "Жөнөтүүнү күтүүдө",
      "shipped": "Жөнөтүлдү",
      "received": "Алынды",
      "rejected": "Баш тартылды",
      "cancelled": "Кайтарылып алынды"
    },
    "incoming": "Кампаңызга арыздар: {{count}}",
    "incomingHint": "Филиалдар товар күтүп жатышат — жөнөтүңүз же баш тартыңыз.",
    "dirOut": "Биздин арыздар",
    "dirIn": "Биздин кампага",
    "empty": "Азырынча арыз жок",
    "emptyHint": "Борбордук кампадан товар заказ кылыңыз — ал которуу менен келет."
  },
  "conversions": {
    "title": "Бөлүү жана чогултуу",
    "description": "Бөлүү: туша → тамыр эт, жумшак эт, сөөктөр. Чогултуу: бир нече товар → топтом. Өздүк нарк чыгуулардын ортосунда бөлүнөт.",
    "new": "Бөлүү же чогултуу",
    "post": "Өткөрүү",
    "type": "Операция",
    "types": {
      "disassembly": "Бөлүү",
      "assembly": "Чогултуу"
    },
    "disHint": "Кирүүдө бир продукт — чыгууда бир нечеси. Кирүүнүн наркы үлүштөр боюнча бөлүнөт; үлүшсүз — чыгуулардын сатып алуу баасына (же санына) жараша.",
    "asmHint": "Кирүүдө бир нече продукт — чыгууда бирөө. Анын наркы = кирүүлөрдүн суммасы.",
    "template": "Шаблон",
    "pickTemplate": "Шаблондон толтуруу",
    "inputDis": "Эмнени бөлөбүз",
    "inputAsm": "Эмнеден чогултабыз",
    "outputDis": "Эмне чыкты",
    "outputAsm": "Эмне чогултулду",
    "byShares": "Нарктын үлүштөрүн көрсөтүү",
    "share": "Үлүш",
    "sharesSum": "Үлүштөрдүн суммасы: {{pct}}%",
    "autoHint": "Үлүштөр өзү эсептелет: чыгуулардын сатып алуу баасы боюнча, ал жок болсо — саны боюнча.",
    "preview": "Болжол: акыркы сатып алуу баасы боюнча {{sum}}",
    "fill": "Кирүүнү жана чыгууну толтуруңуз",
    "shares100": "Үлүштөрдүн суммасы 100% болушу керек",
    "doneDis": "Бөлүү өткөрүлдү",
    "doneAsm": "Чогултуу өткөрүлдү",
    "tplName": "Шаблондун аталышы, мисалы «Уйдун тушасы»",
    "saveTemplate": "Шаблон катары сактоо",
    "tplFill": "Шаблондун аталышын жана саптарын көрсөтүңүз",
    "tplSaved": "Шаблон сакталды",
    "templates": "Шаблондор",
    "useTemplate": "Шаблон боюнча өткөрүү",
    "tplDeleteTitle": "«{{name}}» шаблонун өчүрөсүзбү?",
    "deleteTitle": "Операцияны жокко чыгарасызбы?",
    "deleteHint": "Кирүү кампага кайтат, чыгуулар эсептен чыгат. Чыгуулар колдонулуп кетсе — жокко чыгаруу өтпөйт.",
    "cancelDoc": "Жокко чыгаруу",
    "dist": {
      "share": "Үлүштөр боюнча",
      "price": "Сатып алуу баасы боюнча",
      "qty": "Саны боюнча"
    },
    "input": "Кирүү",
    "output": "Чыгуу",
    "unitCost": "Өздүк нарк",
    "search": "Продукт же комментарий",
    "what": "Эмне → эмнеге",
    "empty": "Азырынча операция жок",
    "emptyHint": "Тушаны бөлүңүз же белек топтомун чогултуңуз — калдыктар жана нарк өзү жаңыланат."
  },
  "help": {
    "title": "Маалымдама",
    "description": "Coca'нын ар бир функциясын кантип жөндөп колдонуу — макалалар: {{count}}",
    "search": "Маалымдамадан издөө",
    "searchPlaceholder": "Мисалы: сатып алууну кантип өткөрүү, Z-отчёт, техкарта…",
    "results": "«{{q}}» боюнча табылды: {{count}}",
    "noResults": "Эч нерсе табылган жок",
    "noResultsHint": "Башка сөздөрдү колдонуп көрүңүз же колдоо кызматына жазыңыз.",
    "popular": "Эмнеден баштоо",
    "videos": "Видеосабактар",
    "videosHint": "Кыска роликтер: экранда кантип жасалат",
    "video": "Видео",
    "sections": "Маалымдаманын бөлүмдөрү",
    "allArticles": "Бардык макалалар ({{count}})",
    "contents": "Маалымдаманын мазмуну",
    "breadcrumbs": "Жол",
    "inPlan": "Тарифте бар: {{name}}",
    "notInPlan": "Туташтырылган эмес: {{name}}",
    "noPermission": "Ролуңузда кирүү укугу жок",
    "openSection": "Бөлүмдү ачуу",
    "howToConnect": "Кантип туташтыруу",
    "related": "Байланыштуу макалалар",
    "notFound": "Жооп тапкан жоксузбу?",
    "notFoundHint": "Сурооңузду жазыңыз — колдоо кызматы программанын ичинде жооп берет.",
    "askSupport": "Колдоо кызматына жазуу",
    "hint": "Кеңеш",
    "more": "Маалымдамада кененирээк",
    "aboutSection": "Бул бөлүм боюнча маалымдама",
    "ruOnly": "Маалымдама азырынча орус тилинде. Котормолор жакынкы жаңыртууларда чыгат."
  },
  goals: {
    title: "Максаттар жана жетишкендиктер",
    description: "Мекеме, филиал жана ар бир кызматкер үчүн максаттар, рейтинг жана команданын жетишкендиктери. Аткарылышы ар саат сайын өзү эсептелет.",
    myTitle: "Менин максаттарым",
    myDescription: "Сиздин максаттарыңыз, жетишкендиктериңиз жана деңгээлиңиз. Прогресс төлөнгөн заказдар боюнча эсептелет.",
    tabs: {
      goals: "Максаттар",
      leaderboard: "Рейтинг",
      achievements: "Жетишкендиктер",
    },
    add: "Максат коюу",
    edit: "Максатты өзгөртүү",
    scan: "Азыр текшерүү",
    scanResult: "Эсептелген максаттар: {{goals}}, жаңы жетишкендиктер: {{achievements}}",
    empty: "Азырынча максат жок",
    emptyHint: "Күндүк түшүмгө, орточо чекке же тамактын сатылышына максат коюңуз — команда прогрессти көрөт.",
    myEmpty: "Азырынча максат жок — аларды жетекчи коёт",
    showOff: "Өчүрүлгөндөрдү көрсөтүү",
    titlePlaceholder: "Мисалы: күнүнө 50 000 түшүм",
    pickEmployee: "Кызматкерди тандаңыз",
    allBranches: "Бардык филиалдар",
    anyCategory: "Каалаган категория",
    itemFilterHint: "Бош — бардык тамактар",
    rewardHint: "Мисалы: 1000 сом сыйлык",
    activeHint: "Өчүрүлгөн максат эсептелбейт жана кызматкерлерге көрүнбөйт",
    fields: {
      title: "Аталышы",
      scope: "Кимге",
      branch: "Филиал",
      employee: "Кызматкер",
      metric: "Эмнени эсептейбиз",
      target: "Максат",
      menuItem: "Тамак",
      category: "Категория",
      period: "Мезгил",
      dateFrom: "Баштап",
      dateTo: "Чейин",
      reward: "Сыйлык",
      points: "Аткаргандагы упайлар",
      active: "Максат күйгүзүлгөн",
    },
    targetHints: {
      revenue: "Мезгилдеги төлөнгөн заказдардын суммасы",
      orders: "Төлөнгөн заказдардын саны",
      avg_check: "Заказдын орточо суммасы — мезгилдин жыйынтыгы боюнча эсептелет",
      items: "Канча даана сатуу керек",
      new_customers: "Базага канча кардар кошуу керек",
    },
    metrics: {
      revenue: "Түшүм",
      orders: "Заказдар",
      avg_check: "Орточо чек",
      items: "Сатылган тамактар",
      new_customers: "Жаңы кардарлар",
      points: "Упайлар",
    },
    periods: {
      day: "Күн",
      week: "Апта",
      month: "Ай",
      custom: "Өз күндөрү",
    },
    periodNow: {
      day: "Бүгүн",
      week: "Ушул апта",
      month: "Ушул ай",
      custom: "{{from}} — {{to}}",
    },
    scopes: {
      company: "Бүт компания",
      branch: "Филиал",
      employee: "Кызматкер",
    },
    done: "Аткарылды",
    off: "Өчүрүлгөн",
    progressOf: "{{target}} ичинен {{value}}",
    rewardBadge: "Сыйлык: {{reward}}",
    pointsBadge: "+{{count}} упай",
    history: "Аткаруу тарыхы",
    historyEmpty: "Максат азырынча аткарыла элек",
    deleteConfirm: "«{{title}}» максатын өчүрөсүзбү?",
    deleteHint: "Аткаруу тарыхы жана кызматкерлердин упайлары сакталат.",
    rank: "Орун",
    employee: "Кызматкер",
    value: "Жыйынтык",
    points: "Упайлар",
    level: "{{level}}-деңгээл",
    pointsTotal: "{{count}} упай",
    leaderboardTitle: "Филиалдын кызматкерлеринин рейтинги",
    leaderboardEmpty: "Мезгилде азырынча сатуу жок",
    pointsAllTime: "Бардык убакыттагы упайлар: жетишкендиктер жана аткарылган жеке максаттар",
    myRank: "Рейтингдеги орун: {{count}} ичинен {{rank}}",
    nextLevel: "{{level}}-деңгээлге чейин: {{count}} упай",
    maxLevel: "Эң жогорку деңгээл",
    earned: "{{date}} алынган",
    achievementsEarned: "Жетишкендиктер: {{total}} ичинен {{count}}",
    teamTitle: "Команда",
    teamHint: "Кызматкерлердин деңгээлдери, упайлары жана алган жетишкендиктери",
    teamEmpty: "Азырынча эч ким жетишкендик ала элек",
    catalogTitle: "Бардык жетишкендиктер",
    catalogHint: "Кассадагы, сменадагы жана жеткирүүдөгү аракеттер үчүн өзү берилет — саатына бир жолу текшерилет",
    tiers: {
      bronze: "Коло",
      silver: "Күмүш",
      gold: "Алтын",
      platinum: "Платина",
    },
    ach: {
      first_order: { title: "Биринчи заказ", hint: "Биринчи төлөнгөн заказды өткөрүү" },
      orders_100: { title: "100 заказ", hint: "100 төлөнгөн заказ өткөрүү" },
      orders_1000: { title: "1000 заказ", hint: "1000 төлөнгөн заказ өткөрүү" },
      orders_5000: { title: "Залдын легендасы", hint: "5000 төлөнгөн заказ өткөрүү" },
      items_500: { title: "500 тамак", hint: "500 позиция сатуу" },
      items_5000: { title: "5000 тамак", hint: "5000 позиция сатуу" },
      big_table: { title: "Чоң стол", hint: "10 жана андан көп конокко заказ тейлөө" },
      first_shift: { title: "Биринчи смена", hint: "Биринчи сменаны иштөө" },
      shifts_50: { title: "50 смена", hint: "50 смена иштөө" },
      shifts_200: { title: "200 смена", hint: "200 смена иштөө" },
      clean_cash_10: { title: "Так касса", hint: "10 касса сменасын айырмасыз жабуу" },
      clean_cash_50: { title: "Кемчиликсиз касса", hint: "50 касса сменасын айырмасыз жабуу" },
      customers_10: { title: "10 жаңы кардар", hint: "Базага 10 кардар кошуу" },
      customers_100: { title: "100 жаңы кардар", hint: "Базага 100 кардар кошуу" },
      deliveries_10: { title: "10 жеткирүү", hint: "10 заказ жеткирүү" },
      deliveries_100: { title: "100 жеткирүү", hint: "100 заказ жеткирүү" },
      deliveries_500: { title: "500 жеткирүү", hint: "500 заказ жеткирүү" },
      goal_first: { title: "Биринчи максат", hint: "Биринчи жеке максатты аткаруу" },
      goals_10: { title: "10 максат", hint: "10 жеке максат аткаруу" },
      goals_50: { title: "50 максат", hint: "50 жеке максат аткаруу" },
      top_seller: { title: "Аптанын мыкты сатуучусу", hint: "Филиалда апта ичинде эң чоң түшүм" },
    },
  },
  mixedPay: {
    label: "Аралаш",
    cash: "Накталай",
    rest: "Калганы",
    invalid: "Эки бөлүк тең нөлдөн чоң болушу керек",
    partial: "Жарым-жартылай өттү: {{paid}}. Экинчи бөлүгү өткөн жок — текшерип, кошумча төлөңүз.",
  },
  menuPacks: {
    title: "Даяр менюлар",
    subtitle: "Форматыңызга ылайык меню: сүрөттөрү жана сүрөттөмөлөрү бар тамактар, сатып алуу баалары менен азыктар, жарым фабрикаттар жана калькуляциясы бар техкарталар",
    howTitle: "Бул кантип иштейт",
    how: "Форматыңызга ылайык топтомду тандап, тамактарды карап чыгыңыз. Бир жолу, эсеп боюнча сатылып алынат. Төлөгөндөн кийин топтомду менюга толугу менен же тандап жүктөңүз: категориялар, сүрөтү бар позициялар, азыктар, жарым фабрикаттар жана жарыяланган ТТК пайда болот. Бааларды жана граммовкаларды кийин өзгөртсө болот.",
    empty: "Даяр менюлар азырынча жок",
    footer: "Өздүк нарк Бишкектеги сатып алуу баалары менен эсептелген — жүктөгөндөн кийин сиздин азык бааларыңыз менен кайра эсептелет.",
    open: "Көрүү",
    owned: "Сатылып алынган",
    counts: "{{items}} тамак · {{semis}} жарым фабрикат · {{products}} азык",
    state: {
      available: "Сатып алса болот",
      pending: "Төлөм күтүүдө",
      owned: "Сатылып алынган",
    },
    stat: {
      items: "тамак",
      semis: "жарым фабрикат",
      products: "азык",
      photos: "сүрөт",
    },
    avgFoodCost: "Топтомдун орточо фудкосту — {{pct}}%",
    fc: "фудкост {{pct}}%",
    minutes: "{{n}} мүн",
    buy: "{{price}} сатып алуу",
    showInvoice: "Эсепти көрсөтүү",
    ownedNow: "Топтом ачылды — менюга жүктөсөңүз болот",
    askOwner: "Топтомду ээси же администратор сатып ала алат («Жазылуу: башкаруу» укугу).",
    noPrice: "Топтом жазылууңуздун валютасында азырынча сатылбайт — колдоо кызматына жазыңыз.",
    pendingHint: "{{n}} эсеби төлөм күтүүдө. Топтом төлөнгөндөн кийин дароо ачылат.",
    currencyHint: "Топтомдун баалары сом менен — {{currency}} валютасына которуу орнотулган эмес, жүктөгөндөн кийин бааларды текшериңиз.",
    imported: "Жүктөлдү: {{n}} жолу",
    importAgain: "Дагы жүктөө",
    price: "Баасы",
    cost: "Өздүк нарк",
    yield: "Чыгышы",
    calories: "Ккал",
    cookTime: "Даярдалат",
    variants: "Өлчөмдөр",
    modifiers: "Модификаторлор",
    allergens: "Аллергендер",
    semis: "Жарым фабрикаттар",
    semiOutput: "Чыгышы {{qty}} {{unit}} · {{cost}}",
    photoCredit: "Сүрөт: {{author}}, {{license}}",
    photosNote: "Сүрөттөр — Wikimedia Commons (эркин лицензиялар; автору жана лицензиясы тамактын карточкасында). Өздүк нарк — топтомдун сатып алуу баалары боюнча.",
    units: {
      g: "г",
      ml: "мл",
      pcs: "даана",
    },
    recipe: {
      title: "Техкарта",
      product: "Азык",
      gross: "Брутто",
      waste: "Калдык",
      loss: "Жоготуу",
      takeaway: "алып кетүүгө",
      instructions: "Даярдоо технологиясы",
      locked: "Граммовкалар, калдыктар жана технология сатып алгандан кийин ачылат.",
    },
    invoice: {
      title: "{{n}} эсеби",
      pack: "«{{name}}» даяр менюсу",
      bank: "Төлөм реквизиттери",
      after: "Топтом эсеп төлөнгөндөн кийин дароо ачылат. Бардык эсептер — «Жазылуу» бөлүмүндө.",
      print: "Эсепти басып чыгаруу",
      all: "Бардык эсептер",
    },
    import: {
      open: "Менюга жүктөө",
      title: "«{{name}}» жүктөө",
      submit: "Жүктөө ({{n}})",
      photos: "Тамактардын сүрөттөрү",
      recipes: "Техкарталар, азыктар жана жарым фабрикаттар",
      recipesHint: "Сатып алуу баалары менен азыктар, ЖФ жана жарыяланган ТТК — өздүк нарк дароо эсептелет",
      inactive: "Текшергенге чейин позицияларды жашыруу",
      inactiveHint: "Позициялар өчүрүлгөн абалда түзүлөт — бааларды текшергенден кийин «Меню» бөлүмүндө күйгүзүңүз.",
      repeatHint: "Менюда ушундай аталыштагы позициялар өткөрүлүп жиберилет. Ушундай аталыштагы азыктар, категориялар жана модификатор топтору кайра колдонулат.",
      done: "Жүктөлгөн позициялар: {{n}}",
      resultTitle: "Топтом жүктөлдү",
      toMenu: "Менюну ачуу",
      skipped: "Менюда бар болчу — өткөрүлдү: {{n}}",
      counts: {
        items: "Позициялар",
        categories: "Жаңы категориялар",
        products: "Азыктар",
        semis: "Жарым фабрикаттар",
        recipes: "Техкарталар",
        groups: "Модификатор топтору",
        photos: "Сүрөттөр",
      },
    },
  },
  waiterZones: {
    title: "Залдар боюнча официанттар",
    description: "Ким кайсы залды жана столдорду тейлейт: официант сменада жок болсо, столду дароо кийинкиси алат; автобөлүштүрүүнү күйгүзсө болот.",
    tabs: {
      now: "Азыр",
      zones: "Зоналар",
      settings: "Жөндөөлөр",
    },
    add: "Зона кошуу",
    edit: "Зонаны өзгөртүү",
    empty: "Азырынча зоналар жок",
    emptyHint: "Зона түзүңүз: зал же столдор жана официанттар тартиби менен. Бул столдорго жаңы буйрутмалар дароо керектүү официантка кетет.",
    namePlaceholder: "Негизги зал",
    fields: {
      name: "Аталышы",
      scope: "Эмнени тейлейт",
      hall: "Зал",
      tables: "Столдор",
      mode: "Кантип бөлүштүрүү",
      waiters: "Официанттар",
      active: "Зона күйгүзүлгөн",
    },
    scopes: {
      branch: "Бүт филиал",
      hall: "Зал",
      tables: "Өзүнчө столдор",
    },
    modes: {
      priority: "Артыкчылык боюнча",
      round_robin: "Кезек менен",
      least_loaded: "Ким бошураак",
    },
    modeHints: {
      priority: "Столду тизмедеги сменадагы биринчиси алат. Ал жок болсо — экинчиси ж.б.",
      round_robin: "Автобөлүштүрүү: столдор кезек менен — кийинки стол эң көптөн бери стол албаганга.",
      least_loaded: "Автобөлүштүрүү: стол азыр ачык столдору эң аз официантка.",
    },
    pickHall: "Залды тандаңыз",
    pickTables: "Столдорду тандаңыз",
    branchHint: "Запастагы зона: өз зонасы жок же зонасында азыр сменада эч ким жок столдор үчүн иштейт.",
    orderHint: "Тартип маанилүү: биринчиси — негизги официант, калгандары — кезек менен алмаштыруучу.",
    addWaiter: "Официант кошуу",
    moveUp: "Жогору",
    moveDown: "Төмөн",
    activeHint: "Өчүрүлгөн зона бөлүштүрүүгө катышпайт.",
    table: "{{number}}-стол",
    tablesList: "Столдор: {{list}}",
    off: "Өчүрүлгөн",
    inactive: "Жеткиликсиз",
    onShift: "Сменада",
    offShift: "Сменада эмес",
    deleteConfirm: "«{{name}}» зонасын өчүрөсүзбү?",
    deleteHint: "Зонанын официанттары тейлеп жаткан столдор аларда калат.",
    orderRule: "Столду биринчи туура келген зона алат: адегенде «Өзүнчө столдор», анан «Зал», анан «Бүт филиал». Зонада сменада эч ким жок болсо — кийинкиси алынат.",
    noZonesNow: "Зоналар жок — буйрутмалар аны ачкан адамда калат. «Зоналар» өтмөгүндө зона түзүңүз.",
    notTracking: "Сменалар эсепке алынбайт: зоналардын бардык официанттары орунда деп саналат.",
    staffTitle: "Официанттар",
    staffHint: "Ким сменада жана кимде канча ачык стол бар.",
    staffEmpty: "Зоналарда официант жок жана эч ким смена белгилеген жок",
    openTables: "Ачык столдор: {{count}}",
    servedBy: "{{name}} тейлейт · №{{number}} буйрутма",
    free: "Бош",
    nextIs: "Жаңы буйрутманы алат: {{name}} ({{zone}})",
    nextNobody: "Азыр эч ким жок — буйрутма аны ачкан адамда калат",
    settings: {
      requireShift: "Иш сменаларын эсепке алуу",
      requireShiftHint: "Столду келгенин белгилеген жана тыныгууда эмес адам гана алат.",
      reassignOnLeave: "Кеткендин столдорун өткөрүү",
      reassignOnLeaveHint: "Официант сменасын жапты — анын ачык столдору дароо зона боюнча кийинкисине өтөт.",
      assignStaffOrders: "Кассирдин буйрутмаларын бөлүштүрүү",
      assignStaffOrdersHint: "Кассир же администратор ачкан столдогу буйрутманы дароо зонанын официанты алат.",
    },
  },
};
